<!--
 * @LastEditors: Please set LastEditors
 * @desc: 重构公式 抽屉
 * @场景: 使用F1会打开重构公式 抽屉 / ESC可以退出
-->
<template>
  <div class="reconstruction">
    <div style="width: 40%;min-width: 500px;" :style="reconstrucStyleObj">
      <el-scrollbar style="height: 100%;">
        <div style="font-size: 24px;height: 50px;line-height: 50px;padding: 10px 20px 0;display: flex;">
          <div style="text-align: left;width: 80%;" class="nowrapText">
            <i v-if="this.caseVisited === false" class="el-icon-close cursor" @click="closeDrawer()"></i>
            <i v-else class="el-icon-back" @click="closeDrawer()"></i>
            <span style="margin-left: 10px;" v-if="this.caseVisited === false">重构因子</span>
            <span style="margin-left: 10px;" v-else>{{ this.caseItem.title }}</span>
          </div>
        </div>
        <div v-show="this.caseVisited === false" class="reconstruction-tab-top">
          <div class="factor-tabs">
          <el-tabs  v-model="activeName" type="card" style="text-align: left;">
            <el-tab-pane label="常用操作" name="fourth">
              <recommonOperate rightBlockType="is_json" :is_matrix="this.detectionSuccess.is_matrix"
                :expression_id="this.detectionSuccess.expression_id" :dropdownKeyList="this.dropdownKeyList"
                @handleClick="handleClick" @addFunction="addFunction"></recommonOperate>
            </el-tab-pane>
            <el-tab-pane label="常用模板" name="first">
              <div class="reconstruction-card">
                <el-card>
                  <div class="flex_wrap">
                    <div v-for="(x, formatIndex) in formatGroupList" :key="formatIndex">
                      <div class="reconstruction-box-out-1" v-if="x.title !== '自定义'">
                        <div class="reconstruction-triangle-1" style="width: 95px;height: 15px;">
                          <div class="reconstruction-triangle-out">
                            <el-tooltip placement="top" :open-delay="500" effect="light">
                              <div slot="content">
                                <span>{{ x.desc }}</span>
                              </div>
                              <span class="cursor">?</span>
                            </el-tooltip>
                          </div>
                        </div>
                        <img style="margin-top: -5px;" width="18" height="18"
                          :src="require('../../assets/formatFonts/' + x.title + '.svg')" />
                        <div>
                          <el-dropdown trigger="click" @command="addFactorItem">
                            <span class="el-dropdown-link">
                              {{ x.title }}<i style="color: #A0A0A0;" class="el-icon-caret-bottom"></i>
                            </span>
                            <el-dropdown-menu v-if="x.format.length > 0" slot="dropdown">
                              <el-dropdown-item v-for="(y, item) in x.format" :key="item" :command="y" class="flex">
                                <span style="flex: 10;">{{ y.title_chinese }}</span>
                                <span style="flex: 1;text-align: right;">
                                  <el-tooltip placement="right" :open-delay="1000" effect="light">
                                    <div slot="content">
                                      <span>
                                        “{{ y.format }}”<br />
                                        说明：{{ y.instruction }}
                                      </span>
                                    </div>
                                    <img width="18" height="18" src="../../assets/问号.svg" />
                                  </el-tooltip>
                                </span>
                              </el-dropdown-item>
                            </el-dropdown-menu>
                            <el-dropdown-menu v-else style="text-align: center;">
                              <span style="color: #555;">暂无内容</span>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-tab-pane>
            <el-tab-pane label="我的模板" name="third">
              <div class="reconstruction-card">
                <el-card>
                  <div class="flex_wrap">
                    <div v-for="(x, formatIndex) in formatGroupList" :key="formatIndex">
                      <div class="reconstruction-box-out-1" v-if="x.title === '自定义'">
                        <div class="reconstruction-triangle-1" style="width: 95px;height: 15px;">
                          <div class="reconstruction-triangle-out">
                            <el-tooltip placement="top" :open-delay="500" effect="light">
                              <div slot="content">
                                <span>{{ x.desc }}</span>
                              </div>
                              <span class="cursor">?</span>
                            </el-tooltip>
                          </div>
                        </div>
                        <img style="margin-top: -5px;" width="18" height="18"
                          :src="require('../../assets/formatFonts/' + x.title + '.svg')" />
                        <div>
                          <el-dropdown trigger="click" @command="addFactorItem">
                            <span class="el-dropdown-link">
                              自定义<i style="color: #A0A0A0;" class="el-icon-caret-bottom"></i>
                            </span>
                            <el-dropdown-menu v-if="x.format.length > 0" slot="dropdown"
                              :class="{ 'h_400': x.format.length > 10 }">
                              <el-scrollbar style="height: 100%;">
                                <el-dropdown-item v-for="(y, item) in x.format" :key="item" :command="y" class="flex">
                                  <span style="flex: 1;text-align: left;padding: 0 5px;">
                                    <el-tooltip placement="right" :open-delay="1000" effect="light">
                                      <div slot="content">
                                        <span>编辑</span>
                                      </div>
                                      <img @click.stop="eitdOne(y, 'formula')" src="../../assets/edit.svg" />
                                    </el-tooltip>
                                  </span>
                                  <span style="flex: 10;">{{ y.title_chinese }}</span>
                                  <span style="flex: 1;text-align: right;">
                                    <el-tooltip placement="right" :open-delay="1000" effect="light">
                                      <div slot="content">
                                        <span>
                                          “{{ y.format }}”<br />
                                          说明：{{ y.instruction }}
                                        </span>
                                      </div>
                                      <img width="18" height="18" src="../../assets/问号.svg" />
                                    </el-tooltip>
                                  </span>
                                </el-dropdown-item>
                              </el-scrollbar>
                            </el-dropdown-menu>
                            <el-dropdown-menu v-else style="text-align: center;">
                              <span style="color: #555;">暂无内容</span>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-tab-pane>
            <el-tab-pane label="自定义公式" name="second">
              <functionGroup :functionGroupList="this.functionGroupList" @addFactorItem="addFactorItem"></functionGroup>
            </el-tab-pane>
          </el-tabs>
          </div>
          <el-card v-show="this.msgData.length > 0" style="margin-top: 20px;text-align: left;">
            <div class="factor" style="height: 100px;">
              <el-scrollbar style="height: 100%;">
                <div class="flex_wrap">
                  <div style="margin-bottom: 5px;margin-right: 10px;width: 190px;" v-for="(x, msg) in msgData" :key="msg">
                    <div v-if="x.status === 'clarify' || x.status === 'match'">
                      <span>{{ x.title }}:</span>
                      <el-select :trigger-on-focus="false" v-model="x.selectValue" :popper-append-to-body="false"
                        placeholder="请选择" @change="fnEdit(x.title, msgData, x.status)">
                        <el-option class="flex_c" v-for="(item, index) in x.selectOptions" :key="index"
                          :label="item.value" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div v-if="x.status === 'ticker_error'">
                      <span>{{ x.title }}:</span>
                      <el-select :trigger-on-focus="false" v-model="x.selectValue" :popper-append-to-body="false"
                        placeholder="请选择" @change="fnEdit(x.title, msgData, x.status)">
                        <el-option class="flex_c" v-for="(item, index) in x.selectOptions" :key="index"
                          :label="item.value" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </el-card>
          <el-card style="margin: 20px 0;">
            <div style="display: flex;text-align: left;">
              <div style="width: 20px;">
                <i v-show="this.factorHistoryLength !== '' && this.factorHistoryLength !== this.factorCheckHistory.length - 1 && this.factorCheckHistory.length > -1"
                  @click="arrowClick(factorHistoryLength + 1, 'factorTextarea', 'left')"
                  style="font-size: 18px;font-weight: bold;margin-top: 100px;" class="el-icon-arrow-left cursor"></i>
              </div>
              <div style="height: 230px;width: 100%;">
                <div style="width: 100%;margin-bottom: 5px;padding: 0 5px;" class="space_between">
                  <div class="font_s_14">
                    <span class="cursor" @click="openCurve()"><i class="el-icon-s-tools"
                        style="margin-right: 5px;color: #A4001B;"></i>设置</span>
                    <span style="margin-right: 5px;color: #A4001B;" @click="clearHelpInput()" class="cursor">
                        <i class="el-icon-tickets"></i>函数帮助
                      </span>
                  </div>
                  <div>
                    <el-tooltip class="item" effect="dark" content="合并输入框公式" placement="top-start" :open-delay="300">
                      <el-button size="mini" :disabled="factorTextarea.length === 0" @click="mergeFactor"><span class="iconfont icon-lyhebing"></span> 合并</el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="拆分输入框公式" placement="top-start" :open-delay="300">
                       <el-button  size="mini" :disabled="factorTextarea.length === 0" @click="splitFactor"><span class="iconfont icon-lychaifen"></span> 拆分</el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="清空输入框公式" placement="top-start" :open-delay="300">
                      <i style="font-size: 16px;margin-left: 10px;" class="el-icon-delete cursor"
                        @click="clearFactor()"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div>
                  <myMirror id="factor" ref="cmEditor" style="width: 100%;" :factorTextarea.sync="factorTextarea"
                    :utilityAssetList="utilityAssetList" :functionGroupList="functionGroupList"
                    :tickerInfoList="tickerInfoList" :indexInfoList="indexInfoList" :keyWord="keyWord"
                    @getInput="getInput" @keyList="keyList"></myMirror>
                </div>
              </div>
              <div style="width: 20px;">
                <i v-show="this.factorHistoryLength !== '' && this.factorHistoryLength !== -1"
                  @click="arrowClick(factorHistoryLength - 1, 'factorTextarea', 'right')"
                  style="font-size: 18px;font-weight: bold;margin-top: 100px;" class="el-icon-arrow-right cursor"></i>
              </div>
            </div>
            <div style="text-align: left;margin-top: 10px;margin-left: 20px;">
              <el-button :disabled="customDisabled" @click="customTesting(null)" class="determine">检测</el-button>
            </div>
            <!-- 最近记录 / 制表记录 -->
            <HistoryLog
              :recordActive.sync="recordActive"
              :recordLastItem="recordLastItem"
              @save="saveRecordVisited = true"
              @multiDel="multiDeleteTree"
              @addFactorItem="addFactorItem"
              @addTextarea="addTextarea"
              @goDailyBack="goDailyBack"
              @recordFactorList="getRecordFactorList"
            >
            <div style="font-size: 14px;color: #333;text-align: left;">
              <div
                style="border-top: 1px solid #ddd;border-bottom: 1px solid #ddd;background-color: #f5f7fa;padding: 2px 0 2px 15px;">
                <el-row>
                  <el-col :span="15">
                    名称/公式
                  </el-col>
                  <el-col :span="4">
                    状态
                  </el-col>
                  <el-col :span="5">
                    操作
                  </el-col>
                </el-row>
              </div>
              <div class="infinite-scroll" >
                <div infinite-scroll-delay="200" infinite-scroll-immediate="false" v-infinite-scroll="load"
                  infinite-scroll-distance="20">
                  <div
                    class="scroll-item"
                    :class="[{'scroll-item--active':y.status === 'complete' && detectionSuccess.expression_id && detectionSuccess.expression_id === y._id}]"
                    v-for="(y, allFactor) in recordFactorList"
                    :key="allFactor"
                  >
                    <div @click="getRecordLast(y)">
                      <div :class="{ 'recordClass': recordLastItem._id && y._id && recordLastItem._id === y._id }"
                        style="padding: 2px 0 2px 15px;border-bottom: 1px solid #ddd;">
                        <el-row>
                          <el-col :span="15" class="nowrapText" style="padding-right: 10px;">
                            <el-tooltip class="item" effect="dark" :content="y.factor_str" placement="top-start"
                              :open-delay="1000">
                              <span v-if="y.is_commit && y.indexinfo_id">
                                <span>{{ y.index_info && y.index_info.index_title ? y.index_info.index_title : '--' }}</span>
                              </span>
                              <span v-else-if="y.is_commit && y.matrix_info && y.matrix_info.matrix_title">
                                <span>{{ y.matrix_info.matrix_title }}</span>
                              </span>
                              <span v-else style="color: #999;">{{ y.factor_str }}</span>
                            </el-tooltip>
                          </el-col>
                          <el-col :span="4">
                            <span v-if="y.status === 'ok'">计算中</span>
                            <span v-else-if="y.status === 'error'" style="cursor: pointer; ">计算失败</span>
                            <span
                              v-else-if="y.status === 'complete' && detectionSuccess.expression_id && detectionSuccess.expression_id === y._id"
                              @click.stop="openComplete(y, allFactor)" style="text-decoration:underline;"
                              class="cursor c_A30013 scroll-item-complete">计算完成</span>
                            <span v-else-if="y.status === 'complete'" @click.stop="openComplete(y, allFactor)"
                              style="color: #409EFF;" class="cursor scroll-item-complete">计算完成</span>
                          </el-col>
                          <!-- 操作 -->
                          <el-col :span="5" style="text-align: left;padding-right: 10px;">
                            <!-- 比较 -->
                            <span v-if="y.status === 'complete' && !y.is_matrix">
                              <!-- <el-tooltip v-if="!y.addLine" effect="dark" content="和'已选中数据'进行对比" placement="top-start"> -->
                                <el-link v-if="!y.addLine"  @click.stop="addLine(allFactor, y)"  :underline="false"><span class="iconfont icon-lyVS"></span>&nbsp;</el-link>
                              <!-- </el-tooltip> -->
                              <el-link v-else-if="y.addLine" type="primary"
                                @click.stop="delectedLine(allFactor, y)"  :underline="false"><span class="iconfont icon-lyVS"></span></el-link>
                              <!-- <el-tooltip v-if="y.addLine && !y.yAxisIndex" effect="dark" content="当前Y轴在左侧" placement="top-start"> -->
                                <div v-if="y.addLine && !y.yAxisIndex" class="scroll-item-yAxis" @click.stop="updataYAxisIndex(allFactor, y, 'left')">左</div>
                              <!-- </el-tooltip> -->
                              <!-- <el-tooltip v-else-if="y.addLine && y.yAxisIndex" effect="dark" content="当前Y轴在右侧" placement="top-start"> -->
                                <div v-else-if="y.addLine && y.yAxisIndex" class="scroll-item-yAxis" @click.stop="updataYAxisIndex(allFactor, y, 'right')">右</div>
                              <!-- </el-tooltip> -->
                            </span>
                            <!-- 刷新 -->
                            <el-badge style="z-index: 999;" v-if="y.is_commit && y.index_info && !y.index_info.loading"
                              :is-dot="y.index_info && y.index_info.need_refresh" class="item">
                              <el-link v-if="y.is_commit && y.indexinfo_id" @click="refreshFactor(y, allFactor)" icon="el-icon-refresh" style="font-size:16px; padding-bottom: 2px;"  :underline="false"></el-link>
                            </el-badge>
                            <i v-else-if="y.loading" class="el-icon-loading"></i>
                            <el-tooltip content="因子构成"  placement="top-start">
                              <el-popover
                                v-if="y.is_commit && y.index_info && y.index_info.factor_structure"
                                placement="bottom"
                                width="500"
                                trigger="click"
                              >
                                <div
                                  v-for="(z, index) in y.index_info.factor_structure"
                                  :key="index"
                                >
                                  <span>{{ z.t }}={{ z.f }}</span>
                                </div>
                                <el-link type="primary" icon="el-icon-document-copy" @click.stop="onCopyCommit(y,$event)">一键复制</el-link>
                                <el-link slot="reference"  :underline="false">
                                  <span class="iconfont icon-lyi_iot"></span>
                                </el-link>
                              </el-popover>
                            </el-tooltip>
                            <el-link v-if="!y.is_commit && y.status !== 'ok'"
                              @click.stop="deleteOneTree(y, allFactor)" icon="el-icon-delete"   :underline="false" ></el-link>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <div style="text-align: center;">
                    <span v-if="this.recordFactorList.length < this.recordTotNum"><i
                        class="el-icon-loading"></i>加载中</span>
                    <span v-else>没有更多了</span>
                  </div>
                </div>
              </div>
            </div>
            </HistoryLog>
          </el-card>
        </div>
        <div v-show="this.caseVisited === true" style="padding: 10px;text-align: left;">
          <el-card>
            <div :style="cardStyObj">
              <el-scrollbar style="height: 100%;">
                <div>
                  <div style="color: #76323F;font-style: italic;padding: 0 0 10px;font-weight: bold;"
                    v-html="this.caseItem.desc"></div>
                  <div class="font_s_14">{{ this.caseItem.instruction }}</div>
                  <div style="margin: 10px 0;text-align: center;" v-for="(imgSrc, caseImg) in this.caseItem.img"
                    :key="caseImg">
                    <el-image :src="'http://dunhe.guanzhao12.com:3000' + imgSrc"
                      :preview-src-list="['http://dunhe.guanzhao12.com:3000' + imgSrc]">
                    </el-image>
                  </div>
                </div>
                <div style="width: 100%;text-align: right;font-size: 14px;margin: 15px 0;">
                  <span class="cursor" @click="openCurve()"><i class="el-icon-s-tools"
                      style="margin-right: 10px;color: #A4001B;"></i>设置</span>
                </div>
                <div>
                  <div v-for="(item, caseDetail) in caseItem.detail" :key="caseDetail" style="margin-bottom: 10px;">
                    <div class="flex" v-show="item.factor_html">
                      <div style="width: 25px;">
                        <svg @click="openCustom(item.factor_str)" t="1647250031234" class="icon cursor"
                          viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2176" width="25"
                          height="25">
                          <path
                            d="M512 96C282.624 96 96 282.624 96 512s186.624 416 416 416 416-186.624 416-416S741.376 96 512 96z m0 768C317.92 864 160 706.08 160 512S317.92 160 512 160s352 157.92 352 352-157.92 352-352 352z"
                            p-id="2177" fill="#515151"></path>
                          <path
                            d="M466.816 324.96a32 32 0 0 0-50.816 25.888v339.776a32 32 0 0 0 50.816 25.856l233.6-169.888a32 32 0 0 0 0-51.776l-233.6-169.856z"
                            p-id="2178" fill="#515151"></path>
                        </svg>
                      </div>
                      <div class="factorCopy">
                        <span v-html="item.factor_html"></span>
                        <i @click="handleCopy($event, 'factor_str', item.factor_str)"
                          class="el-icon-copy-document icopy"></i>
                      </div>
                    </div>
                    <div style="margin-left: 30px;font-size: 14px;color: #7F7F7F;">
                      <div v-html="item.desc"></div>
                      <div>
                        <div style="margin: 10px 0;text-align: center;" v-for="(imgSrc1, detailImg) in item.img"
                          :key="detailImg">
                          <el-image :src="'http://dunhe.guanzhao12.com:3000' + imgSrc1"
                            :preview-src-list="['http://dunhe.guanzhao12.com:3000' + imgSrc1]">
                          </el-image>
                        </div>
                      </div>
                      <div style="margin-top: 10px;" v-for="(item2, question) in item.questions" :key="question">
                        <div>{{ item2.question }}</div>
                        <span>{{ item2.answer }}</span>
                        <div style="margin: 10px 0;text-align: center;" v-for="(imgSrc2, detailImg1) in item2.img"
                          :key="detailImg1">
                          <el-image :src="'http://dunhe.guanzhao12.com:3000' + imgSrc2"
                            :preview-src-list="['http://dunhe.guanzhao12.com:3000' + imgSrc2]">
                          </el-image>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </el-card>
        </div>
      </el-scrollbar>
    </div>
    <div v-if="rightBlockType !== 'is_json'" style="width: 60%;" :style="reconstrucStyleObj" class="reconstruction-tab-top" id="reconstructionRight">
      <el-scrollbar style="height: 100%;">
        <div style="padding: 10px 0 10px;height: 75px;text-align: left;">
          <el-scrollbar style="height: 100%;">
            <el-row v-if="this.detectionSuccess._id" style="padding: 0 30px 0;">
              <el-col :span="22">
                <div v-if="!loading" >
                  <span style="font-size: 16px;"><i style="color: #13ce66;" class="el-icon-success"></i>公式解析成功</span>
                  <div v-if="this.detectionSuccess && this.detectionSuccess.search === true"
                    style="display: flex;align-items: flex-start;font-size: 14px;padding: 5px 0;">
                    <span>
                      <el-tooltip class="item" effect="dark" content="复制完整推荐列表，请到execl粘贴" placement="top-start"
                        :open-delay="1000">
                        <span>
                          <i style="font-size: 18px;" @click="handleCopy($event, 'search_list', null, 'copyRef2')"
                            class="el-icon-document-copy cursor"></i>
                          <span class="copyClass" ref="copyRef2" @click="copySearch">&nbsp;&nbsp;</span>
                        </span>
                      </el-tooltip>
                      <span class="reconstruction-dialog-text" style="color: #00AC71 ;"
                        v-if="this.detectionSuccess && this.detectionSuccess.modified_factor_str">{{ this.detectionSuccess.modified_factor_str }}</span><br />
                      <span class="reconstruction-dialog-text"
                        style="color: #3668A5;">原表达式：{{ this.detectionSuccess.factor_str }}</span>
                    </span>
                    <el-button type="text" style="font-size: 13px;color: #AAA;padding: 3px 10px 3px 10px;"
                      @click="parseFormat()">保存模板</el-button>
                  </div>
                  <!-- <span v-if="this.detectionSuccess.useFactorHelper" style="font-size: 12px;">注：使用公式助手</span> -->
                  <div
                    v-else-if="this.sectorData.is_multiple_search && this.sectorData.is_multiple_search === true && this.refactorHistoryLength === 0"
                    style="display: flex;align-items: flex-start;font-size: 14px;padding: 5px 0;">
                    <span>
                      <el-tooltip class="item" effect="dark" content="复制完整推荐列表，请到execl粘贴" placement="top-start"
                        :open-delay="1000">
                        <span>
                          <i style="font-size: 16px;" @click="handleCopy($event, 'search_list', null, 'copyRef1')"
                            class="el-icon-document-copy cursor"></i>
                          <span class="copyClass" ref="copyRef1" @click="copySearch()">&nbsp;&nbsp;</span>
                        </span>
                      </el-tooltip>
                      <span class="reconstruction-dialog-text" style="color: #00AC71 ;"
                        v-if="this.sectorData && this.sectorData.modified_factor_str">最优结果：{{ this.sectorData.modified_factor_str }}</span><br />
                      <span class="reconstruction-dialog-text"
                        style="color: #3668A5;">原表达式：{{ this.sectorData.factor_str }}</span><br />
                      <span class="reconstruction-dialog-text" style="color: #555555;"
                        v-if="this.checkFactorData.is_multiple_search !== true">当前表达式：{{ this.detectionSuccess.factor_str }}</span>
                    </span>
                    <el-button type="text" style="font-size: 13px;color: #AAA;padding: 3px 10px 3px 10px;"
                      @click="parseFormat()">保存模板</el-button>
                  </div>
                  <div v-else-if="this.detectionSuccess && this.detectionSuccess.search === false"
                    style="display: flex;align-items: flex-start;font-size: 14px;">
                    <div v-if="this.allFactorStr === false" class="reconstruction-dialog-text nowrapText cursor"
                      style="color: #3668A5;padding-right: 10px;" ref="factorStr">
                      <span ref="factorStrCopy" @click="allFactorStr = true">{{ this.detectionSuccess.factor_str }}</span>
                    </div>
                    <div v-if="this.allFactorStr === true" class="reconstruction-dialog-text cursor"
                      style="color: #3668A5;padding-right: 10px;">
                      <span @click="allFactorStr = false">{{ this.detectionSuccess.factor_str }}</span>
                    </div>
                    <el-button type="text" style="font-size: 13px;color: #AAA;padding: 3px 10px 3px 0;"
                      @click="parseFormat()">保存模板</el-button>
                  </div>
                </div>
                <div v-else>
                  <div style="height: 16px;">&nbsp;</div>
                  <div style="width: 100px; height: 14px; background: #eee;"></div>
                  <div style="margin: 5px 0; width: 60%; height: 14px; background: #eee;"></div>
                  <div style="width: 100px; height: 14px; background: #eee;"></div>
                </div>
              </el-col>
              <el-col :span="2">
                <div style="margin-right: 10px;height: 40px;" v-if="this.caseVisited === false">
                  <el-button v-if="!this.detectionSuccess.is_commit" slot="append"
                  @click="saveFactorVisited = true"
                    class="determine">提交</el-button>
                  <el-button v-else-if="this.detectionSuccess.is_commit" disabled slot="append"
                    class="revert">已提交</el-button>
                </div>
              </el-col>
            </el-row>
          </el-scrollbar>
        </div>
        <div class="flex">
          <div style="width: 30px;">
            <i v-if="!this.detectionSuccess.use_utility && this.refactorHistoryLength !== '' && this.refactorHistoryLength !== this.allFactorList.length - 1"
              @click="arrowClick(refactorHistoryLength + 1, 'lineDetails')"
              style="font-size: 40px;font-weight: bold;margin-top: 260px;" class="el-icon-arrow-left cursor"></i>
            <i v-if="this.detectionSuccess.use_utility && this.refactorHistoryLength !== '' && this.refactorHistoryLength !== this.allFactorList.length - 1"
              @click="arrowClick(refactorHistoryLength + 1, 'lineDetails')"
              style="font-size: 40px;font-weight: bold;margin-top: 500px;" class="el-icon-arrow-left cursor"></i>
          </div>
          <div style="width: 100%;" class="reconstruction-card">
            <div class="flex">
              <div @click="switchOneClick('first')" class="reconstruction_title cursor"
                :class="{ 'reconstruction_title_updata': this.activeName1 === 'first' }">
                <span v-if="this.detailData.graph_title">{{ this.detailData.graph_title }}</span>
                <span v-else>因子信息</span>
              </div>
              <div @click="switchOneClick('second')" class="reconstruction_title cursor"
                :class="{ 'reconstruction_title_updata': this.activeName1 === 'second' }">数据详情</div>
            </div>
            <el-card style="text-align: center;" v-loading="loading2" element-loading-text="计算中"
              element-loading-spinner="el-icon-loading" element-loading-background="rgba(256, 256, 256, 0.8)">
              <div class="align_left" v-if="!this.detectionSuccess.is_matrix">
                <el-checkbox v-model="hide_zero" @change="hideChange('hide_zero')">隐藏0值行/列</el-checkbox>
                <el-checkbox v-model="hide_nan" @change="hideChange('hide_nan')">隐藏空缺值行/列</el-checkbox>
                <!-- <el-checkbox v-if="this.activeName1 === 'first'" v-model="axisVisited">显示坐标轴名称</el-checkbox> -->
              </div>
              <div v-show="this.activeName1 === 'first'" style="min-height: 460px;">
                <div v-if="this.allFlag === true">
                  <div class="font_s_14 align_right" v-if="!this.detectionSuccess.is_matrix">
                    <i v-if="this.detailData._id" @click="onOneDimensionalGraph"
                      class="el-icon-pie-chart cursor">一维分割图</i>
                    <i v-if="this.detailData._id" @click="handleCopy($event, 'detailData')"
                      class="el-icon-document-copy cursor">拷贝数据</i>
                    <span class="copyClass" ref="copyRef" @click="copySearch">&nbsp;&nbsp;</span>
                  </div>
                  <div v-if="this.detectionVisited">
                    <div v-if="!this.detectionSuccess.is_matrix">
                      <factorLine ref="factorLine" v-loading="loading" element-loading-text="计算中" element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(256, 256, 256, 0.8)" :id="'dialogItem'"
                        :detailData="this.detailData" :addTemporary="this.addTemporary"
                        :delectedTemporary="this.delectedTemporary" :yAxisData="this.yAxisData"
                        :lineDetection="this.lineDetection" :auto_scatter_plot="this.auto_scatter_plot"
                        :hide_zero="this.hide_zero" :hide_nan="this.hide_nan" :axisVisited="this.axisVisited"
                        @drawDate="drawDate" :activeName="this.activeName1">
                      </factorLine>
                      <div v-if="this.detailData.description && this.detectionVisited && this.allFlag === true"
                        class="details-center">
                        <span class="reconstruction-dialog-text"
                          style="color: #4F6581;">公式生成数据：{{ this.detailData.description }}</span>
                      </div>
                    </div>
                    <div v-else>
                      <tableLine :activeName="this.activeName1" :matrixData="matrixData"></tableLine>
                    </div>
                  </div>
                  <div v-else-if="!this.detectionVisited"></div>
                </div>
                <div v-else class="badTishi">计算失败</div>
              </div>
              <div v-show="this.activeName1 === 'second'" style="min-height: 450px;">
                <div v-show="!this.detectionSuccess.is_matrix">
                  <vxeTableOne v-if="this.detectionSuccess.dimension === 'one-row'" :detailData="this.detailData"
                    :hideZero="this.hide_zero" :hideNan="this.hide_nan" :date="dateInput"></vxeTableOne>
                  <vxeTable v-show="this.detectionSuccess.dimension === 'two'"
                    :detailDimension="this.detectionSuccess.dimension" :date="dateInput" :param="this.param"
                    :view="this.viewW" :width="this.widthLenght"></vxeTable>
                </div>
                <vxeTablefunc v-show="this.detectionSuccess.is_matrix" :matrixData="matrixData"></vxeTablefunc>
              </div>
            </el-card>
            <div v-if="!this.detectionSuccess.is_matrix">
              <div
                v-show="this.detectionVisited && detectionSuccess.factor_str && detectionSuccess.factor_str.indexOf('取出') < 0 && detectionSuccess.factor_str.indexOf('pick') < 0"
                class="flex">
                <span style="padding: 10px 0 5px;display: flex;" @click="openUtilityLine()">
                  <span style="font-size: 14px;" class="cursorRed">回测预览</span>
                  <svg v-show="!this.use_utility" t="1665277318264" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="2330" width="18" height="18">
                    <path
                      d="M493.504 558.144a31.904 31.904 0 0 0 45.28 0l308.352-308.352a31.968 31.968 0 1 0-45.248-45.248l-285.728 285.728-294.176-294.144a31.968 31.968 0 1 0-45.248 45.248l316.768 316.768z"
                      p-id="2331" fill="#A4001B"></path>
                    <path
                      d="M801.888 460.576l-285.728 285.728-294.144-294.144a31.968 31.968 0 1 0-45.248 45.248l316.768 316.768a31.904 31.904 0 0 0 45.28 0l308.352-308.352a32 32 0 1 0-45.28-45.248z"
                      p-id="2332" fill="#A4001B"></path>
                  </svg>
                  <svg v-show="this.use_utility" t="1665297802583" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="2331" width="18" height="18">
                    <path
                      d="M199.36 572.768a31.904 31.904 0 0 0 22.624-9.376l294.144-294.144 285.728 285.728a31.968 31.968 0 1 0 45.248-45.248l-308.352-308.352a32 32 0 0 0-45.28 0l-316.768 316.768a31.968 31.968 0 0 0 22.656 54.624z"
                      p-id="2332" fill="#A4001B"></path>
                    <path
                      d="M538.784 457.376a32 32 0 0 0-45.28 0l-316.768 316.768a31.968 31.968 0 1 0 45.248 45.248l294.144-294.144 285.728 285.728a31.968 31.968 0 1 0 45.248-45.248l-308.32-308.352z"
                      p-id="2333" fill="#A4001B"></path>
                  </svg>
                </span>
              </div>
              <div class="factor-tabs" >
              <el-tabs v-model="activeName2" type="card" style="margin-top: 20px;"
                v-if="detectionSuccess.use_utility === true && detectionSuccess.factor_str && detectionSuccess.factor_str.indexOf('取出') < 0 && detectionSuccess.factor_str.indexOf('pick') < 0">
                <el-tab-pane label="自定义回测" name="first">
                  <el-card>
                    <div class="flex" style="justify-content: center;">
                      <div class="align_items">
                        <span>资产范围</span>
                        <el-select :trigger-on-focus="false" v-model="tagValue" filterable placeholder="请选择"
                          @change="setUtilitySetting('tagValue')">
                          <el-option class="flex_c" v-for="item in utilityAssetList" :key="item._id" :label="item.tagName"
                            :value="item.tag">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="align_items" style="margin-left: 20px">
                        <span>公式</span>
                        <el-select :trigger-on-focus="false" v-model="utilityValue" placeholder="请选择"
                          @change="setUtilitySetting('utilityValue')">
                          <el-option class="flex_c" v-for="(utility, utilityKey) in utilityList" :key="utilityKey"
                            :label="utility.title" :value="utility._id">
                          </el-option>
                        </el-select>
                        <el-button @click="openUtility()" class="analyzing">管理</el-button>
                      </div>
                    </div>
                    <div v-if="this.fileStatusUtility === true && this.allFlag === true">
                      <div v-if="this.utilityCurveData && this.utilityCurveData.utility_stats" class="flex"
                        style="justify-content: space-around;margin-top: 10px;">
                        <span>均值(年化)：{{ this.utilityCurveData.utility_stats.annual_ret }}%</span>
                        <span>Sharpe值：{{ this.utilityCurveData.utility_stats.sharpe }}</span>
                        <span>均值(年化)/最大回撤：{{ this.utilityCurveData.utility_stats.sortino }}</span>
                      </div>
                      <el-checkbox style="margin-top: 10px;" v-model="hide_repeat"
                        @change="hideChange('hide_repeat')">去除重复值</el-checkbox>
                      <lineDetails v-loading="loading1" element-loading-text="计算中"
                        element-loading-spinner="el-icon-loading" element-loading-background="rgba(256, 256, 256, 0.8)"
                        v-if="this.detectionVisited && (!this.utilityCurveData.utility_msg || this.utilityCurveData.utility_msg === '')"
                        :id="'use_utility'" :activeName="this.activeName2" :theLabel="this.utilityDtes"
                        :theData="this.utilityCurve" :provider="this.detectionSuccess.provider">
                      </lineDetails>
                      <div v-else-if="this.utilityCurveData.utility_msg" class="badTishi">
                        {{ this.utilityCurveData.utility_msg }}</div>
                      <div v-else style="height: 300px;"></div>
                      <div v-if="this.utilityCurveData.status === 'bad'"
                        style="height: 380px;width: 100%;text-align: center;line-height: 380px;">
                        <span>{{ this.utilityCurveData.statusMsg }}</span>
                      </div>
                      <div
                        v-if="this.utilityCurveData.templateExpressionTree && this.utilityCurveData.utility_description"
                        class="details-center">
                        <span class="reconstruction-dialog-text"
                          style="color: #4F6581;">该图表显示：{{ this.utilityCurveData.utility_description }}</span>
                      </div>
                      <div
                        v-if="this.utilityTtestValue && this.utilityTtestValue.ttest_pvalue && this.utilityTtestValue.ttest_pvalue < 0.1"
                        style="display: flex;font-size: 14px;background-color: #f0f9eb;padding: 10px;margin-top: 20px;">
                        <div style="color: #13ce66;font-size: 24px;margin: auto 0;padding-right: 10px;">
                          <i class="el-icon-success"></i>
                        </div>
                        <span>检验结果：因子有效
                          (P值={{ this.utilityTtestValue.ttest_pvalue }})<br />使用配对t检验当前自定义回测与对照组（基准）的差值是否显著。p值小于0.1拒绝零假设，认为结果有效。</span>
                      </div>
                      <div
                        v-else-if="this.utilityTtestValue && this.utilityTtestValue.ttest_pvalue && this.utilityTtestValue.ttest_pvalue > 0.1"
                        style="display: flex;font-size: 14px;background-color: #f4f4f5;padding: 10px;margin-top: 20px;">
                        <div style="color: #909399;font-size: 24px;margin: auto 0;padding-right: 10px;">
                          <i class="el-icon-info"></i>
                        </div>
                        <span>检验结果：因子有效性检验不显著（P值={{ this.utilityTtestValue.ttest_pvalue }})</span>
                      </div>
                    </div>
                    <div v-else class="badTishi">计算失败</div>
                  </el-card>
                </el-tab-pane>
              </el-tabs>
              </div>
            </div>
          </div>
          <div style="width: 30px;">
            <i v-if="!this.detectionSuccess.use_utility && this.refactorHistoryLength !== '' && this.refactorHistoryLength !== 0"
              @click="arrowClick(refactorHistoryLength - 1, 'lineDetails')"
              style="font-size: 40px;font-weight: bold;margin-top: 260px;" class="el-icon-arrow-right cursor"></i>
            <i v-if="this.detectionSuccess.use_utility && this.refactorHistoryLength !== '' && this.refactorHistoryLength !== 0"
              @click="arrowClick(refactorHistoryLength - 1, 'lineDetails')"
              style="font-size: 40px;font-weight: bold;margin-top: 500px;" class="el-icon-arrow-right cursor"></i>
          </div>
        </div>
        <div v-if="this.caseVisited === true"
          style="text-align: right;line-height: 40px;margin-top: 10px;padding: 0 30px 30px 30px;">
          <el-button size="medium" @click="closeDrawer()" class="revert">返 回</el-button>
          <el-button v-if="this.detectionVisited" size="medium" @click="casetaoyong()" class="determine">套 用</el-button>
        </div>
      </el-scrollbar>
    </div>
    <div>
      <el-dialog class="errorClass" :visible.sync="dialogVisible" append-to-body width="30%" top="30vh" center>
        <div slot="title">
          <span style="font-size: 16px;color: #fff;"><i class="el-icon-warning-outline">提示</i></span>
        </div>
        <div v-if="this.curveVisible === false">
          <div v-for="(x, msgIndex) in msgData" :key="msgIndex" style="text-align: left;">
            <span v-if="x.status === 'match'">{{ x.match_title }}</span>
            <span v-else>{{ x.title }}</span>
            <span v-if="x.status === 'match'"><i style="color: #13ce66;" class="el-icon-success"></i></span>
            <span v-else-if="x.status === 'clarifyMatch'"><i style="color: #13ce66;" class="el-icon-success"></i></span>
            <span v-else-if="x.status === 'nofound'" style="color: #ff4949;">:没有匹配项，请检查数据名称是否有误，或在数据库上传该数据</span>
            <span v-else-if="x.status === 'clarify'" style="color: #ff4949;">:数据存在多个可能，请返回选择</span>
            <span v-else-if="x.status === 'ticker_error'" style="color: #ff4949;">:资产存在多个可能，请返回选择</span>
          </div>
        </div>
        <div v-else>
          <div v-for="(x, useMsgIndex) in useMsgData" :key="useMsgIndex" style="text-align: left;">
            <span v-if="x.status === 'match'">{{ x.match_title }}</span>
            <span v-else>{{ x.title }}</span>
            <span v-if="x.status === 'match'"><i style="color: #13ce66;" class="el-icon-success"></i></span>
            <span v-else-if="x.status === 'nofound'" style="color: #ff4949;">:没有匹配项，请检查数据名称是否有误，或在数据库上传该数据</span>
            <span v-else-if="x.status === 'clarify'" style="color: #ff4949;">:数据存在多个可能，请返回选择</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogVisible = false" class="callOff">返 回</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="curveVisible" append-to-body :width="widthStyle" @closed="handleClose"
        class="reconstruction-dialog-tab">
        <div slot="title">
          <div class="flex">
            <div class="boxBackground"></div>
            <span class="boxSpan">设置</span>
          </div>
        </div>
        <div class="reconstruction-strip"></div>
        <div style="margin-left: 30px;" v-if="!utilityManage">
          <div class="reconstruction-border">
            <span style="font-size: 14px;font-weight:bold;">关注资产：ret问号表达式的资产范围</span>
            <br />
            <el-radio-group style="margin: 10px 0 0 20px;" v-model="assetRadio">
              <el-radio label="customLable">
                我的资产
                <el-select :trigger-on-focus="false" v-show="assetRadio === 'customLable'" v-model="valuWe" clearable
                  placeholder="全部">
                  <el-option class="flex_c" v-for="(x, myTag) in myLableName" :key="myTag" :value="x.tagName">
                  </el-option>
                </el-select>
              </el-radio><br />
              <el-radio label="blockTag">
                所有资产
                <el-select :trigger-on-focus="false" v-show="assetRadio === 'blockTag'" v-model="valueBan" clearable
                  placeholder="全部">
                  <el-option class="flex_c" v-for="(x, ban_kuai) in banKuaiData" :key="ban_kuai" :value="x.tagName">
                  </el-option>
                </el-select>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="reconstruction-border flex">
            <div style="width: 60%;margin: auto 0;">
              <el-switch v-model="use_utility" style="width: 30px;height: 15px;" active-color="#A4001B"></el-switch>
              <span>回测预览：快速预览数据的作用</span>
            </div>
            <div v-if="use_utility" style="width: 40%;text-align: right;margin-right: 20px;">
              <el-button size="mini" style="background-color: #FFF;color: #A4001B;border-color: #DCDFE6;"
                @click="openUtility()">管理</el-button>
            </div>
          </div>
          <el-divider></el-divider>
          <div>自动画散点图:
            <el-switch v-model="auto_scatter_plot"  active-color="#A4001B"></el-switch>
          </div>
          <el-divider></el-divider>
          sector和ret问号表达式排序时间段:
          <el-date-picker style="width: 375px;margin-top: 10px;" unlink-panels class="details-picker" v-model="valueDate"
              type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="dataChange">
            </el-date-picker>
          <el-divider></el-divider>
          计算开始日期：
          <el-date-picker
            v-model="calculate_begin_date"
            type="date"
            placeholder="选择计算开始日期" value-format="yyyy-MM-dd" style="width:200px;">
          </el-date-picker>
          <br>
          <br>
          分钟频起始日：
          <el-date-picker
            v-model="live_date"
            type="date"
            placeholder="选择分钟频起始日" value-format="yyyy-MM-dd" style="width:200px;">
          </el-date-picker>
        </div>
        <div v-else style="height: 450px;" ref="table">
          <el-scrollbar style="height: 100%;">
            <div style="text-align: right;font-size: 16px;padding: 0 20px;">
              <el-tooltip placement="top" content="新建" :open-delay="1000">
                <i class="el-icon-folder-add cursor" @click="openAddUtility()"></i>
              </el-tooltip>
            </div>
            <div style="width: 100%;">
              <table border="1px" v-dragform>
                <thead>
                  <tr>
                    <th>序号</th>
                    <th>回测预览公式名</th>
                    <th>公式构成</th>
                    <th>备注</th>
                    <th style="width: 50px;">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in utilityList" :key="key">
                    <td style="width: 30px;">{{ key + 1 }}</td>
                    <td style="width: 100px;">{{ item.title }}</td>
                    <td>{{ item.expression_str }}</td>
                    <td>{{ item.desc }}</td>
                    <td style="width: 20px;text-decoration: underline;" class="cursor" v-if="!item.is_default">
                      <span @click="deleteOne('utility', item)">删除</span>
                      <span @click="eitdOne(item, 'utility')">编辑</span>
                    </td>
                    <td style="width: 30px;" v-else> </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-scrollbar>
        </div>
        <span v-if="!utilityManage" slot="footer" class="dialog-footer">
          <el-button size="medium" @click="handleClose()" class="revert">取 消</el-button>
          <el-button size="medium" @click="setRefactorCurve()" class="determine">确 定</el-button>
        </span>
        <span v-else slot="footer" class="dialog-footer">
          <el-button size="medium" @click="openCurve()" class="determine">返 回</el-button>
        </span>
      </el-dialog>
      <el-dialog title="回测公式" :visible.sync="addUtility" :close-on-click-modal="false" append-to-body width="35%">
        <div>
          <span>回测预览公式名</span>
          <el-input placeholder="请输入内容" v-model="titleInput" @input="huicejiance"></el-input>
          <span v-show="this.gongshiTishi !== 'ok'" class="italicFont">
            <span v-if="this.gongshiTishi === 'exist'">*已存在该数据名数据，请修改</span>
          </span>
          <br /><br />
          <span>公式构成</span>
          <el-autocomplete type="textarea" id="utility" :rows="2" style="width: 100%;" v-model="utility_str"
            :fetch-suggestions="querySearchUtility" placeholder="请输入内容" :trigger-on-focus="false"
            @select="handleSelectUtility">
            <template slot-scope="{ item }">
              <div class="name">
                <span v-if="item.data_type && item.data_type === 'func_info'">函数-{{ item.format }}</span>
                <el-row v-else :gutter="10">
                  <el-col :span="13" class="nowrapText">
                    数据-{{ item.index_title }}
                  </el-col>
                  <el-col :span="8" style="text-align: center;color: #a30014;">
                    <span>
                      <span v-if="item.min_value > 100000000">{{ Math.round(item.min_value / 1000000) / 100 }}亿</span>
                      <span v-else-if="item.min_value > 10000">{{ Math.round(item.min_value / 100) / 100 }}万</span>
                      <span v-else-if="item.min_value < -100000000">{{ Math.round(item.min_value / 1000000) / 100 }}亿 ~
                      </span>
                      <span v-else-if="item.min_value < -10000">{{ Math.round(item.min_value / 100) / 100 }}万 ~ </span>
                      <span v-else>{{ Math.round(item.min_value * 100) / 100 }}~</span>
                    </span>
                    <span>
                      <span v-if="item.max_value > 100000000">{{ Math.round(item.max_value / 1000000) / 100 }}亿</span>
                      <span v-else-if="item.max_value > 10000">{{ Math.round(item.max_value / 100) / 100 }}万</span>
                      <span v-else-if="item.max_value < -100000000">{{ Math.round(item.max_value / 1000000) / 100 }}亿 ~
                      </span>
                      <span v-else-if="item.max_value < -10000">{{ Math.round(item.max_value / 100) / 100 }}万 ~ </span>
                      <span v-else>{{ Math.round(item.max_value * 100) / 100 }}</span>
                    </span>
                  </el-col>
                  <el-col :span="3">
                    <span v-if="item.user_info">{{ item.user_info.realName }}</span>
                    <span v-else>{{ item.index_source_name }}</span>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-autocomplete><br /><br />
          <span>备注</span>
          <el-input type="textarea" :rows="3" placeholder="请输入内容" maxlength="200" show-word-limit v-model="descInput">
          </el-input><br /><br />
        </div>
        <div class="flex_wrap">
          <div v-for="(x, useMsg) in useMsgData" :key="useMsg">
            <div v-if="x.status === 'clarify'" style="margin-bottom: 5px;margin-right: 10px;width: 190px;">
              <span>{{ x.title }}:</span>
              <el-select :trigger-on-focus="false" v-model="x.selectValue" placeholder="请选择"
                @change="curveEdit(x.title, useMsgData)">
                <el-option class="flex_c" v-for="item in x.selectOptions" :key="item._id" :label="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addUtility = false" class="callOff">取 消</el-button>
          <el-button type="primary" @click="addutilityExpression()" class="determine">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="addFormat" :close-on-click-modal="false" append-to-body width="35%">
        <div>
          <span>模板名</span>
          <el-input placeholder="请输入内容" v-model="titleInput" @input="huicejiance"></el-input>
          <span v-show="this.gongshiTishi !== 'ok' && this.formulaId.length < 1" class="italicFont">
            <span v-if="this.gongshiTishi === 'exist'">*已存在该数据名数据，点击确认后将覆盖同名模版</span>
          </span>
          <br /><br />
          <span>公式</span>
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="formulaInput">
          </el-input><br /><br />
          <span>说明</span>
          <el-input type="textarea" :rows="3" placeholder="请输入内容" maxlength="200" show-word-limit v-model="descInput">
          </el-input><br /><br />
        </div>
        <span slot="footer" class="dialog-footer" v-if="this.formulaId.length > 0">
          <el-button @click="deleteOne('formula')" class="callOff">删除模版</el-button>
          <el-button @click="addFormula()" type="primary" class="determine">确定修改</el-button>
        </span>
        <span slot="footer" class="dialog-footer" v-else>
          <el-button @click="addFormat = false" class="callOff">取 消</el-button>
          <el-button @click="addFormula()" type="primary" class="determine">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="description" width="50%" append-to-body top="10vh">
        <div slot="title" style="width: 100%;text-align: left;">
          <span class="cursor" style="color: #030303;font-size: 20px;">
            <i class="el-icon-document"></i>函数帮助
          </span>
        </div>
        <div style="margin-bottom: 15px;text-align: right;">
          <el-input placeholder="请输入内容" style="width: 300px;" clearable @keyup.enter.native="helpSearch"
            v-model="keyInput" @input="getHelpInput" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="helpSearch"></el-button>
          </el-input>
        </div>
        <div>
          <div style="display: flex;font-size: 16px;border-bottom: 7px solid #F7F7F7;">
            <div style="padding: 0 20px;" @click="handleCommand('函数列表')">
              <span v-if="this.commandText === '函数列表'" class="cursorRed">函数列表</span>
              <span v-else class="cursor666">函数列表</span>
              <div v-show="this.commandText === '函数列表'"
                style="height: 5px;width: 12px;background-color: #A4001B;border-radius: 3px 3px 3px 3px;margin: 10px auto 0;">
              </div>
            </div>
            <div style="padding: 0 20px;" @click="handleCommand('重构说明')">
              <span v-if="this.commandText === '重构说明'" class="cursorRed">重构说明</span>
              <span v-else class="cursor666">重构说明</span>
              <div v-show="this.commandText === '重构说明'"
                style="height: 5px;width: 12px;background-color: #A4001B;border-radius: 3px 3px 3px 3px;margin: 10px auto 0;">
              </div>
            </div>
            <div style="padding: 0 20px;" @click="handleCommand('参考模板')">
              <span v-if="this.commandText === '参考模板'" class="cursorRed">参考模板</span>
              <span v-else class="cursor666">参考模板</span>
              <div v-show="this.commandText === '参考模板'"
                style="height: 5px;width: 12px;background-color: #A4001B;border-radius: 3px 3px 3px 3px;margin: 10px auto 0;">
              </div>
            </div>
            <div style="padding: 0 20px;" @click="handleCommand('教程')">
              <span v-if="this.commandText === '教程'" class="cursorRed">教程</span>
              <span v-else class="cursor666">教程</span>
              <div v-show="this.commandText === '教程'"
                style="height: 5px;width: 12px;background-color: #A4001B;border-radius: 3px 3px 3px 3px;margin: 10px auto 0;">
              </div>
            </div>
          </div>
          <div style="height: 400px;">
            <div v-if="this.commandText === '函数列表'" style="text-align: left;display: flex;font-size: 14px;height: 400px;">
              <div style="width: 80px;border-right: 7px solid #F7F7F7;">
                <div class="flex_c" v-show="!this.searchInput">
                  <div v-for="(x, indexGroup) in functionGroupList" :key="indexGroup">
                    <div :class="{ 'functionClass': functionTitleId === x._id }" v-if="x.support_functions.length > 0"
                      style="text-align: center;padding: 10px 0;" @click="goToFunctionTitle(x._id)">{{ x.title }}</div>
                  </div>
                </div>
                <div class="flex_c" v-show="this.searchInput">
                  <div>
                    <div class="functionClass" style="text-align: center;padding: 10px 0;">搜索结果</div>
                  </div>
                </div>
              </div>
              <div style="width: 100%">
                <el-scrollbar style="height: 100%;">
                  <div v-if="!this.searchInput">
                    <div v-for="(x, indexGroup) in functionGroupList" :key="indexGroup">
                      <div v-if="functionTitleId === x._id" style="padding: 0 20px 20px 20px;">
                        <h3>{{ x.title }}</h3>
                        <div v-for="(y, item) in x.support_functions" :key="item" :command="y">
                          <h4>{{ y.title }} ({{ y.title_chinese }}) <span class="font_s_12 m_l_10"
                              v-if="y.remark && y.remark.length > 0">注：{{ y.remark }}</span></h4>
                          <div>格式：{{ y.format }}</div>
                          <div style="text-align: right;">
                            例子：
                            <span class="underlineText" @click="addItem(y.example)">{{ y.example }}</span>
                          </div>
                          <div class="flex">
                            <span style="width: 300px;">输入：{{ y.input }}</span>
                            <span>输出：{{ y.output }}</span>
                          </div>
                          <span>说明：{{ y.instruction }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="this.supportFunctionList.length > 0" style="padding: 0 20px 20px 20px;">
                      <div v-for="(y, item) in supportFunctionList" :key="item" class="emClass">
                        <h4><span v-html="emJoin(y.title)"></span> (<span v-html="emJoin(y.title_chinese)"></span>) <span
                            class="font_s_12 m_l_10" v-if="y.remark && y.remark.length > 0">注：{{ y.remark }}</span></h4>
                        <div>分类：<span v-html="emJoin(y.group.title)"></span></div>
                        <div class="flex">
                          <span style="width: 300px;text-align: right;">格式：<span v-html="emJoin(y.format)"></span></span>
                          <span  style="text-align: right;">例子：
                            <span class="underlineText" @click="addItem(y.example)" ><span
                                v-html="emJoin(y.example)"></span></span>
                          </span>
                        </div>
                        <div class="flex">
                          <span style="width: 300px;">输入：<span v-html="emJoin(y.input)"></span></span>
                          <span>输出：<span v-html="emJoin(y.output)"></span></span>
                        </div>
                        <span>说明：<span v-html="emJoin(y.instruction)"></span></span>
                      </div>
                    </div>
                    <div v-else style="margin-top: 190px;text-align: center;">
                      <span>函数列表下暂无“{{ this.searchInput }}”搜索结果</span>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
            </div>
            <el-scrollbar style="height: 100%;" v-else>
              <div style="font-size: 14px;padding: 0 20px 20px 0;" class="emClass">
                <div v-if="this.commandText === '重构说明'" style="text-align: left;">
                  <h3 v-html="emJoin('1.基本原理说明：')"></h3>
                  <span
                    v-html="emJoin('通过表达式解析器，可以将输入的数据以及运算符，转化为“数据矩阵”。 “数据矩阵”类似一个二维平面，其中x轴代表各个股票，y轴代表不同的日期。矩阵的某一个元素在坐标(x,y)下的值代表对应的数据的值。 例如，ROE矩阵的第一行第一列，代表了平安银行在第一个有效交易日所对应的最近的ROE数据。 在此基础上我们提供通过符号运算对数据进行排序取值，数据转换，区间判断等操作。例如（ROE>10)，代表取出ROE矩阵中所有符合ROE值大于10%的数据。如果需要可以将计算结果通过乘法与其它判断表达式联合使用，例如 (销售毛利润>=30)*(销售净利润>=0) 会取同时满足两个条件的数据。')">
                  </span>
                  <h3 v-html="emJoin('2.基础数据操作：')"></h3>
                  <span
                    v-html="emJoin('(1).可以在数据间进行+，-，*, /, 括号等四则运算。 如CPI-PPI, M2/GDP， (CPI-PPI)*M2/GDP等;<br/>(2).如果数据名带有特殊字符（括号，运算符等），则需要用双引号让解析器知道这是一个数据名;<br/>(3).举个例子：假设希望通过衡量CPI与PPI的差值，并将差值除以M2，来构造一个新的因子，可以使用表达式 (CPI-PPI)/M2')">
                  </span>
                  <h3 v-html="emJoin('3.使用函数：')"></h3>
                  <span
                    v-html="emJoin('目前支持哪些函数<br/>目前支持的函数包括：映射，排序取前n个。使用函数时，需要按照函数名以及参数格式。支持函数之间的复合使用，例如对排序的结果进一步取排序。')">
                  </span>
                  <h3 v-html="emJoin('映射函数')"></h3>
                  <span
                    v-html="emJoin('(1).说明：将原数据属于[下界, 中值1]范围的数据映射到[-1,0]， 将[中值2,上界部分]映射至[0,1]，并令小于下界的数据映射为-1，大于上界的数据映射为1。使用函数后，所有数据将被映射至[-1,1]区间。<br/>(2).格式： “linearMap(数据名, 下界，中值1，中值2，上界)”<br/>(3).例子: “linearMap(“CPI环比”,99,101,101,103)”')">
                  </span>
                  <h3 v-html="emJoin('单侧判断')"></h3>
                  <span
                    v-html="emJoin('(1).说明: 将数据大于等于，或者小于等于某个值的部分映射到1，否则映射到0。输出数据的尺寸和输入数据相同。<br/>(2).格式：”(数据>某数值)”， 例如：大于等于0， 表达式为(“当日流通市值(万元)”>=10000000)。<br/>(3).注意：由于数学中对此函数的优先级比较模糊，因此一定要要在表达式两侧加上括号。<br/>(4).结果使用：函数为生成与输入数据相同大小的0-1矩阵，因此可以将计算结果通过乘法与其它判断表达式联合使用，例如 (“销售毛利率”>=30)*(销售净利率>=7)会生成 同时满足两个条件的矩阵。<br/>(5).例子：(“销售毛利率”>=30)*(销售净利率>=7)')">
                  </span>
                  <h3 v-html="emJoin('区间判断')"></h3>
                  <span
                    v-html="emJoin('(1).说明：判断数据是否符合”a 小于等于 数据 小于等于 b”条件，会将在[a,b]区间的数据映射至1，否则映射至0。<br/>(2).格式：”between(数据名，下界，上界)” 例如：between(“当日流通市值(万元)”,0,1000000)。<br/>(3).例子: between(“当日流通市值(万元)”,0,1000000)')">
                  </span>
                  <h3 v-html="emJoin('排序函数')"></h3>
                  <span
                    v-html="emJoin('(1).说明：排序函数提供将数据的每天的前N个数据映射到1，否则映射到0的功能；<br/>(2).格式：”top(排序依据数据， 取前多少名)”;<br/>(3).说明-关于复合排序：可以进行复合排序，如top(top(销售毛利率, 100),销售净利润, 10), 表示取销售毛利率前100， 然后取销售净利率前10的股票。<br/>(5).说明-返回结果：排序函数返回的是一个0-1矩阵，因此可对排序后结果与其它数据相乘，效果为将排序结果作为一个筛选条件，例如top(销售毛利率,100)*销售净利率, 会将销售净利率中，对应股票不符合位于销售毛利率前100，数据将变为0.<br/>(6).例子：top((“当日流通市值(万元)”>1000000)*”销售毛利率”,10)， 会在符合当日流通市值(万元)>10000000,的股票中，选择销售毛利率排名前10的股票;')">
                  </span>
                </div>
                <div v-if="this.commandText === '参考模板'" style="text-align: left;">
                  <h3><span v-html="emJoin('如何制作一个ppi-cpi剪刀差因子？')"></span></h3>
                  <span class="underlineText" @click="addItem('“PPI:全部工业品:当月同比”-(“CPI同比”-100)')"
                    v-html="emJoin('“PPI:全部工业品:当月同比”-(“CPI同比”-100)')"></span><br />
                  <span v-html="emJoin('用ppi同比数据与cpi同比数据相减。由于cpi数据为百分数，因此需减去100基数。得到的数值反映了ppi与cpi 剪刀差的大小。')"></span>
                  <h3 v-html="emJoin('如何快速回测按照指标来持有某标的？')"></h3>
                  <span class="underlineText" @click="addItem('累加(归一(“PPI:全部工业品:当月同比”-(“CPI同比”-100))*取回报率(沪深300))')"
                    v-html="emJoin('累加(归一(“PPI:全部工业品:当月同比”-(“CPI同比”-100))*取回报率(沪深300))')"></span><br />
                  <span
                    v-html="emJoin('用归一函数将ppi与cpi的剪刀差映射至[-1,1]区间后，再乘以沪深300指数每日的回报率，最后对结果进行累加，便可以快速测试“按照剪刀差大小看空或看多标的”的想法。')"></span>
                  <h3 v-html="emJoin('如何根据多条件筛选资产？')"></h3>
                  <span class="underlineText" @click="addItem('(“销售毛利率”>=30)*(“销售净利率”>=7)')"
                    v-html="emJoin('(“销售毛利率”>=30)*(“销售净利率”>=7)')"></span><br />
                  <span v-html="emJoin('将计算结果用乘法与其它判断表达式联合使用，表示销售毛利率>=30%，同时满足销售净利率>=7%。')"></span>
                  <h3 v-html="emJoin('如何用流通市值选股，并在结果中按照销售利润排序并取前10只？')"></h3>
                  <span class="underlineText" @click="addItem('取前((“当日流通市值(万元)”>1000000)*“销售毛利率”,10)')"
                    v-html="emJoin('取前((“当日流通市值(万元)”>1000000)*“销售毛利率”,10)')"></span><br />
                  <span
                    v-html="emJoin('使用不等式“符合当日流通市值(万元)>1000”将生成2维0-1矩阵，其中不符合条件的位置值1，否则为0。将此0-1矩阵乘以销售毛利率数据，并传递给取前函数，效果是会在排序中排除不符合流通市值要求的股票。')"></span>
                  <h3 v-html="emJoin('如何考察cpi与ppi数据增量的相关性？')"></h3>
                  <span class="underlineText" @click="addItem('累加(取符号(减前值(“CPI同比”,1))*取符号(减前值(延迟(“PPI:全部工业品:当月同比”),1)))')"
                    v-html="emJoin('累加(取符号(减前值(“CPI同比”,1))*取符号(减前值(延迟(“PPI:全部工业品:当月同比”),1)))')"></span><br />
                  <span
                    v-html="emJoin('用取前值函数求得CPI与PPI数据的增量，用取符号函数将离散数据转化为1或-1，排除数值幅度的影响只看方向，用累加反映两数值变化相关程度随时间的改变。可观察到2008年8月之前，CPI与PPI增量总体呈负相关，之后呈正相关。（由于PPI数据发布日期比CPI早一天，因此用延迟函数进行数据对齐)。')"></span>
                </div>
                <div v-if="this.commandText === '教程'" style="text-align: left;">
                  <table v-if="this.caseList.length > 0" border="1px" v-dragform style="margin-top: 20px;width: 100%;">
                    <thead>
                      <tr>
                        <th>标题</th>
                        <th>摘要</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, caseKey) in caseList" :key="caseKey">
                        <td v-html="item.title" style="width: 150px;" class="underlineText" @click="openCase(item._id)">
                        </td>
                        <td v-html="item.desc"></td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else style="margin-top: 190px;text-align: center;">
                    教程列表下暂无“{{ this.searchInput }}”搜索结果
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="description = false" class="determine">返回</el-button>
          <!-- <el-button type="primary" @click="description = false">确 定</el-button> -->
        </span>
      </el-dialog>
      <el-dialog class="errorClass" :visible.sync="errorVisible" width="20%" top="30vh" append-to-body center>
        <div slot="title">
          <span style="font-size: 16px;color: #fff;"><i class="el-icon-warning-outline">错误</i></span>
        </div>
        <div style="text-align: center;">
          <span style="font-size: 14px;">请输入内容</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="medium" @click="errorVisible = false" class="callOff">返 回</el-button>
        </span>
      </el-dialog>
      <el-dialog close-on-press-escape :visible.sync="saveRecordVisited" append-to-body :close-on-click-modal="false"
        width="35%">
        <div style="height: 200px;">
          名称：<br />
          <el-input placeholder="请输入内容" clearable v-model="nameInput" @input="debounce"
            class="input-with-select"></el-input>
          <tishiBox :tishi="this.tishi" :reconstructionSelect="this.reconstructionSelect"
            :detectionSuccess="this.recordLastItem" :is_asset="this.is_asset"></tishiBox>
          <div style="margin-top: 20px;"
            v-if="!this.recordLastItem.is_matrix && this.recordLastItem.index_info && this.recordLastItem.index_info.dimension && this.recordLastItem.index_info.dimension === 'one-row'">
            <el-radio-group v-model="reconstructionSelect" @change="jiance">
              <el-radio label="1">提交为因子</el-radio><br />
              <el-radio label="2">提交为资产</el-radio>
            </el-radio-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="saveRecordVisited = false" class="revert">取消</el-button>
          <el-button @click="factorSubmit(recordLastItem, 'save')" :disabled="this.tishi === ''" type="primary"
            class="determine">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="saveFactorVisited" append-to-body :close-on-click-modal="false" width="35%">
        <div style="height: 200px;">
          名称：<br />
          <el-input placeholder="请输入内容" clearable v-model="nameInput" @input="debounce"
            class="input-with-select"></el-input>
          <tishiBox :tishi="this.tishi" :reconstructionSelect="this.reconstructionSelect"
            :detectionSuccess="this.detectionSuccess" :is_asset="this.is_asset"></tishiBox>
          <div style="margin-top: 20px;"
            v-if="!this.detectionSuccess.is_matrix && ((this.detectionSuccess.dimension && this.detectionSuccess.dimension === 'one-row') || (this.detectionSuccess.index_info && this.detectionSuccess.index_info.dimension && this.detectionSuccess.index_info.dimension === 'one-row'))">
            <el-radio-group v-model="reconstructionSelect" @change="jiance">
              <el-radio label="1">提交为因子</el-radio><br />
              <el-radio label="2">提交为资产</el-radio>
            </el-radio-group>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="saveFactorVisited = false" class="revert">取消</el-button>
          <el-button @click="factorSubmit(detectionSuccess, 'submit')" :disabled="this.tishi === ''" type="primary"
            class="determine">确 定</el-button>
        </span>
      </el-dialog>
      <!-- <el-dialog
        :visible.sync="temporaryVisited"
        append-to-body
        :close-on-click-modal="false"
        width="35%">
        <span>临时数据名：</span>
        <el-input ref="input" autofocus="autofocus" v-model="temporaryInput" placeholder="请输入内容"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="temporaryVisited = false" class="revert">取 消</el-button>
          <el-button @click="addtemporaryName(recordLastItem)" type="primary" class="determine">确 定</el-button>
        </span>
      </el-dialog> -->
    </div>

    <!-- json 展示模式 -->
    <div v-if="rightBlockType === 'is_json'" style="width: 60%;padding: 20px;box-sizing: border-box;" :style="reconstrucStyleObj">
      <el-scrollbar style="height: 100%;">
        <div >
          <el-divider content-position="left"> <span style="font-weight: 600;">解析后的公式</span> </el-divider>
          <div v-if="detectionSuccess && detectionSuccess.factor_str" class="reconstruction-dialog-text" style="color: rgb(54, 104, 165);">{{detectionSuccess.factor_str}}<el-link style="margin-left:20px;" type="primary" icon="el-icon-document-copy" @click.stop="onClip(detectionSuccess.factor_str,$event)">一键复制</el-link></div>
          <el-divider content-position="left"><span style="font-weight: 600;">公式关联的JSON数据</span></el-divider>
          <div v-if="jsonDataOptions.loading" style="height: 100%;display: flex;justify-content: center;align-items: center;color: #b3292c;" ><span class="el-icon-loading"></span>&nbsp;{{ jsonDataOptions.loadingDesc }}</div>
          <div v-else-if="jsonDataOptions.data" > <vue-json-pretty v-if="jsonDataOptions.data"
            :json-data="JSON.stringify(jsonDataOptions.data)" :initial-deep="999" /></div>
          <div v-else>暂无数据</div>
        </div>
      </el-scrollbar>
    </div>

    <!-- 一维分割图 弹窗 -->
    <FactorLineDialogByOne v-if="showOneDimensionalDialog" :show.sync="showOneDimensionalDialog" :limit.sync="oneDimensionalDialogLimit" :dialog-data="oneDimensionalDialogData" :dialog-forward-data="oneDimensionalDialogDataByLimitDay" :limitDay.sync="oneDimensionalDialogLimitDay" @change="onChangeByDay" @changeByLimitDay="onChangeByLimitDay" @close="onFactorLineDialogByOneClose" />
  </div>
</template>
<script>
import VueJsonPretty from '@/components/JsonViewer/index.vue'
import cloneDeep from 'lodash/cloneDeep'

import { getTimeSeriesRequest } from '@/api/timeSeries.js'
import { postRequest, getRequest, getDataWithStatus } from '@/api/dailyBackTest.js'
import { getLableName, addCustomStockPool } from '@/api/customLabel.js'
import factorLine from '@/components/allPage/factorLine.vue'
import tableLine from '@/components/allPage/tableLine'
import formTable from '@/components/dailyBack/formTable'
import recommonOperate from '@/components/allPage/recommonOperate'
import functionGroup from '@/components/allPage/functionGroup'
import myMirror from '@/components/myMirror.vue'
import lineDetails from '@/components/timeSeries/lineDetails'
import vxeTable from '@/components/vxeTable'
import vxeTableOne from '@/components/timeSeries/vxeTableOne'
import vxeTablefunc from '@/components/allPage/vxeTablefunc'
import tishiBox from '@/components/allPage/tishiBox'
import clip from '@/utils/clipboard'
import HistoryLog from './reconstructionItem/HistoryLog.vue'
import Tools from '@/utils/tools.js'
import apiUtils from '@/views/whiteList/weChatMsgReply/InclusionIndex/controller/ApiFunc.js'

import FactorLineDialogByOne from './FactorLineDialogByOne.vue'

export default {
  name: 'LyReconstructionItem',

  components: {
    VueJsonPretty,
    formTable,
    lineDetails,
    factorLine,
    vxeTable,
    vxeTableOne,
    myMirror,
    recommonOperate,
    functionGroup,
    vxeTablefunc,
    tishiBox,
    tableLine,
    HistoryLog,
    FactorLineDialogByOne
  },
  props: ['chongGouItem', 'chongGouVisited', 'id'],
  data () {
    return {
      showOneDimensionalDialog: false,
      oneDimensionalDialogLimit: 60, // 默认从起始点开始，往后60天
      oneDimensionalDialogLimitDay: 0, // 默认从起始点开始，往前0天
      oneDimensionalDialogData: [], // 往后多少天改变后的图表数据
      oneDimensionalDialogDataByLimitDay: [], // 往后多少天改变后的图表数据
      activeName: 'fourth',
      activeName1: 'first',
      activeName2: 'first',
      nameInput: '',
      dateInput: '',
      factorTextarea: '',
      factorItem: '',
      selectOptions: [],
      patrnKey: [],
      indexInfoList: {},
      sector_list: {},
      tickerInfoList: {},
      description: false,
      dialogVisible: false,
      detectionVisited: false,
      caseVisited: false,
      customDisabled: false,
      disabled: false,
      msgData: [],
      useMsgData: [],
      detectionSuccess: {},
      detailData: {},
      loading: true,
      loading1: true,
      loading2: false,
      reconstrucStyleObj: {
        height: ''
      },
      cardStyObj: {
        height: ''
      },
      tishi: '',
      commandText: '函数列表',
      curveVisible: false,
      assetRadio: 'blockTag',
      refactorHistoryLength: '',
      valueBan: '全A',
      valuWe: '',
      banKuaiData: [],
      utilityAssetList: [],
      use_utility: false,
      utility_str: '',
      utilityStr: '',
      utility_data_list: {},
      fileStatus: {},
      checkFactorData: {},
      searchInfoData: {},
      utilityCurveData: {},
      utilityCurve: [],
      utilityDtes: [],
      functionGroupList: [],
      formatGroupList: [],
      errorVisible: false,
      utilityManage: false,
      widthStyle: '35%',
      utilityList: [],
      addUtility: false,
      titleInput: '',
      descInput: '',
      tagValue: '',
      utilityValue: '',
      eitdId: '',
      allFactorStr: false,
      gongshiTishi: '',
      factorHistoryLength: '',
      factorCheckHistory: [],
      caseList: [],
      caseItem: [],
      searchList: [],
      addFormat: false,
      formulaInput: '',
      formulaId: '',
      useFactorHelper: false,
      utilityTtestValue: {},
      temporaryInput: '',
      valueDate: [],
      is_default_date: false,
      fileStatusUtility: true,
      allFlag: true,
      sectorData: {},
      reconstructionSelect: '1',
      myLableName: [],
      addTemporary: {},
      delectedTemporary: {},
      recordLastItem: {},
      yAxisData: {},
      temporaryVisited: false,
      recordFactorList: [],
      recordTotNum: 0,
      allFactorList: [],
      timer: null,
      timerTwo: null,
      totNum: 0,
      treePage: 0,
      matrixFactorList: [],
      matrixTotNum: 0,
      matrixTreePage: 0,
      timerMatrix: null,
      recordActive: 'record',
      saveFactorVisited: false,
      saveRecordVisited: false,
      is_asset: null,
      auto_scatter_plot: false,
      calculate_begin_date: '', // 计算开始日期
      live_date: '', // live date
      rightBlockType: '', // 是否展示json模式
      time: '',
      lineDetection: '',
      functionTitleId: '',
      zcList: [
        'ret',
        '取回报率',
        'close',
        '收盘价',
        'open',
        '开盘价',
        'pick',
        '取出',
        'high',
        '最高价',
        'low',
        '最低价',
        'sector',
        '板块',
        'buildSector',
        '板块构造',
        'sectorRet',
        '板块回报率',
        'asset',
        '资产'
      ],
      showBtn: false,
      keyInput: '',
      searchInput: '',
      supportFunctionList: [],
      keyWord: [],
      dropdownKeyList: [],
      replaceList: {}, // 下拉框选中数据替换公式中对应数据列表
      param: {},
      viewW: '',
      widthLenght: '',
      rightBoxWidth: {
        width: ''
      },
      hide_zero: false, // 零值
      hide_nan: false, // 空缺值
      hide_repeat: false,
      axisVisited: false,
      is_save: false,
      asset_list: [],
      assetData: {},
      assetIndex: 0,
      matrixData: {},
      factorData: {},
      reconstructAssetsMap: {}, // 批量重构资产，暂存 ‘一维 且 值为空’ 数据的 资产名
      dataByExpressionId: {},
      batchFormula: [], // 公式集合
      jsonDataOptions: {
        loading: true,
        loadingDesc: '获取JSON数据中...',
        data: {}
      }
    }
  },
  created () {
    this.getSupportFunctionByGroup()
  },
  mounted () {
    this.getHeight()
    this.rightBoxWidth.width = document.getElementById('reconstructionRight').scrollWidth - 60 + 'px'
    var _this = this
    window.onresize = function () {
      _this.viewW = document.getElementById('reconstructionRight').scrollWidth - 55
      _this.widthLenght = Math.ceil(this.viewW / 140) - 1
      _this.getHeight()
    }
    let hideZero = localStorage.getItem('hide_zero')
    if (hideZero === 'true') {
      this.hide_zero = true
    } else {
      this.hide_zero = false
    }
    let hideNan = localStorage.getItem('hide_nan')
    if (hideNan === 'true') {
      this.hide_nan = true
    } else {
      this.hide_nan = false
    }
    let hideRepeat = localStorage.getItem('hide_repeat')
    if (hideRepeat === 'true') {
      this.hide_repeat = true
    } else {
      this.hide_repeat = false
    }
    this.localForage.getItem('dropdownKeyList').then(function (value) {
      if (value) {
        _this.dropdownKeyList = value
      }
    })
  },
  methods: {
    // 拿到 expression_id 后，根据 expression_id 去拉取 json数据
    async getJsonData (expressionId) {
      this.jsonDataOptions.loading = true
      try {
        const data = await apiUtils.getJsonByExpressionId({
          expression_id: expressionId
        })
        console.log('getExpression ~ res >>>>>>>:', data)
        this.jsonDataOptions.loading = false
        if (data) {
          this.jsonDataOptions.data = data
          this.jsonDataOptions.loadingDesc = `获取JSON数据中中...`
          // const index = this.recordFactorList.findIndex(item => item._id === expressionId)
          // if (index > 0) {
          //   this.openComplete(this.recordFactorList[index], index)
          // }
          this.detectionSuccess.expression_id = expressionId
        }
      } catch (error) {
        console.log('getExpression ~ error >>>>>>>:', error)
        // 重试多次还是失败
        this.jsonDataOptions.loadingDesc = ''
        this.jsonDataOptions.loading = false
      }
    },
    refreshFactor (y, index) { // 重新计算
      var _this = this
      this.$confirm('是否将该重构因子重新计算？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$message({
          message: '计算中，请稍后......',
          type: 'warning',
          duration: 1000
        })
        let url = '/refactor/refreshFactor'
        for (let i = 0; i < this.recordFactorList; i++) {
          if (i === index) {
            this.recordFactorList[i].loading = true
          } else {
            this.recordFactorList[i].loading = false
          }
        }
        postRequest(url, { id: y.indexinfo_id }).then(function (x) {
          if (!x.data.message) {
            _this.$message({
              message: '计算完成',
              type: 'success',
              duration: 1000
            })
            _this.allFactorList = []
            let numOfItems = _this.treePage * 10
            _this.getTreeList(numOfItems, 0, 'bottom')
          }
          setTimeout(() => {
            _this.allFactorList = []
            let numOfItems = _this.treePage * 10
            _this.getTreeList(numOfItems, 0, 'bottom')
          }, 5000)
        })
      }).catch(() => { })
    },
    hideChange (key) { // 缓存缺失值 零值 重复值勾选状态
      if (key === 'hide_zero') {
        localStorage.setItem('hide_zero', this.hide_zero)
      } else if (key === 'hide_nan') {
        localStorage.setItem('hide_nan', this.hide_nan)
      } else if (key === 'hide_repeat') {
        localStorage.setItem('hide_repeat', this.hide_repeat)
      }
      if (key === 'hide_repeat') {
        this.updataUtilityLine()
      } else {
        this.param = {}
        this.getTickerData()
      }
    },
    updataUtilityLine () { // 切换效用勾选重复值使用参数
      if (this.hide_repeat) {
        this.utilityCurve = this.utilityCurveData.curve_repeat
        this.utilityDtes = this.utilityCurveData.dtes_repeat
      } else {
        this.utilityCurve = this.utilityCurveData.utility_curve
        this.utilityDtes = this.utilityCurveData.utility_dtes
      }
    },
    mergeFactor () { // 合并
      this.getEditer()
      const factorTextarea = this.factorTextarea
      this.factorTextarea = Tools.restoreOriginal(factorTextarea)
    },
    splitFactor () { // 拆分
      this.getEditer()
      const factorTextarea = this.factorTextarea
      const formattedExpression = Tools.formatExpression(factorTextarea)
      this.factorTextarea = formattedExpression

      this.$nextTick(() => {
        // 代码编辑器实例
        const editorInstance = this.$refs.cmEditor.editor
        // 获取代码编辑器内文本的最新值
        const editorValue = editorInstance.getValue()
        // console.log('this.$nextTick ~ editorValue >>>>>>>:', editorValue)

        // 检查文本中的括号是否闭合，如果不闭合，需要获取对应的行号，并暂存一个数组中
        const unbalancedBrackets = []
        const bracketsStack = []
        const bracketsMap = { '(': ')', '（': '）', '[': ']', '{': '}' }

        // 遍历文本，检查每个括号
        editorValue.split('\n').forEach((line, index) => {
          for (let char of line) {
            if (char in bracketsMap) {
              bracketsStack.push({ char, line: index + 1 })
            } else if (Object.values(bracketsMap).includes(char)) {
              if (!bracketsStack.length || bracketsMap[bracketsStack.pop().char] !== char) {
                unbalancedBrackets.push(index + 1)
                break
              }
            }
          }
        })

        // 如果栈中还有未闭合的括号，记录它们所在的行
        bracketsStack.forEach(bracket => {
          unbalancedBrackets.push(bracket.line)
        })

        // 遍历 unbalancedBrackets，根据每一个行号，进行编辑器内高亮处理
        unbalancedBrackets.forEach((lineNumber) => {
          editorInstance.markText({ line: lineNumber - 1, ch: 0 }, { line: lineNumber, ch: 0 }, { className: 'highlight-line' })
        })

        this.factorTextarea = formattedExpression
      })
    },
    splitFactorSon (factor) { // 拆分子集
      let quotationWz = []
      for (let i = 0; i < factor.length; i++) {
        if (factor.charAt(i) === '"') {
          quotationWz.push(i)
        }
      }
      let list = this.getWz(factor, quotationWz)
      return list
    },
    getWz (factor, quotationWz) { // 获取拆分位置
      let level1 = /(==|>=|<=|!=)/
      let level2 = /(>|<)/
      let level3 = /[+-]/
      let level4 = /[*/]/
      let level5 = /(,)/
      let levelList1 = ['==', '>=', '<=', '!='] // 优先级1的计算符
      let levelList2 = ['>', '<']
      let levelList3 = ['+', '-']
      let levelList4 = ['*', '/']
      let levelList5 = [',']
      let txtWz = []
      let grade = 6
      quotationWz.unshift(-1)
      quotationWz.push(factor.length)
      for (let i = 0; i < quotationWz.length - 1; i = i + 2) {
        let txt = ''
        txt = factor.substring(quotationWz[i] + 1, quotationWz[i + 1])
        if (level1.test(txt) && grade > 0) {
          grade = 1
          for (let j = 0; j < levelList1.length; j++) {
            if (txt.indexOf(levelList1[j]) > -1) {
              txtWz.push({ index: quotationWz[i] + 1 + txt.indexOf(levelList1[j]), fh: levelList1[j], level: 1 })
            }
          }
        } else if (level2.test(txt) && grade > 1) {
          grade = 2
          for (let j = 0; j < levelList2.length; j++) {
            if (txt.indexOf(levelList2[j]) > -1) {
              txtWz.push({ index: quotationWz[i] + 1 + txt.indexOf(levelList2[j]), fh: levelList2[j], level: 2 })
            }
          }
        } else if (level3.test(txt) && grade > 2) {
          grade = 3
          for (let j = 0; j < levelList3.length; j++) {
            if (txt.indexOf(levelList3[j]) > -1) {
              txtWz.push({ index: quotationWz[i] + 1 + txt.indexOf(levelList3[j]), fh: levelList3[j], level: 3 })
            }
          }
        } else if (level4.test(txt) && grade > 3) {
          grade = 4
          for (let j = 0; j < levelList4.length; j++) {
            if (txt.indexOf(levelList4[j]) > -1) {
              txtWz.push({ index: quotationWz[i] + 1 + txt.indexOf(levelList4[j]), fh: levelList4[j], level: 4 })
            }
          }
        } else if (level5.test(txt) && grade > 4) {
          grade = 5
          for (let j = 0; j < levelList5.length; j++) {
            if (txt.indexOf(levelList5[j]) > -1) {
              txtWz.push({ index: quotationWz[i] + 1 + txt.indexOf(levelList5[j]), fh: levelList5[j], level: 5 })
            }
          }
        }
      }
      let list = {
        txtWz: txtWz,
        grade: grade
      }
      return list
    },
    handleClick (data) { // 点击常用操作函数回填函数及参数进行回测（同下可优化合并）
      this.getEditer()
      let txt = ''
      if (data.dropdownKey === '无' || data.dropdownKey === '' || !data.dropdownKey) {
        txt = data.title_chinese + '(' + this.factorTextarea + ')'
      } else {
        txt = data.title_chinese + '(' + this.factorTextarea + ',' + data.dropdownKey + ')'
      }
      this.factorTextarea = txt
      if (this.dropdownKeyList.length > 0) {
        for (let i = 0; i < this.dropdownKeyList.length; i++) {
          if (this.dropdownKeyList[i].function === data.title_chinese) {
            this.dropdownKeyList[i].key = data.dropdownKey
            break
          }
        }
      } else {
        this.dropdownKeyList.push({ function: data.title_chinese, key: data.dropdownKey })
      }
      this.localForage.setItem('dropdownKeyList', this.dropdownKeyList)
      setTimeout(() => {
        this.customTesting()
      }, 50)
    },
    addFunction (command, data) { // 点击常用操作函数回填函数及参数进行回测
      this.getEditer()
      let txt = ''
      if (command === '无') {
        txt = data.title_chinese + '(' + this.factorTextarea + ')'
      } else {
        txt = data.title_chinese + '(' + this.factorTextarea + ',' + command + ')'
      }
      this.factorTextarea = txt
      if (this.dropdownKeyList.length > 0) { // 保存选中参数并记录
        for (let i = 0; i < this.dropdownKeyList.length; i++) {
          if (this.dropdownKeyList[i].function === data.title_chinese) {
            this.dropdownKeyList[i].key = command
            break
          }
        }
      } else {
        this.dropdownKeyList.push({ function: data.title_chinese, key: command })
      }
      this.localForage.setItem('dropdownKeyList', this.dropdownKeyList)
      setTimeout(() => {
        this.customTesting() // 进行回测
      }, 50)
    },
    getHelpInput () { // 清空帮助文档输入框清空搜索
      if (this.keyInput === '') {
        this.clearHelpInput()
      }
    },
    emJoin (val) { // 帮助文档搜索关键字标红
      if (this.searchInput && val) {
        var text = ''
        var rg = /^[a-zA-Z]/
        let searchText = '<em>' + this.searchInput + '</em>'
        text = val.split(this.searchInput).join(searchText)
        if (rg.test(this.searchInput)) {
          let low = this.searchInput.toLowerCase()
          let lowKey = '<em>' + low + '</em>'
          text = text.split(low).join(lowKey)
          let up = this.searchInput.toUpperCase()
          let upKey = '<em>' + up + '</em>'
          text = text.split(up).join(upKey)
        }
        return text
      } else {
        return val
      }
    },
    clearHelpInput () { // 打开帮助文档or清空搜索
      this.description = true
      this.keyInput = ''
      this.searchInput = ''
      this.supportFunctionList = []
      this.getCaseList()
    },
    getSupportFunction () { // 获取函数列表
      var _this = this
      getRequest('/userConfig/getSupportFunction', { search: this.searchInput }).then(function (x) {
        if (!x.data.message) {
          _this.supportFunctionList = x.data.data
        }
      })
    },
    helpSearch () { // 帮助文档搜索
      this.searchInput = this.keyInput
      // if (!this.searchInput) {
      //   return
      // }
      this.handleCommand(this.commandText)
    },
    keyList (tickerList, infoList, sectorList) { // 获取公式输入框返回参数
      this.tickerInfoList = Object.assign(this.tickerInfoList, tickerList)
      this.indexInfoList = Object.assign(this.indexInfoList, infoList)
      this.sector_list = Object.assign(this.sector_list, sectorList)
    },
    getInput (value) { // 公式输入框通过监听Input事件可以拿到动态改变的code值
      console.log('getInput ~ value >>>>>>>:', value)
      this.factorTextarea = value
    },
    openComplete (y, index) {
      console.log('openComplete ~ y >>>>>>>:', y)
      this.rightBlockType = ''
      this.detectionVisited = false
      this.fileStatusUtility = true
      this.allFlag = true
      this.addTextarea(y)
      this.clearLine()
      this.detailData = {}
      this.checkFactorData = y
      this.refactorHistoryLength = index
      this.detectionSuccess = JSON.parse(JSON.stringify(y))
      this.detectionSuccess.expression_id = y._id
      if (this.detectionSuccess.index_info && this.detectionSuccess.index_info.dimension) {
        this.detectionSuccess.dimension = this.detectionSuccess.index_info.dimension
      }
      this.rightBlockType = ''
      if (y.is_json) {
        this.rightBlockType = 'is_json'
        this.getJsonData(y._id)
        return
      }
      if (this.detectionSuccess.is_matrix) {
        // this.activeName1 = 'second'
        this.detectionVisited = true
        getDataWithStatus('/matrixInfo/getMatrixInfoByExpressionId', 'getMatrixInfoByExpressionId', { id: this.detectionSuccess._id }, ['matrixData', 'fileStatus'], 1000, 20, this)
      } else {
        for (let i = 0; i < this.zcList.length; i++) {
          let text = this.zcList[i] + '('
          if (this.detectionSuccess.factor_str.indexOf(text) > -1) {
            this.hide_nan = true
            localStorage.setItem('hide_nan', this.hide_nan)
            break
          }
        }
        if (y.utility) {
          this.detectionSuccess.use_utility = y.utility.use_utility
          this.detectionSuccess.utility_result_id = y.utility.utility_result_id
          this.use_utility = this.detectionSuccess.use_utility
        }
        if (this.detectionSuccess.is_commit && this.detectionSuccess.index_info) {
          this.lineDetection = this.detectionSuccess.index_info.index_title
        } else if (this.detectionSuccess.name) {
          this.lineDetection = this.detectionSuccess.name
        } else {
          this.lineDetection = this.detectionSuccess.factor_str
        }
        if (this.detectionSuccess.factor_str.indexOf('sector(?)') < 0 && this.detectionSuccess.factor_str.indexOf('板块(?)') < 0) {
          this.sectorData = {}
        } else {
          this.sectorData._id = this.detectionSuccess._id
        }
        var _this = this
        setTimeout(() => {
          _this.openLine()
        }, 0)
      }
    },
    openLine () {
      // console.log(this.detectionSuccess.dimension)
      this.detectionVisited = true
      if (this.detectionSuccess.indexinfo_id) {
        if (this.activeName1 === 'first') {
          getDataWithStatus('/timeSeries/requestIndexDetail', 'requestIndexDetail', { id: this.detectionSuccess.indexinfo_id }, ['detailData', 'fileStatus'], 1000, 20, this)
        } else {
          if (this.detectionSuccess.dimension === 'one-row') {
            getDataWithStatus('/timeSeries/requestIndexDetail', 'requestIndexDetail', { id: this.detectionSuccess.indexinfo_id }, ['detailData', 'fileStatus'], 1000, 20, this)
          } else {
            this.getTickerData()
          }
        }
        if (this.detectionSuccess.search === true) {
          getDataWithStatus('/refactor/getSearchInfo', 'getSearchInfo', { id: this.detectionSuccess.indexinfo_id }, ['searchInfoData', 'fileStatus'], 1000, 20, this)
        }
      }
      if (this.detectionSuccess.use_utility === true && this.detectionSuccess.utility_result_id) {
        getDataWithStatus('/refactor/getUtilityCurveData', 'getUtilityCurveData', { id: this.detectionSuccess.utility_result_id }, ['utilityCurveData', 'fileStatus'], 1000, 20, this)
      } else {
        this.loading1 = false
      }
    },
    deleteOneTree (y, index) { // 删除一条最近记录
      var _this = this
      this.$confirm('确定是否删除该条记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        postRequest('/refactor/deleteOneTree', { id: y._id }).then(function (x) {
          if (!x.data.message && x.data.data.status === 'success') {
            _this.$message({
              type: 'success',
              message: '删除成功!'
            })
            if (_this.recordLastItem._id && _this.recordLastItem._id === y._id) {
              _this.recordLastItem = {}
            }
            if (_this.checkFactorData._id === y._id) {
              _this.detectionVisited = false
            }
            if (_this.recordActive === 'table') {
              _this.matrixFactorList.splice(index, 1)
              _this.matrixTotNum = _this.matrixTotNum - 1
              if (_this.matrixFactorList.length < 10) {
                _this.matrixTreePage = 1
                _this.getTreeMatrixList(10, 0, 'bottom')
              }
            } else {
              _this.allFactorList.splice(index, 1)
              _this.totNum = _this.totNum - 1
              if (_this.allFactorList.length < 10) {
                _this.treePage = 1
                _this.getTreeList(10, 0, 'bottom')
              }
            }
          }
        })
      }).catch(() => {})
    },
    multiDeleteTree () { // 清空最近记录or制表记录未提交内容
      var _this = this
      this.$confirm('确定是否清空所有未提交为因子/资产的检测记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let isMatrix = false
        if (this.recordActive === 'table') {
          isMatrix = true
        }
        postRequest('/refactor/multiDeleteTree', { is_matrix: isMatrix }).then(function (x) {
          if (!x.data.message && x.data.data.status === 'success') {
            _this.$message({
              type: 'success',
              message: '清空完成!'
            })
            _this.treePage = 0
            _this.getTreeList()
            _this.getTreeMatrixList()
          }
        })
      }).catch(() => { })
    },
    goToFunctionTitle (id) {
      this.functionTitleId = id
    },
    handleClose () { // 关闭效用公式管理
      this.getRefactorCurveSetting()
      this.curveVisible = false
    },
    factorSubmit (x, key, item) { // 提交 参数：提交因子，是否最近记录提交，非最近记录提交是否为板块问号（非制表函数）
      this.msgData = []
      if (!this.nameInput) {
        this.$message({
          type: 'error',
          message: '请输入因子名!'
        })
        return
      }

      // 单个因子 提交的时候
      // dimension：one-row是一维  two是二维
      // 如果提交检测后的结果是 一维或者 空， 不提交结果
      if (this.detailData.dimension === 'one-row' && this.detailData.values.length === 0) {
        console.log('>>>> stop')
        this.$alert('该公式结果为空值，请修正。', '提示')
        this.customDisabled = false
        return
      }

      if (x.is_matrix) { // 是否制表函数
        this.generateMatrixInfo(x.matrixinfo_id, key) // 制表函数提交
      } else {
        this.generateFactor(x, key, item) // 非制表函数提交需考虑是否为板块问号等情况
      }
    },
    generateFactor (x, key, item) { // 非制表函数提交
      var _this = this
      if (!(this.tishi === 'ok' || (this.tishi === 'exist' && ((this.reconstructionSelect === '1' && this.is_asset === false) || (this.reconstructionSelect === '2' && this.is_asset === true))))) {
        this.$message({
          type: 'error',
          message: '请重新输入因子名!'
        })
        return
      }
      var param = { index_title: this.nameInput }
      if (key === 'save') {
        if (x.indexinfo_id) {
          param.id = x.indexinfo_id
        } else {
          this.$message({
            type: 'error',
            message: '提交失败!'
          })
          return
        }
        param.is_asset = this.getAsset(x)
      } else {
        if (this.sectorData.is_multiple_search && this.sectorData.is_multiple_search === true) {
          param.id = this.sectorData._id
        } else if (item === 'assetData' && this.assetData._id) {
          param.id = this.assetData._id
        } else if (item === 'factorData' && this.factorData._id) {
          param.id = this.factorData._id
        } else if (this.detectionSuccess.indexinfo_id) {
          param.id = this.detectionSuccess.indexinfo_id
        } else {
          this.$message({
            type: 'error',
            message: '提交失败!'
          })
          return
        }
        if (item === 'assetData') {
          param.is_asset = true
        } else {
          param.is_asset = this.getAsset(x)
        }
      }

      // 生成重构因子
      postRequest('/refactor/generateFactor', param).then(function (x) {
        if (!x.data.message) {
          let isAsset = false
          if (_this.reconstructionSelect === '1') {
            isAsset = false
          } else {
            isAsset = true
          }
          if (key === 'save') {
            _this.recordLastItem.is_asset = isAsset
            _this.recordLastItem.is_commit = true
            _this.recordLastItem.index_info.index_title = _this.nameInput
            getRequest('/refactor/getIndexInfoByExpressionId', { expression_id: _this.recordLastItem._id }).then(function (y) {
              if (!y.data.message) {
                _this.detectionSuccess.indexinfo_id = y.data.data._id
                _this.checkFactorData.indexinfo_id = y.data.data._id
              }
            })
          } else {
            _this.is_save = false
            _this.getIdAddCustom(item)
          }
          _this.saveRecordVisited = false
          _this.closeSaveRecord()
          _this.allFactorList = []
          var numOfItems = _this.treePage * 10
          _this.getTreeList(numOfItems, 0, 'bottom')
        }
      })
    },
    generateMatrixInfo (id, key) { // 制表函数提交
      var _this = this
      if (this.tishi !== 'ok') {
        this.$message({
          type: 'error',
          message: '请重新输入因子名!'
        })
        return
      }
      if (!id) {
        this.$message({
          type: 'error',
          message: '提交失败!'
        })
        return
      }
      this.saveFactorVisited = false
      this.saveRecordVisited = false
      postRequest('/matrixInfo/generateMatrixInfo', { id: id, title: this.nameInput }).then(function (x) {
        if (!x.data.message) {
          if (key === 'save') {
            _this.recordLastItem.matrix_info.matrix_title = _this.nameInput
            _this.recordLastItem.is_commit = true
          }
          _this.closeSaveRecord()
          _this.matrixFactorList = []
          var numOfItems = _this.matrixTreePage * 10
          _this.getTreeMatrixList(numOfItems)
        }
      })
    },
    getAsset (x) { // 是否提交为资产
      let isAsset = false
      if (x.dimension === 'one-row' || (x.index_info && x.index_info.dimension === 'one-row')) {
        if (this.reconstructionSelect === '1') {
          isAsset = false
        } else {
          isAsset = true
        }
      } else {
        this.reconstructionSelect = '1'
      }
      return isAsset
    },

    // 批量重构资产，获取每一个重构因子
    async getIdAddCustom (key) {
      try {
        const expressionId =
        key === 'assetData' && this.assetData._id
          ? this.assetData.expression_id
          : key === 'factorData' && this.factorData._id
            ? this.factorData.expression_id
            : (this.detectionSuccess.is_commit = true, this.detectionSuccess.expression_id)

        const indexInfo = await getRequest('/refactor/getIndexInfoByExpressionId', { expression_id: expressionId })
        const data = indexInfo.data.data
        const message = indexInfo.data.message
        if (!message) {
          if (!key) {
            this.detectionSuccess.indexinfo_id = data._id
            this.checkFactorData.indexinfo_id = data._id
          } else {
            // 查询资产详情
            const detailData = await getRequest('/timeSeries/requestIndexDetail', { id: data._id })

            if (detailData.data && detailData.data.data) {
              const { dimension, values, index_title: indexTitle, _id: id } = detailData.data.data
              // 一维 且 值为空
              if (dimension === 'one-row' && values.length === 0) {
                // 暂存（这里是批量，最后统一弹窗提示）
                if (!this.reconstructAssetsMap[indexTitle]) {
                  this.reconstructAssetsMap[indexTitle] = id
                }
              }
            }

            this.asset_list[this.assetIndex].id = data._id
            this.is_save = true
            // 检查索引长度
            if (this.asset_list.length > 0 && this.assetIndex < this.asset_list.length - 1) {
            // 索引加 1
              this.assetIndex++

              // 计算 postFactor
              let postFactor
              if (key === 'assetData') {
                postFactor = `${this.asset_list[this.assetIndex].index_title}->${this.asset_list[this.assetIndex].assetItem.factor_str}`
                this.asset_list[this.assetIndex].assetItem.post_factor_str = postFactor
                this.factorTextarea = postFactor
              } else if (key === 'factorData') {
                postFactor = this.asset_list[this.assetIndex].assetItem.post_factor_str
              }

              // 检查是否为最后一个
              // 旧：如果是最后一个就调取 详情接口
              if (this.assetIndex === this.asset_list.length - 1) {
                this.is_save = true
                this.nameInput = this.asset_list[this.assetIndex].index_title
                this.checkFactor(this.asset_list[this.assetIndex].assetItem.factor_str, postFactor)
                console.log('最后一个啦')
                // // 判断公式数组有没有值，有的话执行
                // if (this.batchFormula.length) {
                //   for (let i = this.batchFormula.length - 1; i >= 0; i--) {
                //     const str = this.batchFormula[i]
                //     this.onceMoreFormat(str, key)
                //     this.batchFormula.pop()
                //   }
                // }
              } else {
                this.forCheckFactor('factorData')
              }
              return
            }
          }

          // 处理 assetData 的逻辑
          // 检查键名和索引
          if (this.assetIndex === this.asset_list.length - 1 && key === 'assetData') {
          // 提取id数组
            const ids = this.asset_list.map(item => item.id)

            // 去重
            const uniqueIds = this.uniqueTwo(ids)

            // 调用添加方法
            const result = await addCustomStockPool({
              label_name: this.asset_list[0].name,
              stock_list: [],
              index_info_list: uniqueIds
            })

            // 检查结果
            if (!result.data.message) {
            // 成功操作
              this.$emit('shuaxinApp', 'getLableName')
              this.$message({
                message: '添加成功',
                type: 'success',
                duration: 1000
              })
              // 重置
              this.asset_list = []
              this.getLableName('news')
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    closeSaveRecord () { // 提交成功处理
      this.$message({
        type: 'success',
        message: '提交成功!'
      })
      this.saveFactorVisited = false
      this.saveRecordVisited = false
      this.$emit('shuaxin', 'shuaxinRefactor')
      this.tishi = ''
      this.nameInput = ''
    },
    getRecordLast (x) { // 点击单条最近记录
      // console.log('getRecordLast', x)
      if (x.status === 'ok') {
        return
      }
      if (x._id === this.recordLastItem._id) {
        this.recordLastItem = {}
      } else {
        this.recordLastItem = x
      }
      // console.log(this.recordLastItem)
    },
    updataYAxisIndex (index, y, key) { // 对比曲线切换左右轴
      this.yAxisData = {}
      this.delectedTemporary = {}
      this.addTemporary = {}
      if (!this.detectionVisited) {
        return
      }
      if (key === 'left') {
        this.allFactorList[index].yAxisIndex = true
      } else {
        this.allFactorList[index].yAxisIndex = false
      }
      this.yAxisData = {
        _id: this.allFactorList[index].index_info._id,
        yAxisIndex: this.allFactorList[index].yAxisIndex
      }
    },
    addLine (index, y) { // 增加对比曲线
      this.delectedTemporary = {}
      this.yAxisData = {}
      if (!this.detectionVisited) {
        this.$message('请先点击 "计算完成"，选中一条数据')
        return
      }
      this.allFactorList[index].addLine = true
      this.addTemporary = JSON.parse(JSON.stringify(y))
      this.addTemporary._id = y.indexinfo_id
      if (y.is_commit) {
        this.addTemporary.index_title = y.index_info.index_title
      } else if (y.name) {
        this.addTemporary.name = y.name
      } else {
        this.addTemporary.factor_str = y.factor_str
      }
    },
    delectedLine (index, y) { // 删除对比曲线
      this.addTemporary = {}
      this.yAxisData = {}
      if (!this.detectionVisited) {
        return
      }
      this.delectedTemporary = JSON.parse(JSON.stringify(y))
      this.delectedTemporary._id = y.indexinfo_id
      this.allFactorList[index].addLine = false
    },
    dataChange (value) { // sector和ret问号表达式排序时间段(设置变更是否默认时间)
      if (value === null) {
        this.is_default_date = true
        this.getDefaultDate()
      } else {
        this.is_default_date = false
      }
    },
    addFormula () { // 添加/修改模板（我的模板）
      if (!this.formulaInput) {
        this.$message({
          type: 'error',
          message: '请输入模板公式!'
        })
        return
      }
      if (!this.titleInput) {
        this.$message({
          type: 'error',
          message: '请输入模板名称!'
        })
        return
      }
      var _this = this
      var param = {
        title_chinese: this.titleInput,
        instruction: this.descInput,
        format: this.formulaInput
      }
      if (this.formulaId) {
        param.id = this.formulaId
        postRequest('/refactorFormat/edit', param).then(function (x) {
          if (x.data.message) {
            return
          }
          if (x.data.data.status === 'success') {
            _this.addFormat = false
            _this.getListByGroup() // 更新模板列表
          }
        })
      } else {
        if (this.gongshiTishi !== 'ok' && this.gongshiTishi !== 'exist') {
          this.$message({
            type: 'error',
            message: '请修改模板名称!'
          })
          return
        }
        postRequest('/refactorFormat/add', param).then(function (x) {
          if (x.data.message) {
            return
          }
          if (x.data.data.status === 'success') {
            _this.addFormat = false
            _this.getListByGroup() // 更新模板列表
          }
        })
      }
    },
    parseFormat () { // 保存模板
      this.titleInput = ''
      this.descInput = ''
      this.gongshiTishi = ''
      this.formulaId = ''
      let factorItem = this.detectionSuccess.factor_str
      let tot = 0
      let right = []
      let left = []
      for (let i = 0; i < factorItem.length; i++) {
        if (factorItem.charAt(i) === '"') {
          tot = tot + 1
          if (tot % 2 === 1) {
            left.push(i)
          } else {
            right.push(i + 1)
          }
        }
      }
      let text = []
      for (let j = 0; j < left.length; j++) {
        text.push(factorItem.substring(left[j], right[j]))
      }
      text = this.unique(text)
      for (let z = 0; z < text.length; z++) { // 将模板里的数据替换
        factorItem = factorItem.replaceAll(text[z], '数据' + (z + 1))
      }
      this.formulaInput = factorItem
      this.addFormat = true
    },
    casetaoyong () { // 帮助文档教程公式套用（回填到输入框）
      this.caseVisited = false
      this.factorTextarea = this.detectionSuccess.factor_str
    },
    openCustom (factorStr) { // 帮助文档教程公式检测
      this.factorTextarea = factorStr
      this.customTesting()
    },
    openCase (id) { // 打开帮助文档教程
      var _this = this
      getRequest('/refactorCase/caseDetail', { id: id }).then(function (x) {
        if (!x.data.message) {
          _this.caseItem = x.data.data
          _this.caseVisited = true
          _this.description = false
        }
      })
    },
    openCurve () { // 关闭效用公式弹窗
      this.curveVisible = true
      this.utilityManage = false
      this.widthStyle = '35%'
      this.getRefactorCurveSetting()
      this.getLableName()
    },
    getLableName (index) { // 获取资产池
      var _this = this
      getLableName().then(function (x) {
        _this.myLableName = x.data.data
        let flag = false
        for (var a = 0; a < _this.myLableName.length; a++) {
          _this.myLableName[a].type = 'myTag'
          _this.myLableName[a].tagName = _this.myLableName[a].lable_name
          _this.myLableName[a].tag = 'custom' + _this.myLableName[a]._id
          if (_this.valuWe) {
            if (_this.valuWe === _this.myLableName[a].tagName) {
              flag = true
            }
          }
        }
        if (flag === false) {
          _this.valuWe = ''
        }
      })
    },
    openAddUtility () { // 新建添加效用公式
      this.useMsgData = []
      this.utility_data_list = {}
      this.titleInput = ''
      this.descInput = ''
      this.utility_str = ''
      this.utility_str = ''
      this.eitdId = ''
      this.addUtility = true
      this.gongshiTishi = ''
    },
    huicejiance () { // 检查重名（我的模板/效用公式）
      var _this = this
      if (this.addFormat === true) { // 我的模板
        postRequest('/refactorFormat/checkTitle', { title: this.titleInput }).then(function (x) {
          _this.gongshiTishi = x.data.data.status
        })
      } else if (this.addUtility === true) { // 效用公式
        let param = { title: this.titleInput }
        if (this.eitdId) {
          param.id = this.eitdId
        }
        postRequest('/utilityExpression/checkUtilityTitle', param).then(function (x) {
          _this.gongshiTishi = x.data.data.status
        })
      }
    },
    eitdOne (item, key) { // 编辑效用公式or我的模板
      if (key === 'utility') { // 编辑效用公式
        this.eitdId = item._id
        this.titleInput = item.title
        this.descInput = item.desc
        this.utility_str = item.expression_str
        this.addUtility = true
        this.gongshiTishi = ''
      } else if (key === 'formula') { // 编辑我的模板
        this.formulaId = item._id
        this.titleInput = item.title_chinese
        this.descInput = item.instruction
        this.formulaInput = item.format
        this.addFormat = true
      }
    },
    deleteOne (key, item) { // 删除效用公式or我的模板
      var _this = this
      if (key === 'utility') { // 删除效用公式
        this.$confirm('是否删除该公式', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          postRequest('/utilityExpression/deleteOne', { id: item._id }).then(function (x) {
            if (!x.data.message) {
              _this.$message({
                type: 'success',
                message: '删除成功!'
              })
              _this.getUtilityList()
            }
          })
        }).catch(() => { })
      } else if (key === 'formula') { // 删除我的模板
        this.$confirm('是否删除该模板', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          postRequest('/refactorFormat/deleteOne', { id: this.formulaId }).then(function (x) {
            if (!x.data.message) {
              _this.$message({
                type: 'success',
                message: '删除成功!'
              })
              _this.addFormat = false
              _this.getListByGroup()
            }
          })
        }).catch(() => { })
      }
    },
    openUtility () { // 打开效用公式管理
      this.curveVisible = true
      this.utilityManage = true
      this.widthStyle = '60%'
    },
    async setUtilitySetting (key) { // 效用图表切换板块/公式
      if (this.utilityValue == null || this.utilityValue === '') {
        const res = await getRequest('/refactor/getUtilityCurveData', { id: this.detectionSuccess.utility_result_id, is_stop: true }).catch(err => {
          console.error(err)
        })
        if (!res.data.message && res.data.data) {
          this.tagValue = res.data.data.asset_tag
          this.utilityValue = res.data.data.utility_expression_id
        }
      }
      var _this = this
      var param = {
        asset_tag: this.tagValue,
        utility_expression_id: this.utilityValue
      }
      this.utilityCurveData = {}
      this.utilityTtestValue = {}
      this.fileStatusUtility = true
      this.allFlag = true
      this.loading1 = true
      if (key === 'utilityValue') { // 切换效用公式
        postRequest('/userConfig/setUtilitySetting', param).then(function (x) { // 修改效用设置
          if (!x.data.message) {
            _this.generateUtility()
          }
        })
      } else if (this.detectionSuccess.factor_str.indexOf('sector(?)') > -1 || this.detectionSuccess.factor_str.indexOf('板块(?)') > -1) { // 板块问号重新检测
        let tag = this.tagValue
        let utilityAsset = this.utilityAssetList.findIndex(item => item.tag === tag)
        let tagName = this.utilityAssetList[utilityAsset].tagName
        this.sector_list[tagName] = this.tagValue
        this.factorTextarea = this.detectionSuccess.factor_str
        this.factorTextarea = this.factorTextarea.replaceAll('sector(?)', 'sector(' + tagName + ')')
        this.factorTextarea = this.factorTextarea.replaceAll('板块(?)', '板块(' + tagName + ')')
        this.sectorData.is_multiple_search = true
        this.sectorData.factor_str = _this.detectionSuccess.factor_str
        this.sectorData.modified_factor_str = _this.detectionSuccess.modified_factor_str
        this.customTesting(true)
      } else if (this.sectorData.is_multiple_search) { // 板块问号切换重新检测后切换
        let tag = this.tagValue
        let utilityAsset = this.utilityAssetList.findIndex(item => item.tag === tag)
        let tagName = this.utilityAssetList[utilityAsset].tagName
        this.sector_list[tagName] = this.tagValue
        this.factorTextarea = this.sectorData.factor_str
        this.factorTextarea = this.factorTextarea.replaceAll('sector(?)', 'sector(' + tagName + ')')
        this.factorTextarea = this.factorTextarea.replaceAll('板块(?)', '板块(' + tagName + ')')
        this.customTesting(true)
      } else { // 切换板块
        postRequest('/userConfig/setUtilitySetting', param).then(function (x) { // 修改效用设置
          if (!x.data.message) {
            _this.generateUtility()
          }
        })
      }
    },
    generateUtility () { // 效用报错重新检测
      if (this.fileStatus.length > 0) {
        this.customTesting()
      } else {
        this.getUtilityId()
      }
    },
    getUtilityId () { // 获取效用id
      var _this = this
      postRequest('/refactor/generateUtility', { expression_id: this.detectionSuccess.expression_id }).then(function (x) {
        if (!x.data.message) {
          _this.detectionSuccess.utility_result_id = x.data.data.utility_result_id
          _this.fileStatus = ''
          clearTimeout(_this.timerTwo)
          for (let i = 0; i < _this.allFactorList.length; i++) {
            if (_this.allFactorList[i] && _this.detectionSuccess._id === _this.allFactorList[i]._id) {
              _this.getSeveralTrees([_this.detectionSuccess._id], [i]) // 更新该条记录
            }
          }
          if (_this.detectionSuccess.use_utility === true) { // 获取效用图
            getDataWithStatus('/refactor/getUtilityCurveData', 'getUtilityCurveData', { id: x.data.data.utility_result_id }, ['utilityCurveData', 'fileStatus'], 1000, 15, _this)
          }
        }
      })
    },
    getHeight () { // 获取高度
      var windowHeight = window.innerHeight
      this.reconstrucStyleObj.height = windowHeight - 20 + 'px'
      this.cardStyObj.height = windowHeight - 52 + 'px'
      var windowWidth = window.innerWidth - 60
      var drawer = windowWidth + 'px'
      this.$emit('drawer', drawer)
      this.rightBoxWidth.width = document.getElementById('reconstructionRight').scrollWidth - 60 + 'px'
    },
    goUp () { // 滚动到最下方
      var scrollTop = this.$refs.table.scrollHeight - 350
      this.$refs.table.scrollTop = scrollTop
    },
    addutilityExpression () { // 效用检查（版本较老）
      if (!this.utility_str) {
        this.utility_data_list = {}
        this.$message({
          type: 'error',
          message: '请输入回测预览公式!'
        })
        return
      }
      if (!this.titleInput) {
        this.$message({
          type: 'error',
          message: '请输入回测预览公式名称!'
        })
        return
      }
      var _this = this
      let tot = 0
      let flag = false
      this.utility_str = this.utility_str.split('""').join('"')
      for (let i = 0; i < this.utility_str.length; i++) {
        if (this.utility_str.charAt(i) === '"') {
          tot = tot + 1
          if (tot % 2 === 1) {
            flag = true
          } else {
            flag = false
          }
        } else {
          if (flag === false && tot % 2 === 0) {
            if (this.utility_str.charAt(i) === '“') {
              this.utility_str = this.utility_str.substring(0, i) + '"' + this.utility_str.substring(i + 1, this.utility_str.length)
            } else if (this.utility_str.charAt(i) === '”') {
              this.utility_str = this.utility_str.substring(0, i) + '"' + this.utility_str.substring(i + 1, this.utility_str.length)
            } else if (this.utility_str.charAt(i) === '（') {
              this.utility_str = this.utility_str.substring(0, i) + '(' + this.utility_str.substring(i + 1, this.utility_str.length)
            } else if (this.utility_str.charAt(i) === '）') {
              this.utility_str = this.utility_str.substring(0, i) + ')' + this.utility_str.substring(i + 1, this.utility_str.length)
            } else if (this.utility_str.charAt(i) === '，') {
              this.utility_str = this.utility_str.substring(0, i) + ',' + this.utility_str.substring(i + 1, this.utility_str.length)
            } else if (this.utility_str.charAt(i) === '？') {
              this.utility_str = this.utility_str.substring(0, i) + '?' + this.utility_str.substring(i + 1, this.utility_str.length)
            } else if (this.utility_str.charAt(i) === ' ') {
              this.utility_str = this.utility_str.substring(0, i) + this.utility_str.substring(i + 1, this.utility_str.length)
              i = i - 1
            }
          }
        }
      }
      if (this.utility_str.split('(').length !== this.utility_str.split(')').length) {
        this.$message.error('效用公式中左右括号不匹配，请修改后再提交')
        return
      }
      this.utility_str = this.utility_str.split(/\n/).join('')
      this.utility_str = this.utility_str.split('""').join('"')
      var param = {
        title: this.titleInput,
        desc: this.descInput,
        expression_str: this.utility_str,
        data_list: this.utility_data_list
      }
      if (this.eitdId) {
        param.id = this.eitdId
        postRequest('/utilityExpression/edit', param).then(function (x) {
          if (x.data.message) {
            return
          }
          if (x.data.data.status === 'success') {
            _this.useMsgData = []
            _this.titleInput = ''
            _this.descInput = ''
            _this.utility_str = ''
            _this.eitdId = ''
            _this.addUtility = false
            _this.getUtilityList()
          } else if (x.data.data.status === 'error') {
            _this.dialogVisible = true
            _this.useMsgData = x.data.data.msg
            _this.selectOption()
          }
        })
      } else {
        if (this.gongshiTishi !== 'ok') {
          this.$message({
            type: 'error',
            message: '请修改回测预览公式名称!'
          })
          return
        }
        postRequest('/utilityExpression/add', param).then(function (x) {
          if (x.data.message) {
            return
          }
          if (x.data.data.status === 'success') {
            _this.useMsgData = []
            _this.titleInput = ''
            _this.descInput = ''
            _this.utility_str = ''
            _this.addUtility = false
            _this.getUtilityList()
            _this.goUp()
          } else if (x.data.data.status === 'error') {
            _this.dialogVisible = true
            _this.useMsgData = x.data.data.msg
            _this.selectOption()
          }
        })
      }
    },
    closeDrawer () { // 关闭重构or教程
      if (this.caseVisited === false) { // 关闭重构
        this.$emit('closeDrawer', 'chongGouVisited')
      } else { // 关闭教程
        this.caseVisited = false
        // this.factorTextarea = ''
        this.description = true
        this.commandText = '教程'
      }
    },
    getTickerData (key) { // 数据详情接口参数
      this.param = { id: this.detectionSuccess.indexinfo_id }
      if (this.hide_zero) {
        this.param.hide_zero = 1
      } else {
        this.param.hide_zero = 0
      }
      if (this.hide_nan) {
        this.param.hide_nan = 1
      } else {
        this.param.hide_nan = 0
      }
    },
    drawDate (date) { // 因子信息图，图tooltip点击详情跳转数据详情
      this.activeName1 = 'second'
      this.dateInput = date
      this.getTickerData()
    },

    // 因子构成 一键复制
    onCopyCommit (obj, event) {
      if (obj.index_info && obj.index_info.factor_structure) {
        let text = obj.index_info.factor_structure.map(v => `${v.t}=${v.f}`).join('\n')
        clip(text, event)
      }
    },

    onClip (text, event) {
      clip(text, event)
    },

    handleCopy (event, key, item, ref) { // 拷贝
      if (key === 'search_list') { // 推荐资产/板块等拷贝
        var _this = this
        let id = this.detectionSuccess.indexinfo_id
        if (!id || id == null) return
        getRequest('/refactor/getSearchCopyStr', { id }).then(function (x) {
          if (!x.data.message) {
            _this.searchList = x.data.data.search_str
            _this.$refs[ref].click()
          }
        })
      } else if (key === 'factor_str') { // 公式
        clip(item, event)
      } else if (key === 'detailData') { // 因子信息（图）
        if (this.detailData.dimension === 'one-row') { // 一维数据直接拷贝
          let text = '日期\t' + this.detailData.index_title
          for (let i = 0; i < this.detailData.labels.length; i++) {
            text = text + '\n' + this.detailData.labels[i] + '\t' + this.detailData.values[i]
          }
          clip(text, event)
        } else { // 二维数据拷贝
          this.getTwoData()
        }
      }
    },
    getTwoData () { // 拷贝二维数据
      var _this = this
      getRequest('/dataSupport/getCoordinate', { id: this.detailData._id }).then(function (x) {
        if (!x.data.message) {
          if (x.data.data.status === 'ok') {
            let dtesLen = x.data.data.dtes_len
            let tkrsLen = x.data.data.tkrs_len
            let dateList = x.data.data.dtes
            let nameList = x.data.data.name
            if (dtesLen * tkrsLen > 50000) {
              _this.$message.error('数据过大，暂不支持拷贝粘贴')
              return
            }
            let params = {
              x: 0,
              y: 0,
              w: dtesLen,
              h: tkrsLen,
              id: _this.detailData._id
            }
            getRequest('/dataSupport/getDataByCoordinate', params).then(function (x) {
              if (!x.data.message) {
                let tablesData = x.data.data
                let text = '\t'
                for (let i = 0; i < nameList.length; i++) {
                  text = text + nameList[i] + '\t'
                }
                for (let i = 0; i < dateList.length; i++) {
                  text = text + '\n' + dateList[i] + '\t'
                  for (let j = 0; j < nameList.length; j++) {
                    if (tablesData[i][j]) {
                      text = text + tablesData[i][j] + '\t'
                    } else {
                      text = text + '\t'
                    }
                  }
                }
                _this.searchList = text
                _this.$refs.copyRef.click()
              }
            })
          } else if (x.data.data.status === 'waiting') {
            setTimeout(() => {
              _this.getTwoData()
            }, 1000)
          } else {
            _this.$message.error(x.data.data.message)
          }
        }
      })
    },
    copySearch (event) { // 拷贝数据详情及异步拷贝
      clip(this.searchList, event)
    },
    switchOneClick (name) { // 切换tab（因子信息及数据详情）
      this.clearLine() // 清空图表对比等
      this.lineDetection = ''
      if (name) {
        this.activeName1 = name
      }
      if (this.activeName1 === 'first') {
        if (this.detectionSuccess.is_commit && this.detectionSuccess.index_info) {
          this.lineDetection = this.detectionSuccess.index_info.index_title
        } else if (this.detectionSuccess.name) {
          this.lineDetection = this.detectionSuccess.name
        } else {
          this.lineDetection = this.detectionSuccess.factor_str
        } // 图表显示名称
        if (this.detectionSuccess.indexinfo_id) { // 图表显示
          this.loading = true
          getDataWithStatus('/timeSeries/requestIndexDetail', 'requestIndexDetail', { id: this.detectionSuccess.indexinfo_id }, ['detailData', 'fileStatus'], 1000, 20, this)

          // 批量资产重构之后，如果存在 一维且值为空 的数据
          if (Object.keys(this.reconstructAssetsMap).length) {
            const tips = '以下名称为空值，请知悉。<br/>' + Object.keys(this.reconstructAssetsMap).map(key => key).join('<br/>')
            this.$alert(tips, '提示', {
              dangerouslyUseHTMLString: true
            })
          }
          if (this.detectionSuccess.search === true) {
            getDataWithStatus('/refactor/getSearchInfo', 'getSearchInfo', { id: this.detectionSuccess.indexinfo_id }, ['searchInfoData', 'fileStatus'], 1000, 20, this) // 板块问号情况下使用
          }
        }
      } else {
        if (this.detectionSuccess && this.detectionSuccess.indexinfo_id) {
          if (this.detectionSuccess.dimension === 'two') {
            this.getTickerData()
          } else { // 一维数据使用图表数据显示
            getDataWithStatus('/timeSeries/requestIndexDetail', 'requestIndexDetail', { id: this.detectionSuccess.indexinfo_id }, ['detailData', 'fileStatus'], 1000, 20, this)
          }
        }
      }
    },
    clearLine () { // 清空图表对比等
      this.dateInput = ''
      this.addTemporary = {}
      this.delectedTemporary = {}
      for (let i = 0; i < this.allFactorList.length; i++) {
        if (this.allFactorList[i]) {
          this.allFactorList[i].addLine = false
        }
      }
    },
    getRefactorCurveSetting () { // 获取设置内容
      var _this = this
      getRequest('/userConfig/getRefactorCurveSetting').then(function (x) {
        if (!x.data.message) {
          var result = x.data.data
          _this.assetRadio = result.asset_type // 选择板块or我的资产
          _this.valuWe = result.lable_name
          _this.valueBan = result.block_tag_name
          _this.use_utility = result.use_utility // 是否打开效用
          _this.useFactorHelper = result.useFactorHelper
          _this.is_default_date = result.is_default_date // 是否默认回测时间
          _this.auto_scatter_plot = result.auto_scatter_plot // 散点图
          _this.calculate_begin_date = result.calculate_begin_date // 计算开始日期
          _this.live_date = result.live_date || '' // live date
          if (result.is_default_date === false) { // 非默认时回测开始时间结束时间
            _this.valueDate = [result.beginDate, result.endDate]
          } else { // 获取默认回测时间
            _this.getDefaultDate()
          }
        }
      })
    },
    getDefaultDate () { // 获取默认回测时间
      var _this = this
      getRequest('/userConfig/getDefaultDate').then(function (x) {
        if (!x.data.message) {
          var result = x.data.data
          _this.valueDate = [result.beginDate, result.endDate]
        }
      })
    },
    openUtilityLine () { // 右侧图表下方按钮打开效用
      this.use_utility = !this.use_utility
      this.detectionSuccess.use_utility = this.use_utility
      this.setRefactorCurve('openUtility')
    },
    setRefactorCurve (key) { // 设置
      var _this = this
      let lableId = ''
      let blockTag = ''
      if (this.assetRadio === 'blockTag') {
        if (this.valueBan === undefined || this.valueBan.length < 1) {
          this.$message.error('请选择板块')
          return
        }
        for (let i = 0; i < this.banKuaiData.length; i++) {
          if (this.banKuaiData[i].tagName === this.valueBan) {
            blockTag = this.banKuaiData[i].tag
            break
          }
        }
      } else if (this.assetRadio === 'customLable') {
        if (this.valuWe === undefined || this.valuWe.length < 1) {
          this.$message.error('请选择我的资产')
          return
        }
        for (let i = 0; i < this.myLableName.length; i++) {
          if (this.myLableName[i].tagName === this.valuWe) {
            lableId = this.myLableName[i]._id
            break
          }
        }
      }
      var beginDate = this.formatTimes(this.valueDate[0])
      var endDate = this.formatTimes(this.valueDate[1])
      var param = {
        asset_type: this.assetRadio, // 选择板块or我的资产
        lable_id: lableId,
        block_tag: blockTag,
        use_utility: this.use_utility, // 是否打开效用
        useFactorHelper: this.useFactorHelper,
        is_default_date: this.is_default_date, // 是否默认回测时间
        beginDate: beginDate, // 回测开始时间
        endDate: endDate, // 回测结束时间
        auto_scatter_plot: this.auto_scatter_plot, // 散点图
        calculate_begin_date: this.calculate_begin_date, // 计算开始日期
        live_date: this.live_date // live date
      }
      postRequest('/userConfig/setRefactorCurve', param).then(function (x) {
        _this.useMsgData = []
        if (x.data.message) {
          return
        }
        if (x.data.data.status === 'success') {
          _this.curveVisible = false
          if (_this.use_utility && _this.detectionSuccess.expression_id) { // 设置时打开效用并且当前有检测成功内容图表
            _this.loading1 = true
            _this.getUtilityId()
          }
        }
      })
    },
    formatTimes (time) {
      return this.$moment(time).format('YYYY-MM-DD').toString()
    },
    curveEdit (title, item) { // 效用下拉框选中参数对应id等
      this.useMsgData = JSON.parse(JSON.stringify(item))
      for (let i = 0; i < this.useMsgData.length; i++) {
        if (this.useMsgData[i].title === title) {
          for (let j = 0; j < this.useMsgData[i].selectOptions.length; j++) {
            if (this.useMsgData[i].selectOptions[j].value === this.useMsgData[i].selectValue) {
              this.utility_data_list[this.useMsgData[i].title] = this.useMsgData[i].selectOptions[j]._id
            }
          }
        }
      }
    },
    arrowClick (i, item, factor) { // 图表或输入框切换
      var _this = this
      if (item === 'lineDetails') {
        this.clearLine()
        this.detectionVisited = false
        this.fileStatusUtility = true
        this.allFlag = true
        this.detailData = {}
        this.utilityCurveData = {}
        this.utilityTtestValue = {}
        this.refactorHistoryLength = i
        this.detectionSuccess = {}
        this.checkFactorData = this.recordFactorList[i]
        this.detectionSuccess = JSON.parse(JSON.stringify(this.recordFactorList[i]))
        this.detectionSuccess.expression_id = this.recordFactorList[i]._id
        if (this.recordFactorList[i].utility && !this.recordFactorList[i].is_matrix) {
          this.detectionSuccess.use_utility = this.recordFactorList[i].utility.use_utility
          this.detectionSuccess.utility_result_id = this.recordFactorList[i].utility.utility_result_id
        }
        if (this.detectionSuccess.is_commit && this.detectionSuccess.index_info) {
          this.lineDetection = this.detectionSuccess.index_info.index_title
        } else if (this.detectionSuccess.is_commit && this.detectionSuccess.matrix_info) {
          this.lineDetection = this.detectionSuccess.matrix_info.match_title
        } else if (this.detectionSuccess.name) {
          this.lineDetection = this.detectionSuccess.name
        } else {
          this.lineDetection = this.detectionSuccess.factor_str
        }
        this.fileStatus = {}
        if (this.detectionSuccess.status === 'error') {
          this.allFlag = false
          return
        }
        if (this.detectionSuccess.is_matrix) {
          // this.activeName1 = 'second'
          this.detectionVisited = true
          getDataWithStatus('/matrixInfo/getMatrixInfoByExpressionId', 'getMatrixInfoByExpressionId', { id: this.detectionSuccess._id }, ['matrixData', 'fileStatus'], 1000, 20, this)
        } else {
          this.switchOneClick()
          // console.log(this.recordFactorList[i])
          this.getRecordLast(this.recordFactorList[i])
          setTimeout(() => {
            _this.openLine()
          }, 50)
        }
      } else if (item === 'factorTextarea') {
        if (i === 0 && factor === 'left') {
          this.localForage.setItem('factorTextarea', this.factorTextarea)
          if (this.factorCheckHistory[0].factor_str === this.factorTextarea) {
            i = 1
          }
          this.factorHistoryLength = i
          if (this.factorCheckHistory[i].index_info_list) {
            this.indexInfoList = this.factorCheckHistory[i].index_info_list
          }
          if (this.factorCheckHistory[i].ticker_info_list) {
            this.tickerInfoList = this.factorCheckHistory[i].ticker_info_list
          }
          if (this.factorCheckHistory[i].sector_list) {
            this.sector_list = this.factorCheckHistory[i].sector_list
          }
          this.factorTextarea = this.factorCheckHistory[i].post_factor_str
        } else {
          this.factorHistoryLength = i
          var factorText = ''
          this.localForage.getItem('factorTextarea').then(function (value) {
            factorText = value
            if (i === -1) {
              _this.factorTextarea = factorText
              return
            } else if (i === 0 && factor === 'right') {
              if (_this.factorCheckHistory[0].factor_str === factorText) {
                _this.factorHistoryLength = -1
                i = 0
              }
              _this.factorTextarea = _this.factorCheckHistory[i].post_factor_str
            } else {
              _this.factorTextarea = _this.factorCheckHistory[i].post_factor_str
            }
            if (_this.factorCheckHistory[i].index_info_list) {
              _this.indexInfoList = _this.factorCheckHistory[i].index_info_list
            }
            if (_this.factorCheckHistory[i].sector_list) {
              _this.sector_list = _this.factorCheckHistory[i].sector_list
            }
            if (_this.factorCheckHistory[i].ticker_info_list) {
              _this.tickerInfoList = _this.factorCheckHistory[i].ticker_info_list
            }
          })
        }
      }
    },
    handleCommand (command) { // 帮助文档切换tab
      this.commandText = command
      this.description = true
      if (!this.searchInput) {
        return
      }
      // 搜索
      if (this.commandText === '教程') {
        this.getCaseList()
      } else if (this.commandText === '函数列表') {
        this.getSupportFunction()
      }
    },
    debounce () { // 检测影子名节流
      // 每次按下键盘的时候都会触发这个函数，
      // 先清除定时器然后再设置定时器，他就会从新开始计时
      var _this = this
      this.tishi = ''
      this.is_asset = null
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        _this.jiance()
      }, 500)
    },
    async jiance (key) { // 检测输入因子名是否可以使用/是否重名
      this.tishi = ''
      var _this = this
      if (!this.nameInput) {
        return
      }
      if (this.nameInput.indexOf('$') > -1) {
        this.tishi = '请勿输入特殊符号“$”'
      }
      if (this.nameInput.indexOf("'") > -1) {
        this.tishi = "请勿输入特殊符号“'”"
      }
      if (this.nameInput.indexOf('"') > -1) {
        this.tishi = '请勿输入特殊符号“"”'
      }
      if (this.tishi) {
        this.$alert(this.tishi, '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return
      }
      let isMatrix = false
      let id = ''
      if (!key) { // 非批量检查因子名
        if (this.saveFactorVisited) { // 检测检查因子名
          isMatrix = this.detectionSuccess.is_matrix
          id = this.detectionSuccess._id
          if (this.detectionSuccess.dimension === 'two' || (this.detectionSuccess.index_info && this.detectionSuccess.index_info.dimension === 'two')) { // 判断是否不可以提交为资产
            this.reconstructionSelect = '1'
          }
        } else if (this.saveRecordVisited) { // 最近记录部分检查因子名
          isMatrix = this.recordLastItem.is_matrix
          id = this.recordLastItem._id
          if (this.recordLastItem.dimension === 'two' || (this.recordLastItem.index_info && this.recordLastItem.index_info.dimension === 'two')) { // 判断是否不可以提交为资产
            this.reconstructionSelect = '1'
          }
        } else { // 自动提交检查因子名
          isMatrix = this.detectionSuccess.is_matrix
          id = this.detectionSuccess._id
        }
      }

      // 提交前的校验
      if (this.dataByExpressionId && this.dataByExpressionId._id) {
        // 查询对应的因子详情数据
        const detailData = await getRequest('/timeSeries/requestIndexDetail', { id: this.dataByExpressionId._id })

        if (detailData.data && detailData.data.data) {
          let _target = this.asset_list.find(v => v.id === this.dataByExpressionId._id)
          const { dimension, values } = detailData.data.data
          // 一维 且 值为空
          if (dimension === 'one-row' && values.length === 0) {
            const tips = '以下公式为空值，请修正。<br/>' + _target.assetItem.factor_str
            this.$alert(tips, '提示', {
              dangerouslyUseHTMLString: true
            })
            this.customDisabled = false
            return
          }
        }
      }

      this.customDisabled = false
      if (isMatrix) { // 制表函数检查因子名
        postRequest('/matrixInfo/checkTitle', { id: id, title: this.nameInput }).then(function (x) {
          if (!x.data.message) {
            _this.tishi = x.data.data.status
            if (_this.is_save === true) {
              if (_this.tishi !== 'ok') {
                let text = ''
                if (_this.tishi === 'only_number') {
                  text = '*全为数字不通过'
                } else if (_this.tishi === 'exist') {
                  text = '*重名无法进行覆盖操作，请做修改'
                }
                _this.$alert(text, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                })
                _this.is_save = false
              } else if (_this.tishi === 'ok' && key) { // 自动提交
                _this.factorSubmit(_this.detectionSuccess, 'submit')
              }
            }
          }
        })
      } else {
        postRequest('/timeSeries/checkTitle', { index_title: this.nameInput }).then(function (x) {
          if (!x.data.message) {
            _this.tishi = x.data.data.status
            _this.is_asset = x.data.data.is_asset
            if (key || (_this.asset_list.length > 0 && _this.assetIndex === _this.asset_list.length - 1)) { // 批量提交最后一个提交或自动提交
              if (key === 'assetData') {
                _this.reconstructionSelect = '2'
              }
              if (key === 'assetData' && _this.tishi === 'exist' && !_this.is_asset) {
                _this.asset_list = []
                _this.$alert('*资产与数据重名无法进行覆盖操作，请做修改', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                })
                _this.is_save = false
              } else if (key === 'factorData' && _this.tishi === 'exist' && _this.is_asset) {
                _this.asset_list = []
                _this.$alert('*资产与数据重名无法进行覆盖操作，请做修改', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                })
                _this.is_save = false
              } else if (_this.tishi === 'only_number') {
                _this.asset_list = []
                _this.$alert('*全为数字不通过', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                })
                _this.is_save = false
              } else {
                _this.factorSubmit(_this.assetData, 'submit', key) // 提交
              }
            } else if (_this.is_save === true) { // 自动提交
              if (_this.tishi !== 'ok') {
                let flag = false
                let text = ''
                if (_this.tishi === 'exist') {
                  if (_this.reconstructionSelect === '1' && !_this.is_asset) {
                    flag = true
                    text = '*与已有数据重名，点击“确定”覆盖原数据？覆盖后依赖该数据的重构因子会发生变化，需手动重新计算'
                  } else if (_this.reconstructionSelect === '2' && _this.is_asset) {
                    flag = true
                    text = '*与已有资产重名，点击“确定”覆盖原数据？覆盖后依赖该数据的重构因子会发生变化，需手动重新计算'
                  } else {
                    text = '*资产与数据重名无法进行覆盖操作，请做修改'
                  }
                } else if (_this.tishi === 'only_number') {
                  text = '*全为数字不通过'
                }
                if (flag === true) {
                  _this.$confirm(text, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                  }).then(() => {
                    _this.factorSubmit(_this.detectionSuccess, 'submit') // 重名覆盖提交
                  }).catch(() => {
                    _this.is_save = false
                  })
                } else {
                  _this.$alert(text, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                  })
                  _this.is_save = false
                }
              } else if (_this.tishi === 'ok') {
                _this.factorSubmit(_this.detectionSuccess, 'submit') // 提交
              }
            }
          }
        })
      }
    },
    goDailyBack (x) { // 关闭重构进入回测页使用重构因子/资产
      var item = x.index_info
      if (item.is_asset && item.is_asset === true) {
        item.data_type = 'stock_info'
        item.type = 'index_info'
      } else {
        item.data_type = 'index_info'
      }
      let text = JSON.stringify(item)
      // this.bus.$emit('shuaxin', 'addTag', text)
      this.$emit('shuaxinApp', 'addTag', text)
    },
    fnEdit (title, item, status) { // 下拉框选中参数对应id等
      this.msgData = JSON.parse(JSON.stringify(item))
      for (let i = 0; i < this.msgData.length; i++) {
        if (this.msgData[i].title === title) {
          for (let j = 0; j < this.msgData[i].selectOptions.length; j++) {
            if (this.msgData[i].selectOptions[j].value === this.msgData[i].selectValue) {
              if (status === 'ticker_error') {
                this.tickerInfoList[this.msgData[i].title] = this.msgData[i].selectOptions[j].ticker
              } else {
                this.replaceList[this.msgData[i].title] = this.msgData[i].selectOptions[j].index_title // 下拉框选中数据替换公式中对应数据列表
                this.indexInfoList[this.msgData[i].title] = this.msgData[i].selectOptions[j]._id
              }
            }
          }
        }
      }
    },
    querySearchUtility (queryString, cb) { // 效用公式匹配数据/因子
      if (!this.utility_str) {
        this.utility_data_list = {}
      }
      var elInput = document.getElementById('utility')
      var startPos = elInput.selectionStart
      this.utilityStr = this.utility_str
      this.patrnKey = queryString.substring(0, startPos).split(/[-+*()（）/"“,，><=]/)
      var results = []
      if (this.patrnKey[this.patrnKey.length - 1].length < 1) {
        cb(results)
        return results
      }
      this.utilityStr = this.utility_str
      getTimeSeriesRequest('dataAndTagSearch', { key: this.patrnKey[this.patrnKey.length - 1], fields: 'indexinfo' }).then(function (x) {
        if (!x.data.message) {
          results = x.data.data.search_data
          cb(results)
        }
        return results
      })
      // 调用 callback 返回建议列表的数据
    },
    handleSelectUtility (item) { // 效用公式
      var elInput = document.getElementById('utility')
      var startPos = elInput.selectionStart
      var endPos = elInput.selectionEnd
      this.utility_data_list[item.index_title] = item._id
      var key = this.patrnKey[this.patrnKey.length - 1]
      if (endPos === undefined) {
        this.utilityStr = this.utilityStr.substring(0, this.utilityStr.lastIndexOf(key))
        if (item.data_type === 'func_info') {
          this.utilityStr = this.utilityStr + item.format
        } else {
          this.utilityStr = this.utilityStr + '"' + item.index_title + '"'
        }
        this.utility_str = this.utilityStr
      } else {
        var startFactor = this.utilityStr.substring(0, startPos)
        var startFactorKey
        var endPosKey
        if (startFactor.lastIndexOf(key) < 0) {
          startFactorKey = this.utilityStr.lastIndexOf(key)
          endPosKey = this.utilityStr.substring(endPos + 1)
        } else {
          startFactorKey = startFactor.lastIndexOf(key)
          endPosKey = this.utilityStr.substring(endPos)
        }
        if (item.data_type === 'func_info') {
          this.utilityStr = this.utilityStr.substring(0, startFactorKey) + item.format + endPosKey
        } else if (this.utilityStr.substring(0, startFactor.lastIndexOf(key)).lastIndexOf('"') === this.utilityStr.substring(0, startFactorKey).length - 1) {
          this.utilityStr = this.utilityStr.substring(0, startFactorKey - 1) + '"' + item.index_title + '"' + endPosKey
        } else {
          this.utilityStr = this.utilityStr.substring(0, startFactorKey) + '"' + item.index_title + '"' + endPosKey
        }
        this.utility_str = this.utilityStr
      }
    },
    clearFactor () { // 清空输入框
      this.factorTextarea = ''
    },
    addItem (x, y, z, id) { // 获取回填包含内容
      this.description = false
      // this.activeName = 'first'
      this.factorTextarea = x
      if (y) {
        this.indexInfoList = y
      }
      if (z) {
        this.sector_list = z
      }
    },
    addTextarea (x) { // 回填公式
      let txt = x.post_factor_str
      if (txt.charAt(0) === '"' && txt.charAt(x.length - 1) === '"') { // 公式为单数据回填该数据公式
        txt = txt.substring(1, txt.length - 1)
      }
      if (txt.indexOf('"') < 0 && x.index_info_list) { // 公式为单数据回填该数据公式
        let id = x.index_info_list[txt] // 获取该数据id
        var _this = this
        if (id) { // 有id获取公式
          getRequest('/refactor/refactorDetail', { id: id }).then(function (data) {
            if (!data.data.message) {
              let item = data.data.data.refactor_detail[0]
              if (item.templateExpressionTree && item.templateExpressionTree.factor_str) { // 获取到公式回填
                let factorItem = item.templateExpressionTree
                _this.addFactorToArea(factorItem)
              } else { // 没有公式回填
                _this.addFactorToArea(x)
              }
            }
          })
        } else { // 无id回填
          this.addFactorToArea(x)
        }
      } else { // 非单数据回填
        this.addFactorToArea(x)
      }
    },
    addFactorToArea (x) { // 回填并获取参数
      if (x.index_info_list) {
        this.indexInfoList = x.index_info_list
      }
      if (x.sector_list) {
        this.sector_list = x.sector_list
      }
      this.factorTextarea = x.post_factor_str
      this.$refs.cmEditor.editor.setValue(x.post_factor_str)
    },
    getEditer () { // 获取公式
      this.factorTextarea = this.$refs.cmEditor.editor.getValue()
    },
    addFactorItem (x, key) { // 添加函数or数据
      let txt = x.format
      this.getEditer()
      let elInput = this.$refs.cmEditor.editor.getCursor() // 鼠标位置等
      var startPos = elInput.ch
      // console.log(elInput)
      var lastPos = this.factorTextarea.substr(this.factorTextarea.length - 1, 1)
      if (x.index_info && x.index_info._id && x.index_info.index_title) { // 引用数据
        this.indexInfoList[x.index_info.index_title] = x.index_info._id
        if (startPos === undefined) { // 有鼠标位置
          this.factorTextarea = this.factorTextarea + '"' + x.index_info.index_title + '"'
        } else {
          this.factorTextarea = this.factorTextarea.substring(0, startPos) + '"' + x.index_info.index_title + '"' + this.factorTextarea.substring(startPos, this.factorTextarea.length)
        }
      }
      if (!txt) { // 添加公式
        return
      }
      // 替换特殊字符为当前公式
      var zz = /(数据+[0-9])+?/
      if (zz.test(txt) && txt.indexOf('数据1') > -1 && this.factorTextarea.length > 0 && lastPos !== '+' && lastPos !== '-' && lastPos !== '*' && lastPos !== '/' && lastPos !== '(' && lastPos !== '（') { // 当前公式最后一个字符非特殊字符
        txt = txt.replaceAll('数据1', this.factorTextarea)
        this.factorTextarea = txt
      } else if (!zz.test(txt) && txt.indexOf('数据') > -1 && this.factorTextarea.length > 0 && lastPos !== '+' && lastPos !== '-' && lastPos !== '*' && lastPos !== '/' && lastPos !== '(' && lastPos !== '（') {
        txt = txt.replaceAll('数据', this.factorTextarea)
        this.factorTextarea = txt
      } else {
        if (startPos === undefined) {
          this.factorTextarea = this.factorTextarea + x.format
        } else {
          this.factorTextarea = this.factorTextarea.substring(0, startPos) + x.format + this.factorTextarea.substring(startPos, this.factorTextarea.length)
        }
      }
    },
    unique (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr) && res.set(arr, 1))
    },
    uniqueTwo (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr) && res.set(arr, 1))
    },
    uniqueTitle (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.title) && res.set(arr.title, 1))
    },
    format (factor) { // 检查公式是否符合规范及修正
      // console.log(factor)
      let tot = 0
      let flag = false
      let left = 0 // 双引号外的左括号
      let right = 0 // 双引号外的右括号
      let bkleft = 0 // 资产类函数内左括号
      let bkright = 0 // 资产类函数内右边括号
      let keyWords = [] // 公式包含函数
      let computeSign = true // 优先级
      let signWz = 1 // 优先级检查位置
      let wz = 0 // 双引号位置
      let custom = 0 // 自动提交为资产时资产名位置
      let custom1 = 0 // 自动提交为因子时因子名位置
      let factorAfter = '' // 裁切因子名时判断等号前是否为为特殊符号
      let factorBefore = '' // 裁切因子名时判断等号后是否为为特殊符号
      let inParentheses = false // 新增一个标志，用于跟踪是否在括号内
      let afterOperator = false // 新增标志：是否在操作符之后
      let recentList = ['today', '今天', 'oneYearAgo', '一年前']
      let updatedFactor = factor

      for (let i = 0; i < updatedFactor.length; i++) {
        for (let j = 0; j < recentList.length; j++) {
          let recent = updatedFactor.indexOf(recentList[j], i)
          if (recent !== -1) {
            // 检查关键词是否后面跟着括号
            if (updatedFactor.charAt(recent + recentList[j].length) !== '(') {
              // 插入括号
              updatedFactor = updatedFactor.substring(0, recent + recentList[j].length) + '()' + updatedFactor.substring(recent + recentList[j].length)
              i = recent + recentList[j].length + 1 // 更新索引以避免重复处理
            } else {
              i = recent + recentList[j].length // 移动索引到关键词之后
            }
          }
        }
      }

      factor = updatedFactor
      for (let i = 0; i < factor.length; i++) {
        if (factor.charAt(i) === '"') {
          tot = tot + 1
          if (tot % 2 === 1) {
            flag = true
          } else {
            flag = false
            wz = i
          }
        } else {
          // console.log(i, tot)
          if (flag === false && tot % 2 === 0) {
            let isName = false
            custom = factor.indexOf('->') // ->裁切资产名位置
            if (custom > 0) {
              this.nameInput = factor.substring(0, custom)
              factor = factor.substring(custom + 2, factor.length)
              this.reconstructionSelect = '2'
              isName = true
            } else if (factor.charAt(i) === '=') {
              factorAfter = factor.charAt(i + 1)
              factorBefore = factor.charAt(i - 1)
              let isTableZ = factor.indexOf('表格(')
              let isTable = factor.indexOf('table(')
              if (i > 0 && factorAfter !== '=' && factorBefore !== '=' && factorBefore !== '>' && factorBefore !== '<' && factorBefore !== '!') {
                if ((isTableZ > -1 && isTableZ > i) || (isTable > -1 && isTable > i) || (isTableZ < 0 && isTable < 0)) { // 是否表格函数，表格函数=在表格函数后不解析，非表格函数解析
                  custom1 = i
                  this.nameInput = factor.substring(0, i)
                  factor = factor.substring(i + 1, factor.length)
                  this.reconstructionSelect = '1'
                  isName = true
                }
              }
            }
            if (isName) { // 自动保存并初始化循环参数
              this.is_save = true
              i = 0
              keyWords = []
              left = 0
              right = 0
              bkleft = 0
              bkright = 0
              break
            } // 截取名称及公式后退出当前循环进行下一个循环，不进行下列步骤
            if (factor.charAt(i) === '(') {
              // 只对英文括号进行函数关键字提取
              let patrnKey = factor.substring(0, i).split(/[-+*()（） /"",，><=]/)
              keyWords.push(patrnKey[patrnKey.length - 1])
              left = left + 1
              inParentheses = true // 当遇到开括号时，设置标志
              afterOperator = false // 进入括号后，重置操作符之后的标志
            } else if (factor.charAt(i) === '（') {
              // 中文括号不提取关键字，但仍需要计数
              left = left + 1
              inParentheses = true
              afterOperator = false
            } else if (factor.charAt(i) === ')') {
              right = right + 1
              inParentheses = false // 当遇到闭括号时，清除标志
            } else if (factor.charAt(i) === '）') {
              // 中文括号不提取关键字，但仍需要计数
              right = right + 1
              inParentheses = false
            }

            // 检查当前字符是否是操作符
            if ('+-*/'.includes(factor.charAt(i))) {
              afterOperator = true // 标记为在操作符之后
            }

            let flag1 = false
            for (let zc = 0; zc < this.zcList.length; zc++) {
              let zcWz = factor.indexOf(this.zcList[zc])
              // console.log(this.zcList[zc], zcWz)
              // console.log(i, factor.charAt(i), zcWz + this.zcList[zc].length + 1, zcWz > -1 && i > (zcWz + this.zcList[zc].length + 1))
              if (zcWz >= wz && i > (zcWz + this.zcList[zc].length + 1)) {
                flag1 = true
                break
              }
            }
            let isCharAt = false // 是否需要进行替换
            if (flag1) {
              isCharAt = false
              if (factor.charAt(i) === '（' && bkleft === 0) {
                bkleft = bkleft + 1
              } else if (factor.charAt(i) === '）' && bkleft - bkright === 1) {
                bkright = bkright + 1
              } else if (factor.charAt(i) === '？') {
                factor = factor.substring(0, i) + '?' + factor.substring(i + 1, factor.length)
              } else if (bkleft === bkright) {
                isCharAt = true
                bkleft = 0
                bkright = 0
              }
            } else {
              isCharAt = true
            }
            if (isCharAt) { // 中文符号变为英文符号
              // console.log(factor.charAt(i), i)
              if (factor.charAt(i) === '“') {
                factor = factor.substring(0, i) + '"' + factor.substring(i + 1, factor.length)
              } else if (factor.charAt(i) === '”') {
                factor = factor.substring(0, i) + '"' + factor.substring(i + 1, factor.length)
              } else if (factor.charAt(i) === '（') {
                factor = factor.substring(0, i) + '(' + factor.substring(i + 1, factor.length)
              } else if (factor.charAt(i) === '）') {
                factor = factor.substring(0, i) + ')' + factor.substring(i + 1, factor.length)
              } else if (factor.charAt(i) === '，') {
                factor = factor.substring(0, i) + ',' + factor.substring(i + 1, factor.length)
              } else if (factor.charAt(i) === '？') {
                factor = factor.substring(0, i) + '?' + factor.substring(i + 1, factor.length)
              } else if (factor.charAt(i) === ' ' && !inParentheses) {
                if (afterOperator) {
                // 如果是操作符后的空格，移除所有连续空格
                  while (i < factor.length && factor.charAt(i) === ' ') {
                    factor = factor.substring(0, i) + factor.substring(i + 1, factor.length)
                  }
                  afterOperator = false // 重置操作符之后的标志
                } else {
                  // 如果不是操作符后的空格，像之前一样移除空格
                  factor = factor.substring(0, i) + factor.substring(i + 1, factor.length)
                  i = i - 1
                }
              }
            }
          }
        }
      }
      // 拆分优先级及判断运算符是否正确
      let factorList = factor.split(/[+*/><]/) // 根据关键字裁切
      for (let i = 0; i < factorList.length; i++) {
        signWz = signWz + factorList[i].length
        if (factorList[i].length < 1) { // 运算符裁切中有空字符
          let sign = factor.slice(signWz, signWz + 2)
          return { computeSign: false, sign: sign }
        } else if (factorList[i].charAt(factorList[i].length - 1) === '-') {
          let sign = factor.slice(signWz - 2, signWz)
          return { computeSign: false, sign: sign }
        }
      }
      // console.log(right)
      // console.log(left)
      return { right: right, left: left, keyWords: keyWords, factor: factor, computeSign: computeSign, custom: custom, custom1: custom1 }
    },
    // 检测（单个或批量）
    customTesting (key) {
      console.log('🚀 ~ file: reconstructionItem.vue:3501 ~ customTesting ~ key:', key)
      this.loading2 = true
      this.reconstructAssetsMap = {}

      this.dateInput = ''
      this.asset_list = [] // 循环批量生成资产列表
      this.tishi = ''
      this.nameInput = ''
      this.is_save = false
      this.tagValue = ''
      this.utilityValue = ''
      this.fileStatus = {}
      this.detailData = {}
      this.utilityCurveData = {}
      this.utilityTtestValue = {}
      this.matrixData = {}
      this.detectionVisited = false
      this.reconstructionSelect = '1'
      this.fileStatusUtility = true
      this.allFlag = true // 清空初始化图表
      // 如果不是教程, 需要获取公式
      if (this.caseVisited === false && !key) {
        this.getEditer() // 获取输入框公式
      }
      // 输入框无内容 弹窗提示
      if (!this.factorTextarea) {
        this.errorVisible = true
        return
      }

      // 对输入框内的文本进行格式化
      let factorStr = this.factorTextarea
      factorStr = Tools.removeSpacesOutsideQuotes(factorStr)
      factorStr = factorStr.split(/\r/).join('')
      factorStr = factorStr.split('""').join('"')
      factorStr = factorStr.split('！=').join('!=')
      this.$set(this, 'factorTextarea', factorStr)

      // replaceList -> 点击检测按钮后，出来的下拉组内的下拉数据集合
      // replaceList = [{"市盈率":"市盈率(PE)"}]
      let replaceData = Object.keys(this.replaceList)
      // 对replaceList中的数据进行替换(双引号格式化)
      for (let i = 0; i < replaceData.length; i++) {
        let title = '"' + replaceData[i] + '"'
        let indexTitle = '"' + this.replaceList[replaceData[i]] + '"'
        factorStr = factorStr.split(title).join(indexTitle)
      }

      let factorStrList = []
      // 对当前文本内容，用回车符号切割成一个集合
      factorStrList = factorStr.split(/\n/)

      // 对批量提交因子进行处理
      let batchFactorList = [] // 多个因子的集合
      this.batchFormula = [] // 多个公式的集合
      let text = ''

      // 判断字符串中是否符合公式的格式（必须不是开头和结尾是=号）
      /** *  正常字符串结构如下(有可能用户手动对单条公式换行，这里对单条公式格式是否正确进行判断)：
         高低价斜率=按期回归系数(最高价(沪深300),最低价(沪深300),18)\n
         RSS=按期决定系数(最高价(沪深300),最低价(沪深300),18)\n
         z分数=("高低价斜率"-按期平均("高低价斜率",600))/按期标准差("高低价斜率",600)
      ***/
      for (let i = 0; i < factorStrList.length; i++) {
        let curItem = factorStrList[i]
        // 如果当前元素中包含等号（=），且等号不在末尾位置
        if (curItem.indexOf('=') > 0 && curItem.indexOf('=') !== curItem.length - 1) {
          if (text.indexOf('=') > 0 && text.indexOf('=') !== text.length - 1) {
            batchFactorList.push(text)
            text = ''
          }
          batchFactorList.push(curItem)
        } else {
          text = text + curItem
          // 校验括号是否完全闭合
          if (Tools.checkParentheses(curItem)) {
            // 如果当前的字符串是个公式
            this.batchFormula.push(curItem)
          }
        }
      }
      // 如果是单条可执行函数：例如：按期回归系数(最高价(沪深300),最低价(沪深300),18)，并且该条数据没有等号
      if (batchFactorList.length < 1) {
        factorStr = factorStr.split(/\n/).join('')
        this.onceMoreFormat(factorStr, key)
        return
      }

      console.log(this.batchFormula)

      // console.log(batchFactorList)
      this.asset_list = []
      for (let i = 0; i < batchFactorList.length; i++) { // 批量提交因子
        // 如果是单条提交因子
        if (batchFactorList.length === 1) {
          this.onceMoreFormat(batchFactorList[0], key)
          return
        } else {
          let keyWords = []
          var factorData = {}
          factorData = this.format(batchFactorList[i]) // 处理公式不符合提交规范的内容并对公式进行检查是否复合格式
          if (!factorData.computeSign) {
            this.$message.error('运算符出错：' + factorData.sign)
            return
          }
          if (factorData.right !== factorData.left) {
            this.$message.error('表达式中左右括号不匹配，请修改后再提交')
            return
          }
          keyWords = factorData.keyWords
          for (let i = 0; i < keyWords.length; i++) {
            let index = this.zcList.indexOf(keyWords[i - 1])
            let index1 = this.keyWord.indexOf(keyWords[i])
            if (this.zcList.indexOf(keyWords[i]) > -1) {
              this.hide_nan = true
              localStorage.setItem('hide_nan', this.hide_nan)
            }
            if (keyWords[i] && index1 < 0 && index < 0) { // 非资产括号前函数是否有对应函数
              let txt = '“' + keyWords[i] + '”' + '不是一个函数，请检查拼写是否正确'
              this.$message.error(txt)
              return
            }
          }
          let postFactor = factorData.factor
          let custom1 = factorData.custom1
          if (custom1 > 0 && this.is_save === true) {
            postFactor = this.nameInput + '=' + postFactor
          }
          var param = {
            index_info_list: this.indexInfoList,
            sector_list: this.sector_list,
            factor_str: factorData.factor,
            is_case: this.caseVisited,
            ticker_info_list: this.tickerInfoList,
            post_factor_str: postFactor
          }
          this.asset_list.push({
            assetItem: param, // 接口参数
            index_title: this.nameInput // 生成资产名或因子名
          })
        }
      }
      if (this.asset_list.length > 1) { // 只有一个资产或因子不进行循环
        this.assetIndex = 0
        this.forCheckFactor('factorData')
      }
    },
    onceMoreFormat (factor, key) { // 非批量生成因子再次对公式进行检测
      // console.log(factor)
      let keyWords = []
      var factorData = {}
      factorData = this.format(factor) // 处理公式不符合提交规范的内容并对公式进行检查是否符合格式
      // console.log(factorData)
      if (!factorData.computeSign) {
        this.$message.error('运算符出错：' + factorData.sign)
        return
      }
      if (factorData.right !== factorData.left) {
        this.$message.error('表达式中左右括号不匹配，请修改后再提交')
        return
      } // 下拉框选中数据替换公式中对应数据
      keyWords = factorData.keyWords
      for (let i = 0; i < keyWords.length; i++) {
        let index = this.zcList.indexOf(keyWords[i - 1])
        let index1 = this.keyWord.indexOf(keyWords[i])
        if (this.zcList.indexOf(keyWords[i]) > -1) {
          this.hide_nan = true
          localStorage.setItem('hide_nan', this.hide_nan)
        }
        if (keyWords[i] && index1 < 0 && index < 0) { // 括号前内容非函数是否有对应资产函数，其他函数是否是正确的
          let txt = '“' + keyWords[i] + '”' + '不是一个函数，请检查拼写是否正确'
          this.$message.error(txt)
          return
        }
      }
      let factorStr = factorData.factor
      // console.log(factorStr)
      // if (factorStr.indexOf('快速回测') > -1 && (factorStr.indexOf('板块(?)') > -1 || factorStr.indexOf('sector(?)') > -1)) { // 快速回测函数板块处理
      //   // console.log(this.sectorReplace(factorStr))
      //   factorStr = this.sectorReplace(factorStr)
      // }
      let question = factorStr.indexOf('(?')
      let keyText
      let custom = factorData.custom
      if (custom > 0 && question > -1 && factorStr.charAt(question + 2) !== ')') { // 是否包含?批量生成资产
        keyText = factorStr.substring(question + 2, factorStr.length)
        let wz = keyText.indexOf(')')
        keyText = keyText.substring(0, wz)
        this.getFactorlist(keyText, factorStr, this.nameInput)
        return
      }
      let customFun = ['资产池收盘价(', 'multiClose(']
      for (let i = 0; i < customFun.length; i++) { // 是否资产池批量生成资产
        question = factorStr.indexOf(customFun[i])
        if (custom > 0 && question > -1 && factorStr.charAt(question + customFun[i].length) !== ')') {
          keyText = factorStr.substring(question + customFun[i].length, factorStr.length)
          let wz = keyText.indexOf(')')
          let customName = keyText.substring(0, wz)
          keyText = customFun[i] + customName + ')'
          this.getcustomlist(keyText, factorStr, this.nameInput, customName) // 匹配资产池相关资产，并生成list进行循环生成资产
          return
        }
        if (custom < 0 && question > -1) {
          this.$alert('当前操作不允许', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return
        }
      }
      // this.bus.$emit('factor', this.factorTextarea)
      var timeNow = this.getDate()
      if (this.time && timeNow > this.time) { // 与下方checkFactor时间内板块问号表达式对应，问号表达式检测成功后需等待20进行第二次检测
        var beginDate = new Date(Date.parse(this.time))
        var endDate = new Date(Date.parse(timeNow))
        var diff = endDate.getTime() - beginDate.getTime()
        var sec = diff / 1000
        if (sec < 20 && (this.factorTextarea.indexOf('板块(?)') > -1 || this.factorTextarea.indexOf('sector(?)') > -1)) {
          let ss = 20 - sec
          let text = '您已提交带有问号表达式的任务，请等待' + ss + '秒后再次提交'
          this.$alert(text, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          return
        }
      }
      let postFactor = factorStr
      let custom1 = factorData.custom1
      // console.log(custom)
      if (custom > 0) {
        postFactor = this.nameInput + '->' + postFactor
      } else if (custom1 > 0 && this.is_save === true) {
        postFactor = this.nameInput + '=' + postFactor
      }
      this.factorTextarea = postFactor
      // console.log(factorStr, postFactor, key)
      this.checkFactor(factorStr, postFactor, key)
    },
    sectorReplace (factorStr) { // 快速回测替换
      // console.log(factorStr)
      factorStr = factorStr.substring(4, factorStr.length - 1)
      // var regex = /板块\([^)]+\)/
      factorStr = factorStr.replace(/板块\([^)]+\)/g, '板块(?)')
      factorStr = factorStr.replace(',板块(?)', ')板块(?)')
      // console.log(factorStr)
      factorStr = factorStr.replace(/sector\([^)]+\)/g, 'sector(?)')
      factorStr = factorStr.replace(',sector(?)', ')sector(?)')
      // console.log(factorStr)
      return factorStr
    },
    getFactorlist (key, factorStr, name) { // 匹配?资产关键字
      var _this = this
      getRequest('/ticker/getAssetList', { key: key }).then(function (x) {
        if (!x.data.message) {
          var results = x.data.data
          let keyText = '?' + key
          for (let i = 0; i < results.length; i++) {
            let assetItem = {
              index_info_list: _this.indexInfoList,
              sector_list: _this.sector_list,
              is_case: false
            }
            let text = factorStr
            if (!results[i].asset_type || results[i].asset_type !== 'index_info') {
              text = text.split(keyText).join(results[i].name)
              _this.tickerInfoList[results[i].name] = results[i].ticker
              assetItem.ticker_info_list = _this.tickerInfoList
              assetItem.factor_str = text
              let indexTitle = name + '(' + results[i].name + ')'
              let postFactor = indexTitle + '->' + text
              assetItem.post_factor_str = postFactor
              _this.asset_list.push({ assetItem: assetItem, index_title: indexTitle, name: name })
            }
            if (_this.asset_list.length > 300) {
              _this.asset_list = []
              _this.$alert('匹配资产超过300，请将需匹配资产名修改得具体一些', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              })
              return
            } else if (_this.asset_list.length < 1) {
              _this.asset_list = []
              _this.$alert('无匹配资产，请修改...', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              })
              return
            }
          }
          if (_this.asset_list.length === 1) {
            let postFactor = _this.asset_list[0].assetItem.factor_str
            postFactor = _this.nameInput + '->' + _this.asset_list[0].assetItem.factor_str
            _this.factorTextarea = postFactor
            _this.checkFactor(_this.asset_list[0].assetItem.factor_str, postFactor)
            return
          }
          _this.assetIndex = 0
          _this.forCheckFactor('assetData')
        }
      })
    },
    getcustomlist (key, factorStr, name, customName) { // 匹配资产池相关资产，并生成list进行循环生成资产
      var _this = this
      getRequest('/customLabel/getLableName', { keyword: customName }).then(function (y) {
        if (!y.data.message) {
          if (!y.data.data.length) {
            let tips = `请检查字符串语法是否正确：<br/>${factorStr}`
            _this.$alert(tips, '公式解析失败', {
              dangerouslyUseHTMLString: true
            })
            return
          }
          var result = y.data.data[0]
          getRequest('/customLabel/getStockList', { _id: result._id }).then(function (x) {
            if (!x.data.message) {
              var results = x.data.data['stocks']
              for (let i = 0; i < results.length; i++) {
                let assetItem = {
                  index_info_list: _this.indexInfoList,
                  sector_list: _this.sector_list,
                  is_case: false
                }
                let text = factorStr
                text = text.split(key).join('收盘价(' + results[i].name + ')') // 关键字替换
                _this.tickerInfoList[results[i].name] = results[i].ticker // 资产名对应id或ticker
                assetItem.ticker_info_list = _this.tickerInfoList
                assetItem.factor_str = text
                let indexTitle = name + '(' + results[i].name + ')'
                var postFactor = text
                postFactor = indexTitle + '->' + text
                assetItem.postFactor = postFactor
                _this.asset_list.push({
                  assetItem: assetItem, // 接口参数
                  index_title: indexTitle, // 生成资产名
                  name: name
                })
              }
              if (_this.asset_list.length === 1) { // 只有一个资产不进行循环
                _this.factorTextarea = postFactor
                // 会调取 /refactor/checkFactor
                // 之后会调取 /refactor/getIndexInfoByExpressionId， 触发detectionSuccess 的值，触发深度监听
                // 会调取 switchOneClick（）
                _this.checkFactor(_this.asset_list[0].assetItem.factor_str, postFactor)
                return
              } else if (_this.asset_list.length < 1) {
                _this.asset_list = []
                _this.$alert('无匹配资产，请修改...', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                })
                return
              }
              _this.assetIndex = 0
              _this.forCheckFactor('assetData')
            }
          })
        }
      })
    },
    forCheckFactor (key) { // 和checkFactor差不多，用于批量生成资产，检测成功后会进行检测资产名是否可以使用，再进行保存
      console.log('🚀 ~ file: reconstructionItem.vue:3879 ~ forCheckFactor ~ key:', key)
      var _this = this
      this.customDisabled = true
      this.is_save = false
      let params = this.asset_list[this.assetIndex].assetItem
      if (this.$route.path === '/factorBase') {
        params.index_info_list = Object.assign({}, params.index_info_list, this.handleParamsByIndexInfoList())
      }
      // 接口校验
      postRequest('/refactor/checkFactor', params).then(async function (x) {
        _this.customDisabled = false
        if (x.data.message) {
          _this.assetData = {}
          return
        }
        // 成功返回
        if (x.data.data.status === 'success') {
          // 更新当前的数据为，重构因子代码编辑器历史列表的最新节点
          _this.refactorHistoryLength = 0
          _this.checkFactorData = x.data.data
          _this.customDisabled = true
          _this.rightBlockType = ''
          if (x.data.data.is_json) {
            _this.rightBlockType = 'is_json'
            _this.getJsonData(x.data.data.expression_id)
            return
          }
          // 是否为表格数据，如果是表格数据会跳转到 数据详情tab
          if (_this.checkFactorData.is_matrix) {
            _this.activeName1 = 'second'
            _this.checkFactorData.is_commit = false
            getDataWithStatus('/matrixInfo/getMatrixInfoByExpressionId', 'getMatrixInfoByExpressionId', { id: _this.checkFactorData.expression_id }, ['matrixData', 'fileStatus'], 1000, 20, _this)
          } else {
            // 非制表（图），先取图相关id
            // 轮询获取indexInfo_id，通过该id保存该资产
            getDataWithStatus('/refactor/getIndexInfoByExpressionId', 'getIndexInfoByExpressionId', { expression_id: _this.checkFactorData.expression_id }, [key, 'fileStatus', 'dataByExpressionId'], 1000, 20, _this)
          }
        } else if (x.data.data.status === 'tltle_chongfu') {
          _this.$alert('已存在相同标题数据', '错误', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
        } else if (x.data.data.status === 'error') {
          // 失败
          _this.dialogVisible = true
          _this.msgData = x.data.data.msg
          _this.selectOption()
        } else if (x.data.data.status === 'ticker_error') {
          // 资产多选下拉框
          _this.dialogVisible = true
          _this.msgData = x.data.data.msg
          for (let i = 0; i < _this.msgData.length; i++) {
            if (_this.msgData[i].status === 'clarify') {
              _this.msgData[i].status = 'ticker_error'
            }
          }
          _this.msgData = _this.uniqueTitle(_this.msgData)
          _this.selectOption()
        } else if (x.data.data.status === 'factor_error') {
          // 公式解析失败
          _this.$alert(x.data.data.error_msg, '错误', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
        }
      })
    },
    // TODO:执行多行因子，同名因子会出现打算弹窗提示的情况，需要根据当前登录人默认执行操作。
    handleParamsByIndexInfoList () {
      const _indexInfoList = {}
      if (this.asset_list && this.asset_list.length) {
        this.asset_list.forEach(element => {
          const { id, index_title: title } = element
          if (id != null && title != null) {
            _indexInfoList[title] = id
          }
        })
      }
      return _indexInfoList
    },

    checkFactor (factorTextarea, postFactor, key) {
      this.assetData = {}
      this.loading = true
      this.loading1 = true
      this.loading2 = true
      this.clearLine()
      var param = {
        index_info_list: this.indexInfoList,
        sector_list: this.sector_list,
        factor_str: factorTextarea,
        is_case: this.caseVisited,
        ticker_info_list: this.tickerInfoList,
        post_factor_str: postFactor
      }
      if (this.caseVisited === true) {
        param.index_info_list = {}
      }
      var _this = this
      this.customDisabled = true
      this.disabled = true

      if (this.$route.path === '/factorBase') {
        param.index_info_list = Object.assign({}, param.index_info_list, this.handleParamsByIndexInfoList())
      }
      // 检测重构因子
      postRequest('/refactor/checkFactor', param).then(async function (x) {
        // _this.factorTextarea = postFactor
        _this.customDisabled = false
        _this.disabled = false
        if (_this.activeName1 === 'first') {
          _this.loading2 = false
        }
        if (x.data.message) {
          _this.detectionVisited = false
          _this.detectionSuccess = {}
          return
        } else if (x.data.data.status !== 'success') {
          _this.detectionVisited = false
          _this.loading2 = false
        }
        if (x.data.data.status === 'success') {
          _this.detectionVisited = true
          _this.msgData = []
          _this.replaceList = {} // 下拉框选中数据替换公式中对应数据列表
          _this.refactorHistoryLength = 0 // 输入框切换位置参数
          _this.checkFactorData = x.data.data
          _this.rightBlockType = ''
          if (x.data.data.is_json) {
            _this.rightBlockType = 'is_json'
          }
          if (_this.checkFactorData.is_matrix) { // 制表函数
            _this.detectionSuccess = _this.checkFactorData
            _this.detectionSuccess.is_commit = false
            _this.detectionSuccess.matrixinfo_id = _this.detectionSuccess._id
            _this.activeName1 = 'second' // 切换到表格
            _this.recordActive = 'table' // 切换制表记录tab
            let numOfItems = _this.matrixTreePage * 10
            _this.getTreeMatrixList(numOfItems) // 获取制表记录更新列表
            getDataWithStatus('/matrixInfo/getMatrixInfoByExpressionId', 'getMatrixInfoByExpressionId', { id: _this.checkFactorData.expression_id }, ['matrixData', 'fileStatus'], 1000, 20, _this) // 轮询获取matrixInfo_id，通过该id获取图表
          } else { // 最近记录
            _this.recordActive = 'record' // 切换最近记录tab
            _this.detectionSuccess.use_utility = _this.checkFactorData.use_utility // 效用图是否显示
            if (_this.checkFactorData.is_multiple_search && !key) { // 是否为板块问号下切换板块
              _this.sectorData = _this.checkFactorData
            } else if (!key) {
              _this.sectorData = {}
            }
            if (_this.factorTextarea.indexOf('板块(?)') > -1 || _this.factorTextarea.indexOf('sector(?)') > -1) { // 板块问号表达式需等待20秒后才能点击第二次
              _this.time = _this.getDate()
            }
            let numOfItems = _this.treePage * 10
            await _this.getTreeList(numOfItems) // 获取最近记录更新列表
            if (!x.data.data.is_json) {
              getDataWithStatus('/refactor/getIndexInfoByExpressionId', 'getIndexInfoByExpressionId', { expression_id: _this.checkFactorData.expression_id }, ['detectionSuccess', 'fileStatus'], 1000, 20, _this, () => {
                console.log('callback')
                console.log('最后一个啦')
                // 判断公式数组有没有值，有的话执行
                // if (_this.batchFormula.length) {
                //   for (let i = _this.batchFormula.length - 1; i >= 0; i--) {
                //     const str = _this.batchFormula[i]
                //     _this.onceMoreFormat(str, key)
                //     _this.batchFormula.pop()
                //   }

                //   console.log(_this.batchFormula.length);
                // }
              }) // 轮询获取indexInfo_id，通过该id获取图表
            }
          }
          _this.msgData = x.data.data.msg
          _this.selectOption()

          await _this.getJsonData(x.data.data.expression_id)
          _this.getRecordFactorList()
          let numOfItems = _this.treePage * 10
          await _this.getTreeList(numOfItems) // 获取最近记录更新列表
        } else if (x.data.data.status === 'tltle_chongfu') {
          _this.$alert('已存在相同标题数据', '错误', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
        } else if (x.data.data.status === 'error') {
          _this.dialogVisible = true
          _this.msgData = x.data.data.msg
          _this.selectOption()
        } else if (x.data.data.status === 'ticker_error') {
          _this.dialogVisible = true
          _this.msgData = x.data.data.msg
          for (let i = 0; i < _this.msgData.length; i++) {
            if (_this.msgData[i].status === 'clarify') {
              _this.msgData[i].status = 'ticker_error'
            }
          }
          _this.msgData = _this.uniqueTitle(_this.msgData)
          _this.selectOption()
        } else if (x.data.data.status === 'factor_error') {
          _this.$alert(x.data.data.error_msg, '错误', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
        }
      })
    },
    getDate () {
      const myDate = new Date()
      const year = myDate.getFullYear()
      const month = myDate.getMonth() + 1
      const date = myDate.getDate()
      const h = myDate.getHours()
      const m = myDate.getMinutes()
      const s = myDate.getSeconds()
      var time =
        year.toString() + '-' +
        this.convert(month).toString() + '-' +
        this.convert(date).toString() +
        ' ' +
        this.convert(h) +
        ':' +
        this.convert(m) +
        ':' +
        this.convert(s)
      return time
    },
    convert (val) {
      return val < 10 ? '0' + val : val
    },
    getFactorStrHistory () { // 输入框前后切换，因子检测历史记录
      var _this = this
      getRequest('/refactor/getFactorStrHistory').then(function (x) {
        if (!x.data.message) {
          _this.factorCheckHistory = x.data.data
          _this.factorHistoryLength = -1
        }
      })
    },
    selectOption () { // 解析检测/效用公式检测内容包含参数的下拉选项
      var _this = this
      if (this.curveVisible === false) { // 非帮助文档教程内容
        for (let i = 0; i < this.msgData.length; i++) {
          this.msgData[i].selectOptions = []
          if (this.msgData[i].title.length < 1) {
            break
          }
          let results = []
          let result = []
          let flag = 0 // 判断优先级
          if (this.msgData[i].status === 'match') { // 检测成功的数据
            getTimeSeriesRequest('dataAndTagSearch', { key: this.msgData[i].title, fields: 'indexinfo' }).then(function (x) {
              results = x.data.data.search_data
              if (results.length > 0) {
                for (var j = 0; j < results.length; j++) {
                  if (results[j].data_type !== 'func_info') { // 非函数
                    if (results[j].user_info) {
                      results[j].value = results[j].index_title + '    ' + results[j].user_info.realName + '    ' + results[j].table_name
                    } else {
                      results[j].value = results[j].index_title + '    ' + results[j].index_source_name + '    ' + results[j].table_name
                    }
                    result.push(results[j])
                    if (flag !== 3) {
                      if (_this.indexInfoList && _this.msgData[i] && _this.indexInfoList[_this.msgData[i].title] === results[j]._id) { // 最高优先级id相同
                        _this.msgData[i].selectValue = results[j].value
                        flag = 3
                      } else if (_this.msgData[i] && _this.msgData[i].selectValue === results[j].value && flag < 3) { // 第二优先级value（名称及来源）相同
                        flag = 2
                      } else if (_this.msgData[i].match_title === results[j].index_title && flag < 2) { // 第三优先级名称相同
                        _this.msgData[i].selectValue = results[j].value
                        flag = 1
                      }
                    }
                  }
                }
                if (flag === 0) {
                  _this.msgData[i].selectValue = ''
                }
                _this.msgData[i].selectOptions = result
              } else {
                _this.msgData[i].selectValue = ''
              }
            })
          } else if (this.msgData[i].status === 'clarify') { // 检测需要选择的数据
            getTimeSeriesRequest('dataAndTagSearch', { key: this.msgData[i].title, fields: 'indexinfo' }).then(function (x) {
              results = x.data.data.search_data
              if (results.length > 0) {
                for (var j = 0; j < results.length; j++) {
                  if (results[j].data_type !== 'func_info') {
                    if (results[j].user_info) {
                      results[j].value = results[j].index_title + '    ' + results[j].user_info.realName
                    } else {
                      results[j].value = results[j].index_title + '    ' + results[j].index_source_name
                    }
                    result.push(results[j])
                    if (flag !== 3) {
                      if (_this.indexInfoList[_this.msgData[i].title] === results[j]._id) {
                        _this.msgData[i].selectValue = results[j].value
                        flag = true
                      } else if (_this.msgData[i].selectValue === results[j].value && flag < 3) {
                        flag = true
                      } else if (_this.msgData[i].match_title === results[j].index_title && flag < 2) {
                        _this.msgData[i].selectValue = results[j].value
                        flag = true
                      }
                    }
                  }
                }
                _this.msgData[i].selectOptions = result
                if (flag === 0) {
                  _this.msgData[i].selectValue = ''
                }
              } else {
                _this.msgData[i].selectValue = ''
              }
            })
          } else if (this.msgData[i].status === 'ticker_error') { // 检测多选的股票
            getRequest('/ticker/getAssetList', { key: this.msgData[i].title }).then(function (x) {
              results = x.data.data
              if (results.length > 0) {
                for (var j = 0; j < results.length; j++) {
                  results[j].value = results[j].code + '    ' + results[j].name
                  if (flag === 0 && _this.tickerInfoList[_this.msgData[i].title] && _this.tickerInfoList[_this.msgData[i].title] === results[j].ticker) {
                    _this.msgData[i].selectValue = results[j].value
                    flag = 1
                  }
                }
                if (flag === 0) {
                  _this.msgData[i].selectValue = ''
                }
                _this.msgData[i].selectOptions = results
              } else {
                _this.msgData[i].selectValue = ''
              }
            })
          }
        }
      } else { // 效用公式检测
        for (let i = 0; i < this.useMsgData.length; i++) {
          if (this.useMsgData[i].status === 'clarify') { // 检测需要选择的数据
            this.useMsgData[i].selectValue = ''
            this.useMsgData[i].selectOptions = []
            let results = []
            getTimeSeriesRequest('dataAndTagSearch', { key: this.useMsgData[i].title, fields: 'indexinfo' }).then(function (x) {
              results = x.data.data.search_data
              if (results.length > 0) {
                for (var j = 0; j < results.length; j++) {
                  results[j].value = results[j].index_title + '     ' + results[j].index_source_name
                }
              }
              _this.useMsgData[i].selectOptions = results
            })
          }
        }
      }
    },
    getRecordFactorList (key) { // 切换最近记录和制表记录tab
      if (key) {
        this.recordActive = key
        this.recordLastItem = {}
      }
      // console.log(this.recordActive)
      if (this.recordActive === 'record') {
        this.recordFactorList = this.allFactorList
        this.recordTotNum = this.totNum
      } else {
        this.recordFactorList = this.matrixFactorList
        this.recordTotNum = this.matrixTotNum
      }
      // console.log(this.recordFactorList)
    },
    getSeveralList (x, key) { // 最近记录/制表记录需要更新状态的记录
      if (x.length > 0) {
        var ids = []
        var indexs = []
        for (let i = 0; i < x.length; i++) {
          x[i].addLine = false
          x[i].yAxisIndex = false
          if (x[i] && x[i].status === 'ok') {
            ids.push(x[i]._id)
            indexs.push(i)
          }
        }
        if (ids.length > 0) {
          if (key === 'matrix') {
            this.getMatrixTrees(ids, indexs)
          } else {
            this.getSeveralTrees(ids, indexs)
          }
        }
      }
    },
    addMatrixRefactorList (numOfItems, startItem, wz) { // 制表记录增加记录更新列表
      var _this = this
      getRequest('/refactor/getTreeList', { numOfItems: numOfItems, startItem: startItem, is_matrix: true }).then(function (x) {
        if (!x.data.message) {
          _this.matrixTotNum = x.data.data.tot_num
          var addData = x.data.data.tree_list
          for (let i = 0; i < addData.length; i++) {
            addData[i].addLine = false
            addData[i].yAxisIndex = false
          }
          var list = []
          var allList = _this.matrixFactorList
          if (wz === 'top') {
            list = addData.concat(allList)
          } else {
            list = allList.concat(addData)
          }
          _this.matrixFactorList = list
          clearTimeout(_this.timerMatrix)
          _this.getSeveralList(_this.matrixFactorList, 'matrix')
          _this.getRecordFactorList()
        }
      })
    },
    getMatrixTrees (ids, wz, key, time) { // 制表记录状态更新
      // console.log(ids)
      var _this = this
      clearTimeout(this.timerMatrix)
      postRequest('/refactor/getSeveralTrees', { ids: ids }).then(function (x) {
        if (!x.data.message) {
          var list = x.data.data
          var items = []
          var indexs = []
          var allList = _this.matrixFactorList
          _this.matrixFactorList = []
          for (let i = 0; i < wz.length; i++) {
            allList[wz[i]] = list[i]
            if (list[i] && list[i].status && list[i].status === 'ok') {
              items.push(list[i]._id)
              indexs.push(wz[i])
            }
            if (time) {
              if (key === 'getSeveralTrees') {
                time = time * 1.3
              }
            } else {
              time = 2000
            }
            _this.matrixFactorList = allList
            if (items.length > 0) {
              clearTimeout(_this.timerMatrix)
              _this.timerMatrix = setTimeout(() => {
                _this.getMatrixTrees(items, indexs, 'getSeveralTrees', time)
              }, time)
            }
          }
        }
      })
    },
    getTreeMatrixList (numOfItems) { // 制表记录列表
      var _this = this
      clearTimeout(this.timerMatrix)
      var numOfItem = numOfItems
      if (!numOfItem) {
        numOfItem = 10
      }
      getRequest('/refactor/getTreeList', { numOfItems: numOfItem, startItem: 0, is_matrix: true }).then(function (x) {
        if (!x.data.message) {
          _this.matrixTotNum = x.data.data.tot_num
          _this.matrixFactorList = x.data.data.tree_list
          _this.getSeveralList(_this.matrixFactorList, 'matrix')
          _this.getRecordFactorList()
        }
      })
    },
    load () { // 最近记录/制表记录上拉加载
      if (this.recordActive === 'table') {
        if (this.matrixTotNum && this.matrixTotNum <= this.matrixTreePage * 10) {
          return
        }
        this.matrixTreePage = this.matrixTreePage + 1
        let numOfItems = 10
        let startItem = this.matrixTreePage * 10
        this.addMatrixRefactorList(numOfItems, startItem, 'bottom')
      } else {
        if (this.totNum && this.totNum <= this.treePage * 10) {
          return
        }
        this.treePage = this.treePage + 1
        let numOfItems = 10
        let startItem = this.treePage * 10
        this.addRefactorList(numOfItems, startItem, 'bottom')
      }
    },
    addRefactorList (numOfItems, startItem, wz) { // 最近记录增加记录更新列表
      var _this = this
      getRequest('/refactor/getTreeList', { numOfItems: numOfItems, startItem: startItem, is_matrix: false }).then(function (x) {
        if (!x.data.message) {
          _this.totNum = x.data.data.tot_num
          var addData = x.data.data.tree_list
          for (let i = 0; i < addData.length; i++) {
            addData[i].addLine = false
            addData[i].yAxisIndex = false
          }
          var list = []
          var allList = _this.allFactorList
          if (wz === 'top') {
            list = addData.concat(allList)
          } else {
            list = allList.concat(addData)
          }
          _this.allFactorList = list
          clearTimeout(_this.timerTwo)
          _this.getSeveralList(_this.allFactorList, 'all')
          _this.getRecordFactorList()
        }
      })
    },
    getSeveralTrees (ids, wz, key, time) { // 最近记录状态更新
      var _this = this
      clearTimeout(this.timerTwo)
      postRequest('/refactor/getSeveralTrees', { ids: ids }).then(function (x) {
        if (!x.data.message) {
          var list = x.data.data
          var items = []
          var indexs = []
          var allList = _this.allFactorList
          _this.allFactorList = []
          for (let i = 0; i < wz.length; i++) {
            allList[wz[i]] = list[i]
            if (list[i] && list[i].status && list[i].status === 'ok') {
              items.push(list[i]._id)
              indexs.push(wz[i])
            }
            if (time) {
              if (key === 'getSeveralTrees') {
                time = time * 1.3
              }
            } else {
              time = 2000
            }
            _this.allFactorList = allList
            if (items.length > 0) {
              clearTimeout(_this.timerTwo)
              _this.timerTwo = setTimeout(() => {
                _this.getSeveralTrees(items, indexs, 'getSeveralTrees', time)
              }, time)
            }
          }
        }
      })
    },
    async getTreeList (numOfItems) { // 最近记录列表
      var _this = this
      clearTimeout(this.timerTwo)
      var numOfItem = numOfItems
      if (!numOfItem) {
        numOfItem = 10
      }
      await getRequest('/refactor/getTreeList', { numOfItems: numOfItem, startItem: 0, is_matrix: false }).then(function (x) {
        if (!x.data.message) {
          _this.totNum = x.data.data.tot_num
          _this.allFactorList = x.data.data.tree_list
          _this.getSeveralList(_this.allFactorList, 'all')
          _this.getRecordFactorList()
        }
      })
    },
    getSupportFunctionByGroup () { // 函数及函数分组
      var _this = this
      getRequest('/userConfig/getSupportFunctionByGroup').then(function (x) {
        if (!x.data.message) {
          _this.functionGroupList = x.data.data
          _this.functionTitleId = _this.functionGroupList[0]._id
          let keyList = []
          for (let i = 0; i < _this.functionGroupList.length; i++) {
            var support = _this.functionGroupList[i].support_functions
            for (let j = 0; j < support.length; j++) {
              keyList.push(support[j].title)
              keyList.push(support[j].title_chinese)
            }
          }
          _this.keyWord = keyList
          _this.getTreeList()
          _this.getTreeMatrixList()
          _this.getUtilityList()
          _this.getFactorStrHistory()
          _this.getListByGroup()
          _this.getAssetList()
          _this.getRefactorCurveSetting()
          _this.getLableName()
          _this.getUtilityAssetList()
          setTimeout(() => {
            _this.getChongGouItem()
          }, 500)
        }
      })
    },
    getChongGouItem () {
      if (Object.keys(this.chongGouItem).length > 0) {
        this.factorItem = ''
        this.factorTextarea = ''
        // 来源于 因子库-弹窗内-点击 进入重构
        if (this.chongGouItem.orgType != null && this.chongGouItem.orgType === 'factorBase') {
          this.addItem(this.chongGouItem.factorBaseStr)
          return
        }
        if (!this.chongGouItem.min_value && this.chongGouItem.indexInfo) {
          this.chongGouItem.min_value = this.chongGouItem.indexInfo.min_value
          this.chongGouItem.max_value = this.chongGouItem.indexInfo.max_value
        }
        if (this.chongGouItem.is_refract === true) {
          let factorStr = this.chongGouItem.templateExpressionTree.factor_str
          if (this.chongGouItem.index_title) {
            factorStr = this.chongGouItem.index_title + '=' + factorStr
          }
          this.addItem(factorStr, this.chongGouItem.templateExpressionTree.index_info_list, this.chongGouItem.templateExpressionTree.sector_list)
        } else {
          let title = '"' + this.chongGouItem.index_title + '"'
          this.addItem(title, this.chongGouItem.index_info_list, this.chongGouItem.sector_list)
        }
      }
      if (this.detectionSuccess._id && !this.detectionSuccess.is_matrix) {
        this.detectionVisited = true
        this.loading = true
        this.loading1 = true
        console.log('detailDat7')
        getDataWithStatus('/timeSeries/requestIndexDetail', 'requestIndexDetail', { id: this.detectionSuccess.indexinfo_id }, ['detailData', 'fileStatus'], 1000, 20, this)
        if (this.detectionSuccess.use_utility === true) {
          getDataWithStatus('/refactor/getUtilityCurveData', 'getUtilityCurveData', { id: this.detectionSuccess.utility_result_id }, ['utilityCurveData', 'fileStatus'], 1000, 20, this)
        } else {
          this.loading1 = false
        }
      }
    },
    getListByGroup () { // 常用模板、我的模板
      var _this = this
      getRequest('/refactorFormat/getListByGroup').then(function (x) {
        if (!x.data.message) {
          _this.formatGroupList = x.data.data
        }
      })
    },
    getUtilityList () { // 效用公式
      var _this = this
      getRequest('/utilityExpression/getList').then(function (x) {
        if (!x.data.message) {
          _this.utilityList = x.data.data
        }
      })
    },
    getCaseList () { // 帮助文档-教程
      var _this = this
      getRequest('/refactorCase/caseList', { search: this.searchInput }).then(function (x) {
        if (!x.data.message) {
          _this.caseList = x.data.data
        }
      })
    },
    getUtilityAssetList () { // 所有资产（包含板块，我的资产）
      var _this = this
      getRequest('/userConfig/utilityAssetList').then(function (x) {
        if (!x.data.message) {
          _this.utilityAssetList = x.data.data
        }
      })
    },
    getAssetList () { // 获取板块
      var _this = this
      getRequest('/userConfig/assetList').then(function (x) {
        if (!x.data.message) {
          _this.banKuaiData = x.data.data
        }
      })
    },

    // 一维分割曲线图
    // 当曲线对比途中，出现 0，1一维和其它曲线图表时候，找到交点，根据每个交点，重新绘制曲线图
    onOneDimensionalGraph () {
      this.oneDimensionalDialogLimit = 60
      // 获取echart图表数据
      const factorLineRef = this.$refs.factorLine
      const { series, xAxis } = factorLineRef.getEchartOption()
      // 图表数据至少要有两条
      if (series != null && series.length > 1) {
        const _series = cloneDeep(series)
        const barData = _series.find(v => v.type === 'bar')
        const otherSeries = _series.filter(v => v.type !== 'bar')
        if (barData != null) {
          this.showOneDimensionalDialog = true
          // 找到柱状图的 标线 （也就是 0，1 竖线和其它曲线图的交点X轴的值）
          const { markLine } = barData
          if (markLine != null && markLine.data != null && markLine.data.length) {
            // 获取X轴的点
            const markLineData = markLine.data.map(v => v.xAxis)
            // 整个图表的X轴的数值集合
            const orgXAxis = xAxis && xAxis.length && xAxis[0].data
            // 根据每一个X轴的点，作为起点，重新绘制曲线，最大60天
            this.redrawCurveByDate(markLineData, otherSeries, orgXAxis)
          }
        } else {
          this.$message('对比曲线中，需要有1条一维柱状图')
        }
      } else {
        this.$message('请添加曲线对比后在使用此功能')
      }
    },

    initOneDimensionalGraph (type = '') {
      // 获取echart图表数据
      const factorLineRef = this.$refs.factorLine
      const { series, xAxis } = factorLineRef.getEchartOption()
      // 图表数据至少要有两条
      if (series != null && series.length > 1) {
        const _series = cloneDeep(series)
        const _xAxis = cloneDeep(xAxis)
        const barData = _series.find(v => v.type === 'bar')
        const otherSeries = _series.filter(v => v.type !== 'bar')
        if (barData != null) {
          // 找到柱状图的 标线 （也就是 0，1 竖线和其它曲线图的交点X轴的值）
          const { markLine } = barData
          if (markLine != null && markLine.data != null && markLine.data.length) {
            // 获取X轴的点
            const markLineData = markLine.data.map(v => v.xAxis)
            // 整个图表的X轴的数值集合
            const orgXAxis = _xAxis && _xAxis.length && _xAxis[0].data
            if (type === 'forward') {
              this.handleOneDimensionalXAxis(markLineData, otherSeries, orgXAxis)
            } else {
              // 根据每一个X轴的点，作为起点，重新绘制曲线，最大60天
              this.redrawCurveByDate(markLineData, otherSeries, orgXAxis)
            }
          }
        }
      }
    },

    // 根据传入的X轴作为起点，重新计算曲线数据曲线
    // xAxisDots: X轴，每一个元素都是一个起点
    // otherSeries: 除了当前 0,1数据的其它曲线的图表数据
    // orgXAxis: 整个图表的X轴的数值集合
    redrawCurveByDate (xAxisDots, otherSeries, orgXAxis) {
      this.oneDimensionalDialogData = []

      // 先找到每一个需要重新计算的X轴起点，在整个图表的X轴的索引位置
      let indexes = xAxisDots.map(value => orgXAxis.indexOf(value))
      console.log('redrawCurveByDate ~ indexes >>>>>>>:', indexes)

      indexes.forEach(startIndex => {
        otherSeries.forEach((series, seriesIndex) => {
          if (series && series.data && series.data.length) {
            // 根据X轴对图表数据进行截取，最大值60天，需要去掉当前值，此处+1
            const _seriesData = this.truncateArray(series.data, startIndex, this.oneDimensionalDialogLimit + 1)
            const _xAxisData = this.truncateArray(orgXAxis, startIndex, this.oneDimensionalDialogLimit + 1)
            if (_seriesData && _seriesData.length) {
              // 处理图表需要的option
              this.handleOneDimensionalOption(_xAxisData, this.handleComputCurveData(_seriesData), series.name)
            }
          }
        })
      })
    },

    // 一维图 - 往前X天
    handleOneDimensionalXAxis (xAxisDots, otherSeries, orgXAxis) {
      this.oneDimensionalDialogDataByLimitDay = []
      // 先找到每一个需要重新计算的X轴起点，在整个图表的X轴的索引位置
      // 竖线和横线相交点的集合
      let indexes = xAxisDots.map(value => orgXAxis.indexOf(value))

      indexes.forEach(startIndex => {
        otherSeries.forEach((series, seriesIndex) => {
          if (series && series.data && series.data.length) {
            // 根据X轴对图表数据进行截取
            const _seriesData = this.truncateArrayByForward(series.data, startIndex, this.oneDimensionalDialogLimitDay)
            const _xAxisData = this.truncateArrayByForward(orgXAxis, startIndex, this.oneDimensionalDialogLimitDay)
            if (_seriesData && _seriesData.length) {
              // 处理图表需要的option
              this.handleOneDimensionalOption(_xAxisData, _seriesData, 'forward')
            }
          }
        })
      })
    },

    // 一维图 - 往后X天
    truncateArrayByForward (arr, index, limit) {
      // 计算开始获取值的索引位置
      let startIndex = Math.max(index - limit, 0)

      // 获取从startIndex到index（不包含index，如果包含需要 index + 1）的数值
      let values = arr.slice(startIndex, index)
      // console.log('Values before Index:', values)
      return values
    },

    // 如果输入的数组长度小于等于最大长度，那么直接返回原数组；否则，使用 slice() 方法将数组截取为最大长度的子数组。
    truncateArray (arr, startIndex, maxLength) {
      if (arr.length <= maxLength) {
        return arr
      } else {
        return arr.slice(startIndex, startIndex + maxLength)
      }
    },

    // 如果是回报率曲线，需要，重新计算曲线图的数据，每一个值减掉初始值进行归零处理
    // seriesData: 图表的数据值
    handleComputCurveData (seriesData) {
      return seriesData
    },

    // 处理图表需要的数据配置项
    // _xAxisData: X轴，seriesData：图表的值，
    handleOneDimensionalOption (_xAxisData, seriesData, type = '') {
      const title = type === 'forward' ? _xAxisData[_xAxisData.length - 1] : _xAxisData[0]
      let optionItem = {
        show: true,
        saveImgTitle: `曲线图 - 分割点（${title}）`,
        yAxisDataTitle: '',
        xAxisMin: null,
        decimalPlaces: 4,
        mulNum: 1,
        seriesData: [
          {
            name: `分割点（${title}）`,
            data: seriesData,
            type: 'line',
            itemStyle: {
              color: '#c4181f' // 设置曲线的颜色
            },
            legendSelected: true
          }
        ],
        xAxisData: _xAxisData,
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              name: `曲线图 - 分割点（${title}）`,
              type: 'jpeg',
              pixelRatio: 2,
              excludeComponents: ['toolbox']
            }
          }
        }
      }

      if (type === 'forward') {
        this.oneDimensionalDialogDataByLimitDay.push(optionItem)
      } else {
        this.oneDimensionalDialogData.push(optionItem)
      }
    },

    // 切换往后X天时，重新计算数据
    onChangeByDay () {
      this.oneDimensionalDialogData = []
      this.initOneDimensionalGraph()
    },
    // 切换往前X天时，重新计算数据
    onChangeByLimitDay () {
      this.oneDimensionalDialogDataByLimitDay = []
      this.initOneDimensionalGraph('forward')
    },
    // 一维分割图弹窗 关闭
    onFactorLineDialogByOneClose () {
      this.showOneDimensionalDialog = false
      this.oneDimensionalDialogLimit = 60
      this.oneDimensionalDialogData = []
      this.oneDimensionalDialogLimitDay = 0
      this.oneDimensionalDialogDataByLimitDay = []
    }

  },
  watch: {
    assetData () {
      if (this.assetData._id) {
        if (this.assetData.dimension === 'two' && this.reconstructionSelect === '2') {
          this.$alert('二维数据不可提交为资产', '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          })
          this.asset_list = []
          this.customDisabled = false
        } else {
          this.asset_list[this.assetIndex].id = this.assetData._id
          this.reconstructionSelect = '2'
          this.nameInput = this.asset_list[this.assetIndex].index_title
          this.jiance('assetData')
        }
      }
    },
    // _this.forCheckFactor('factorData') -> 轮询的方法getDataWithStatus，这个方法里面对 key进行的更新 -> 当前组件深度监听 factorData
    factorData (data) {
      // 在 getDataWithStatus 中有将接口的返回值赋值给 factorData
      if (data._id) {
        this.asset_list[this.assetIndex].id = data._id
        // 提交的时候，默认选中 '提交为因子'
        this.reconstructionSelect = '1'
        this.nameInput = this.asset_list[this.assetIndex].index_title
        this.jiance('factorData')
      }
    },
    fileStatus () {
      if (this.fileStatus.statusMsg && this.fileStatus.statusMsg.length > 0) {
        this.customDisabled = false
        this.loading = false
        this.loading1 = false
        this.loading2 = false
        this.detectionVisited = true
        this.$message.error(this.fileStatus.statusMsg)
        if (this.fileStatus.name === 'getUtilityCurveData' || this.fileStatus.name === 'getUtilityTtestValue') {
          if (this.fileStatus.params && (this.fileStatus.params._id === this.detectionSuccess._id || this.fileStatus.params.indexinfo_id === this.detectionSuccess.indexinfo_id)) {
            this.fileStatusUtility = false
            var _this = this
            getRequest('/refactor/getUtilityCurveData', { id: this.detectionSuccess.utility_result_id, is_stop: true }).then(function (x) {
              if (!x.data.message) {
                _this.tagValue = x.data.data.asset_tag
                _this.utilityValue = x.data.data.utility_expression_id
              }
            })
          }
        } else {
          if (!this.detailData.labels || this.detailData.labels.length < 1) {
            this.allFlag = false
          }
        }
      }
    },
    // 深度监听 detectionSuccess | 有可能来自于 -> getDataWithStatus()
    detectionSuccess () {
      console.log('🚀 ~ file: reconstructionItem.vue:4537 ~ detectionSuccess ~ detectionSuccess:')
      if (this.detectionSuccess.index_id > -1) {
        this.fingerPrint = {}
        if (this.checkFactorData.is_commit === true || this.checkFactorData.is_commit === false) {
          this.detectionSuccess.is_commit = this.checkFactorData.is_commit
        }
        this.detectionSuccess.search = this.checkFactorData.search
        this.detectionSuccess.use_utility = this.checkFactorData.use_utility
        // this.detectionSuccess.useFactorHelper = this.checkFactorData.useFactorHelper
        this.detectionSuccess.factor_str = this.checkFactorData.factor_str
        this.detectionSuccess.utility_result_id = this.checkFactorData.utility_result_id
        this.detectionSuccess.is_multiple_search = this.checkFactorData.is_multiple_search
        this.detectionSuccess.is_matrix = this.checkFactorData.is_matrix
        this.detectionVisited = true
        this.detectionSuccess.index_info_list = this.indexInfoList
        this.detectionSuccess.ticker_info_list = this.tickerInfoList
        this.detectionSuccess.sector_list = this.sector_list
        this.detectionSuccess.indexinfo_id = this.detectionSuccess._id
        this.detectionSuccess.addLine = false
        this.detectionSuccess.yAxisIndex = false
        if (this.is_save === true) {
          if (this.detectionSuccess.dimension === 'two' && this.reconstructionSelect === '2') {
            this.$alert('二维数据不可提交为资产', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            })
            this.is_save = false
          } else {
            this.jiance()
          }
        }
        if (this.detectionSuccess.is_commit && this.detectionSuccess.index_info) {
          this.lineDetection = this.detectionSuccess.index_info.index_title
        } else if (this.detectionSuccess.name) {
          this.lineDetection = this.detectionSuccess.name
        } else {
          this.lineDetection = this.detectionSuccess.factor_str
        }
        if (this.detectionSuccess.is_multiple_search && this.detectionSuccess.is_multiple_search === true) {
          this.sectorData._id = this.detectionSuccess._id
        }
        if (this.detectionSuccess.search === true) {
          getDataWithStatus('/refactor/getSearchInfo', 'getSearchInfo', { id: this.detectionSuccess.indexinfo_id }, ['searchInfoData', 'fileStatus'], 1000, 20, this)
        }
        this.switchOneClick()
        if (this.detectionSuccess.use_utility === true) {
          this.use_utility = this.detectionSuccess.use_utility
          getDataWithStatus('/refactor/getUtilityCurveData', 'getUtilityCurveData', { id: this.detectionSuccess.utility_result_id }, ['utilityCurveData', 'fileStatus'], 1000, 20, this)
        } else {
          this.loading1 = false
        }
      }
      if (!this.detectionSuccess.is_matrix) {
        this.loading2 = false
      }
    },
    searchInfoData () {
      if (this.detectionSuccess && this.detectionSuccess.factor_str) {
        this.searchInfoData.templateExpressionTree.factor_str = this.detectionSuccess.factor_str
      }
      if (this.detectionSuccess && this.detectionSuccess.use_utility) {
        this.searchInfoData.templateExpressionTree.use_utility = this.detectionSuccess.use_utility
      }
      if (this.detectionSuccess.search === true) {
        this.detectionSuccess.modified_factor_str = this.searchInfoData.templateExpressionTree.modified_factor_str
      }
      if (this.detectionSuccess.is_multiple_search && this.detectionSuccess.is_multiple_search === true) {
        this.sectorData.modified_factor_str = this.searchInfoData.modified_factor_str
      }
    },
    matrixData () {
      if (this.matrixData._id) {
        this.loading = false
        this.detectionSuccess._id = this.matrixData._id
        this.detectionSuccess.matrixinfo_id = this.matrixData._id
        if (this.is_save === true) {
          this.jiance()
        }
        this.getFactorStrHistory()
        this.loading2 = false
      }
    },
    detailData () {
      if (this.detailData.graph_title) {
        this.loading2 = false
        this.nan_disabled = false
        if (this.detailData.is_bool === true && this.detailData.dimension !== 'two') {
          this.hide_zero = false
        }
        let value = this.detailData.values.filter(da => da !== null)
        if (value.length / this.detailData.values.length < 0.3) {
          this.hide_nan = true
          localStorage.setItem('hide_nan', this.hide_nan)
        }
        this.checkFactorData = JSON.parse(JSON.stringify(this.detectionSuccess))
        this.loading = false
        this.getFactorStrHistory()
      }
    },
    utilityCurveData () {
      this.utility_curve = []
      this.utility_dtes = []
      if (this.utilityCurveData.utility_curve) {
        this.loading1 = false
        if (this.utilityCurveData.utility_calculation === 'complete') {
          getDataWithStatus('/refactor/getUtilityTtestValue', 'getUtilityTtestValue', { id: this.detectionSuccess.utility_result_id }, ['utilityTtestValue', 'fileStatus'], 1000, 20, this)
          let utilityCurve = this.utilityCurveData.utility_curve
          let utilityDtes = this.utilityCurveData.utility_dtes
          // 去掉数据最前面连续为0的值，从第一个非0值开始显示
          let index = 0
          for (let i = 0; i < utilityCurve.length; i++) {
            if (utilityCurve[i] !== 0) {
              index = i
              break
            }
          }
          this.tagValue = this.utilityCurveData.asset_tag
          this.utilityValue = this.utilityCurveData.utility_expression_id
          this.utilityCurveData.utility_curve = utilityCurve.slice(index, utilityCurve.length)
          this.utilityCurveData.utility_dtes = utilityDtes.slice(index, utilityDtes.length)
          this.utilityCurveData.curve_repeat = [utilityCurve[0]]
          this.utilityCurveData.dtes_repeat = [utilityDtes[0]]
          for (let i = 1; i < utilityCurve.length; i++) {
            if (utilityCurve[i] !== utilityCurve[i - 1]) {
              this.utilityCurveData.curve_repeat.push(utilityCurve[i])
              this.utilityCurveData.dtes_repeat.push(utilityDtes[i])
            }
          }
          this.updataUtilityLine()
        }
      }
    },
    utilityTtestValue () {
      if (Object.keys(this.utilityTtestValue).length > 0) {
      }
    },
    chongGouItem (newVal, oldVal) {
      this.getChongGouItem()
    },
    chongGouVisited (newVal, oldVal) {
      console.log('detailDat1')
      this.chongGouVisited = newVal
      if (this.chongGouVisited === true) {
        this.nameInput = ''
        this.tishi = ''
        this.selectOption()
        this.getUtilityAssetList()
        clearTimeout(this.timerTwo)
        if (this.allFactorList.length > 0) {
          var ids = []
          var indexs = []
          for (let i = 0; i < this.allFactorList.length; i++) {
            if (this.allFactorList[i] && this.allFactorList[i].status === 'ok') {
              ids.push(this.allFactorList[i]._id)
              indexs.push(i)
            }
          }
          if (ids.length > 0) {
            this.getSeveralTrees(ids, indexs)
          }
        }
        if (this.detectionSuccess._id) {
          this.detectionVisited = true
          this.loading = true
          this.loading1 = true
          console.log('detailDat2')
          getDataWithStatus('/timeSeries/requestIndexDetail', 'requestIndexDetail', { id: this.detectionSuccess.indexinfo_id }, ['detailData', 'fileStatus'], 1000, 20, this)
          if (this.detectionSuccess.use_utility === true) {
            getDataWithStatus('/refactor/getUtilityCurveData', 'getUtilityCurveData', { id: this.detectionSuccess.utility_result_id }, ['utilityCurveData', 'fileStatus'], 1000, 20, this)
          } else {
            this.loading1 = false
          }
        }
      } else {
        this.detectionVisited = false
      }
    }
  },
  activated () {
    this.selectOption()
    this.getChongGouItem()
    this.getTreeList()
    this.getTreeMatrixList()
  }
}
</script>
<style scoped>
.reconstruction {
  text-align: left;
  display: flex;
}

.reconstruction >>> .el-dialog__body {
  padding: 0 20px !important;
}

.intelligent >>> .el-button-group >>> .el-button--danger:first-child {
  width: 125px;
  height: 60px;
}

.intelligent >>> .el-button-group >>> .el-button--danger:last-child {
  height: 60px;
}

.intelligent >>> .el-dropdown >>> .el-button-group >>> .el-button {
  float: left;
}

.list >>> .el-button {
  padding: 0;
}

.reconstruction th {
  border: 1px solid #dcdfe6;
  padding: 5px;
  box-sizing: border-box;
}

.reconstruction td {
  border-width: 1px;
  border-style: solid;
  border: 1px solid #dcdfe6;
  border-image: initial;
  padding: 5px;
  overflow: hidden;
  box-sizing: border-box;
}

.intelligent >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
}

.intelligent  >>> .el-input__icon {
  line-height: 30px;
}

.functionClass {
  background-color: #F7F7F7;
  color: #A4001B;
}

.icopy {
  width: 20px;
  height: 18px;
  opacity: 0;
}

.factorCopy {
  width: 100%;
  font-size: 14px;
  margin: 2px 0 2px 5px;
  background-color: #F2F2F2;
  padding: 2px 5px;
  margin-left: 10px;
  cursor: pointer;
}

.factorCopy:hover .icopy {
  opacity: 1;
}

.reconstruction-card >>> .el-card {
  border-radius: 0 0 10px 10px !important;
}

.reconstruction >>> .el-input-group__append,
.el-input-group__prepend {
  background-color: #FFF !important;
}

.reconstruction >>> .el-dialog {
  border-radius: 10px;
}

.reconstruction >>> .el-dropdown-link {
  cursor: pointer;
  color: #444444;
}

.reconstruction-box-out-1 {
  position: relative;
  border: 0.5px solid #DCDCDC;
  border-radius: 7px;
  background-color: #F8F8F8;
  width: 95px;
  height: 55px;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 10px;
}

.reconstruction-triangle-1 {
  background: linear-gradient(41deg, transparent 92px, #D8D8D8 0%);
  background-size: 95px 55px;
  border-top-right-radius: 4px;
}

.reconstruction-triangle-out {
  color: #FFF;
  height: 20px;
  text-align: right;
  font-size: 10px;
}

.reconstruction-strip {
  background-color: rgba(247, 247, 247, 1);
  height: 5px;
}

.reconstruction-border {
  padding: 15px 0;
  border-bottom: 1px solid #F7F7F7;
}

.reconstruction-border .el-input__icon {
  width: 15px;
  line-height: 20px;
}

.reconstruction-dialog-text {
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-style: italic;
}

.el-dropdown-menu__item {
  padding: 0px 5px 5px !important;
  width: 110px;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 30px !important;
}

.el-row {
  margin-bottom: 0 !important;
}

.errorClass >>> .el-dialog__headerbtn {
  top: 10px;
}

.errorClass >>> .el-dialog__header {
  padding: 10px;
  background-color: #A30014;
  /* border-radius: 10px 10px 0 0; */
}

.reconstruction-tab-top .factor-tabs >>> .el-textarea__inner {
  background-color: #F7F7F7;
  border: 1px solid #F7F7F7;
  border-radius: 10px;
}

.reconstruction-tab-top .factor-tabs >>> .el-textarea__inner:focus {
  border-color: #F7F7F7;
}

.reconstruction-tab-top .factor-tabs >>> .el-textarea__inner:hover {
  border-color: #F7F7F7;
}

.reconstruction-tab-top .factor-tabs >>> .temporary {
  background-color: #F7F7F7;
  border-radius: 10px;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--left >>> .el-tabs__header.is-left {
  float: left;
  margin-bottom: 0;
  margin-right: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--left >>> .el-tabs__nav-wrap.is-left::after,
.el-tabs--left >>> .el-tabs__nav-wrap.is-right::after,
.el-tabs--right >>> .el-tabs__nav-wrap.is-left::after,
.el-tabs--right >>> .el-tabs__nav-wrap.is-right::after {
  width: 100%;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__nav-wrap::after {
  background-color: #333;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--left >>> .el-tabs__nav-wrap.is-left {
  margin-right: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--left >>> .el-tabs__active-bar.is-left,
.el-tabs--left >>> .el-tabs__active-bar.is-right,
.el-tabs--right >>> .el-tabs__active-bar.is-left,
.el-tabs--right >>> .el-tabs__active-bar.is-right {
  width: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__nav-scroll {
  overflow: hidden;
  border: 1px solid #E4E7ED;
  background-color: #F7F7F7;
  border-radius: 10px 10px 0 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--card>.el-tabs__header .el-tabs__nav {
  background-color: #f7f7f7;
  border: 0;
}

.reconstruction-tab-top .factor-tabs  >>> .el-tabs__item {
  color: #666;
  border-radius: 4px 4px 0 0;
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  border-right: 1px solid #E3E3E3;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__item:hover {
  color: #666;
  cursor: pointer;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__item.is-active {
  color: #A30014;
  background-color: rgba(163, 0, 20, 0.15);
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--card>.el-tabs__header .el-tabs__item {
  border-bottom: 0;
  border-left: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #EEE;
}

.factorInputStyle >>> .el-input__inner {
  padding: 0px 0 0 5px;
}

.reconstruction >>> .el-select-dropdown__item {
  padding: 0 !important;
}

.reconstruction >>> .el-drawer__header {
  margin-bottom: 0;
}

.boxBackground {
  margin: 3px;
  background-color: #A30013;
  border-radius: 2px;
  width: 4px;
  height: 16px;
}

.boxSpan {
  font-weight: bold;
  font-size: 14px;
  margin-left: 10px;
}

.badTishi {
  height: 437px;
  line-height: 437px;
  text-align: center;
}

.italicFont {
  font-size: 14px;
  color: #a30014;
  font-style: italic;
}

.recordClass {
  background-color: #f0f9eb;
}

.cursorRed {
  color: #A4001B;
  cursor: pointer;
}

.cursor666 {
  color: #666;
  cursor: pointer;
}

.flex100 {
  width: 100%;
  flex: 1;
  display: flex;
}
.c_A30013 {
  color: #A30013;
}

.p_3 {
  padding: 3px !important;
}

.h_400 {
  height: 400px
}

.infinite-scroll {
  height: 200px;overflow: auto;
}
.infinite-scroll .scroll-item {
  width: 100%;margin: 0;
}
.infinite-scroll .scroll-item:hover {
  background-color: #f0f9eb;
}
.infinite-scroll .scroll-item--active {
  background-color:#fdf5e6;
}

.infinite-scroll .scroll-item--active:hover {
  background-color: #fdf5e6;
}
.infinite-scroll .scroll-item-complete:hover {
  color: #A30013;
  text-decoration:underline;
}
.infinite-scroll .scroll-item-yAxis{
    width: 16px;
    display: inline-block;
    text-align: center;
    border: 1px solid #409EFF;
    color: #409EFF;
    font-size: 12px;
    padding: 1px;
    border-radius: 5px;
}
.infinite-scroll .scroll-item-yAxis:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/allPage/reconstructionItem.vue